
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea66d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea66d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8fHQO", function(module, exports) {

$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "xml", () => xml);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "parseHTML", () => parseHTML);
$parcel$export(module.exports, "root", () => root);
$parcel$export(module.exports, "contains", () => contains);
$parcel$export(module.exports, "extract", () => extract);
$parcel$export(module.exports, "merge", () => merge);
parcelRequire("CeYTB");
var $86PNL = parcelRequire("86PNL");

var $7Oe9g = parcelRequire("7Oe9g");
/**
 * Helper function to render a DOM.
 *
 * @param that - Cheerio instance to render.
 * @param dom - The DOM to render. Defaults to `that`'s root.
 * @param options - Options for rendering.
 * @returns The rendered document.
 */ function render(that, dom, options) {
    if (!that) return '';
    return that(dom !== null && dom !== void 0 ? dom : that._root.children, null, undefined, options).toString();
}
/**
 * Checks if a passed object is an options object.
 *
 * @param dom - Object to check if it is an options object.
 * @param options - Options object.
 * @returns Whether the object is an options object.
 */ function isOptions(dom, options) {
    return !options && typeof dom === 'object' && dom != null && !('length' in dom) && !('type' in dom);
}
function html(dom, options) {
    /*
     * Be flexible about parameters, sometimes we call html(),
     * with options as only parameter
     * check dom argument for dom element specific properties
     * assume there is no 'length' or 'type' properties in the options object
     */ const toRender = isOptions(dom) ? (options = dom, undefined) : dom;
    /*
     * Sometimes `$.html()` is used without preloading html,
     * so fallback non-existing options to the default ones.
     */ const opts = {
        ...this === null || this === void 0 ? void 0 : this._options,
        ...(0, $7Oe9g.flattenOptions)(options)
    };
    return render(this, toRender, opts);
}
function xml(dom) {
    const options = {
        ...this._options,
        xmlMode: true
    };
    return render(this, dom, options);
}
function text(elements) {
    const elems = elements !== null && elements !== void 0 ? elements : this ? this.root() : [];
    let ret = '';
    for(let i = 0; i < elems.length; i++)ret += (0, $86PNL.textContent)(elems[i]);
    return ret;
}
function parseHTML(data, context, keepScripts = typeof context === 'boolean' ? context : false) {
    if (!data || typeof data !== 'string') return null;
    if (typeof context === 'boolean') keepScripts = context;
    const parsed = this.load(data, this._options, false);
    if (!keepScripts) parsed('script').remove();
    /*
     * The `children` array is used by Cheerio internally to group elements that
     * share the same parents. When nodes created through `parseHTML` are
     * inserted into previously-existing DOM structures, they will be removed
     * from the `children` array. The results of `parseHTML` should remain
     * constant across these operations, so a shallow copy should be returned.
     */ return [
        ...parsed.root()[0].children
    ];
}
function root() {
    return this(this._root);
}
function contains(container, contained) {
    // According to the jQuery API, an element does not "contain" itself
    if (contained === container) return false;
    /*
     * Step up the descendants, stopping when the root element is reached
     * (signaled by `.parent` returning a reference to the same object)
     */ let next = contained;
    while(next && next !== next.parent){
        next = next.parent;
        if (next === container) return true;
    }
    return false;
}
function extract(map) {
    return this.root().extract(map);
}
function merge(arr1, arr2) {
    if (!isArrayLike(arr1) || !isArrayLike(arr2)) return;
    let newLength = arr1.length;
    const len = +arr2.length;
    for(let i = 0; i < len; i++)arr1[newLength++] = arr2[i];
    arr1.length = newLength;
    return arr1;
}
/**
 * Checks if an object is array-like.
 *
 * @category Static
 * @param item - Item to check.
 * @returns Indicates if the item is array-like.
 */ function isArrayLike(item) {
    if (Array.isArray(item)) return true;
    if (typeof item !== 'object' || item === null || !('length' in item) || typeof item.length !== 'number' || item.length < 0) return false;
    for(let i = 0; i < item.length; i++){
        if (!(i in item)) return false;
    }
    return true;
}

});
parcelRegister("CeYTB", function(module, exports) {

$parcel$export(module.exports, "isTag", () => (parcelRequire("3zekA")).isTag);
$parcel$export(module.exports, "isCDATA", () => (parcelRequire("3zekA")).isCDATA);
$parcel$export(module.exports, "isText", () => (parcelRequire("3zekA")).isText);
$parcel$export(module.exports, "isComment", () => (parcelRequire("3zekA")).isComment);
$parcel$export(module.exports, "isDocument", () => (parcelRequire("3zekA")).isDocument);
$parcel$export(module.exports, "hasChildren", () => (parcelRequire("3zekA")).hasChildren);

var $86PNL = parcelRequire("86PNL");

var $cWyns = parcelRequire("cWyns");

var $2VlnM = parcelRequire("2VlnM");

var $bPZtU = parcelRequire("bPZtU");

var $dYR1U = parcelRequire("dYR1U");

var $7ZYrI = parcelRequire("7ZYrI");

var $2FnQg = parcelRequire("2FnQg");
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
$parcel$exportWildcard(module.exports, $86PNL);
$parcel$exportWildcard(module.exports, $cWyns);
$parcel$exportWildcard(module.exports, $2VlnM);
$parcel$exportWildcard(module.exports, $bPZtU);
$parcel$exportWildcard(module.exports, $dYR1U);
$parcel$exportWildcard(module.exports, $7ZYrI);
$parcel$exportWildcard(module.exports, $2FnQg);

});
parcelRegister("86PNL", function(module, exports) {

$parcel$export(module.exports, "getOuterHTML", () => $5e7710faf81de260$export$39484b727cc2f324);
$parcel$export(module.exports, "getInnerHTML", () => $5e7710faf81de260$export$7ed15b4d2218408);
$parcel$export(module.exports, "getText", () => $5e7710faf81de260$export$c72d34660a162238);
$parcel$export(module.exports, "textContent", () => $5e7710faf81de260$export$e0e0794250e9118f);
$parcel$export(module.exports, "innerText", () => $5e7710faf81de260$export$5864bc2a45f1eb81);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $k4wK2 = parcelRequire("k4wK2");

var $hREhV = parcelRequire("hREhV");
function $5e7710faf81de260$export$39484b727cc2f324(node, options) {
    return (0, $k4wK2.default)(node, options);
}
function $5e7710faf81de260$export$7ed15b4d2218408(node, options) {
    return (0, $3zekA.hasChildren)(node) ? node.children.map((node)=>$5e7710faf81de260$export$39484b727cc2f324(node, options)).join("") : "";
}
function $5e7710faf81de260$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($5e7710faf81de260$export$c72d34660a162238).join("");
    if ((0, $3zekA.isTag)(node)) return node.name === "br" ? "\n" : $5e7710faf81de260$export$c72d34660a162238(node.children);
    if ((0, $3zekA.isCDATA)(node)) return $5e7710faf81de260$export$c72d34660a162238(node.children);
    if ((0, $3zekA.isText)(node)) return node.data;
    return "";
}
function $5e7710faf81de260$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($5e7710faf81de260$export$e0e0794250e9118f).join("");
    if ((0, $3zekA.hasChildren)(node) && !(0, $3zekA.isComment)(node)) return $5e7710faf81de260$export$e0e0794250e9118f(node.children);
    if ((0, $3zekA.isText)(node)) return node.data;
    return "";
}
function $5e7710faf81de260$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($5e7710faf81de260$export$5864bc2a45f1eb81).join("");
    if ((0, $3zekA.hasChildren)(node) && (node.type === (0, $hREhV.ElementType).Tag || (0, $3zekA.isCDATA)(node))) return $5e7710faf81de260$export$5864bc2a45f1eb81(node.children);
    if ((0, $3zekA.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("7Z39T", function(module, exports) {
$parcel$export(module.exports, "CDATA", () => (parcelRequire("3zekA")).CDATA);
$parcel$export(module.exports, "cloneNode", () => (parcelRequire("3zekA")).cloneNode);
$parcel$export(module.exports, "Comment", () => (parcelRequire("3zekA")).Comment);
$parcel$export(module.exports, "Document", () => (parcelRequire("3zekA")).Document);
$parcel$export(module.exports, "Element", () => (parcelRequire("3zekA")).Element);
$parcel$export(module.exports, "hasChildren", () => (parcelRequire("3zekA")).hasChildren);
$parcel$export(module.exports, "isCDATA", () => (parcelRequire("3zekA")).isCDATA);
$parcel$export(module.exports, "isComment", () => (parcelRequire("3zekA")).isComment);
$parcel$export(module.exports, "isDirective", () => (parcelRequire("3zekA")).isDirective);
$parcel$export(module.exports, "isDocument", () => (parcelRequire("3zekA")).isDocument);
$parcel$export(module.exports, "isTag", () => (parcelRequire("3zekA")).isTag);
$parcel$export(module.exports, "isText", () => (parcelRequire("3zekA")).isText);
$parcel$export(module.exports, "ProcessingInstruction", () => (parcelRequire("3zekA")).ProcessingInstruction);
$parcel$export(module.exports, "Text", () => (parcelRequire("3zekA")).Text);

$parcel$export(module.exports, "DomHandler", () => $5d00ae21c5789654$export$ff8ccbac9225de62);

var $hREhV = parcelRequire("hREhV");

var $3zekA = parcelRequire("3zekA");
// Default options
const $5d00ae21c5789654$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $5d00ae21c5789654$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $3zekA.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $5d00ae21c5789654$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $5d00ae21c5789654$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $3zekA.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $hREhV.ElementType).Tag : undefined;
        const element = new (0, $3zekA.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $hREhV.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $3zekA.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $hREhV.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $3zekA.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $3zekA.Text)("");
        const node = new (0, $3zekA.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $3zekA.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $5d00ae21c5789654$export$2e2bcd8739ae039 = $5d00ae21c5789654$export$ff8ccbac9225de62;

});
parcelRegister("hREhV", function(module, exports) {

$parcel$export(module.exports, "ElementType", () => $d016a34ede83f3d0$export$b992dc138d950e31);
$parcel$export(module.exports, "isTag", () => $d016a34ede83f3d0$export$3bf645f08efe3292);
$parcel$export(module.exports, "Root", () => $d016a34ede83f3d0$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Text", () => $d016a34ede83f3d0$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Directive", () => $d016a34ede83f3d0$export$befdefbdce210f91);
$parcel$export(module.exports, "Comment", () => $d016a34ede83f3d0$export$4d299b491347818a);
$parcel$export(module.exports, "Script", () => $d016a34ede83f3d0$export$2f8b47a141e57afc);
$parcel$export(module.exports, "Style", () => $d016a34ede83f3d0$export$d9e45bc13d335801);
$parcel$export(module.exports, "Tag", () => $d016a34ede83f3d0$export$3288d34c523a1192);
$parcel$export(module.exports, "CDATA", () => $d016a34ede83f3d0$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Doctype", () => $d016a34ede83f3d0$export$31b44af36ff2c60f);
/** Types of elements found in htmlparser2's DOM */ var $d016a34ede83f3d0$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($d016a34ede83f3d0$export$b992dc138d950e31 || ($d016a34ede83f3d0$export$b992dc138d950e31 = {}));
function $d016a34ede83f3d0$export$3bf645f08efe3292(elem) {
    return elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Tag || elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Script || elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Style;
}
const $d016a34ede83f3d0$export$be92b6f5f03c0fe9 = $d016a34ede83f3d0$export$b992dc138d950e31.Root;
const $d016a34ede83f3d0$export$5f1af8db9871e1d6 = $d016a34ede83f3d0$export$b992dc138d950e31.Text;
const $d016a34ede83f3d0$export$befdefbdce210f91 = $d016a34ede83f3d0$export$b992dc138d950e31.Directive;
const $d016a34ede83f3d0$export$4d299b491347818a = $d016a34ede83f3d0$export$b992dc138d950e31.Comment;
const $d016a34ede83f3d0$export$2f8b47a141e57afc = $d016a34ede83f3d0$export$b992dc138d950e31.Script;
const $d016a34ede83f3d0$export$d9e45bc13d335801 = $d016a34ede83f3d0$export$b992dc138d950e31.Style;
const $d016a34ede83f3d0$export$3288d34c523a1192 = $d016a34ede83f3d0$export$b992dc138d950e31.Tag;
const $d016a34ede83f3d0$export$1f8b8f7e5c763232 = $d016a34ede83f3d0$export$b992dc138d950e31.CDATA;
const $d016a34ede83f3d0$export$31b44af36ff2c60f = $d016a34ede83f3d0$export$b992dc138d950e31.Doctype;

});

parcelRegister("3zekA", function(module, exports) {

$parcel$export(module.exports, "cloneNode", () => $298fc1d08428934f$export$ae8e35ea29ddac22);
$parcel$export(module.exports, "Text", () => $298fc1d08428934f$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $298fc1d08428934f$export$4d299b491347818a);
$parcel$export(module.exports, "ProcessingInstruction", () => $298fc1d08428934f$export$9269dce19ee35e96);
$parcel$export(module.exports, "CDATA", () => $298fc1d08428934f$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Document", () => $298fc1d08428934f$export$b34a105447964f9f);
$parcel$export(module.exports, "Element", () => $298fc1d08428934f$export$db77ccec0bb4ccac);
$parcel$export(module.exports, "isTag", () => $298fc1d08428934f$export$3bf645f08efe3292);
$parcel$export(module.exports, "isCDATA", () => $298fc1d08428934f$export$c2d65aed98d39b56);
$parcel$export(module.exports, "isText", () => $298fc1d08428934f$export$1879817ac5c922b7);
$parcel$export(module.exports, "isComment", () => $298fc1d08428934f$export$3ab01370f5e64ac8);
$parcel$export(module.exports, "isDirective", () => $298fc1d08428934f$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "isDocument", () => $298fc1d08428934f$export$62858bae88b53fd0);
$parcel$export(module.exports, "hasChildren", () => $298fc1d08428934f$export$bd5ff50f0e53d41c);

var $hREhV = parcelRequire("hREhV");
class $298fc1d08428934f$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $298fc1d08428934f$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $298fc1d08428934f$export$c3569d91cd44d357 extends $298fc1d08428934f$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $298fc1d08428934f$export$5f1af8db9871e1d6 extends $298fc1d08428934f$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $298fc1d08428934f$export$4d299b491347818a extends $298fc1d08428934f$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $298fc1d08428934f$export$9269dce19ee35e96 extends $298fc1d08428934f$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $hREhV.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $298fc1d08428934f$export$62be934f90997196 extends $298fc1d08428934f$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $298fc1d08428934f$export$1f8b8f7e5c763232 extends $298fc1d08428934f$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $298fc1d08428934f$export$b34a105447964f9f extends $298fc1d08428934f$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $298fc1d08428934f$export$db77ccec0bb4ccac extends $298fc1d08428934f$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $hREhV.ElementType).Script : name === "style" ? (0, $hREhV.ElementType).Style : (0, $hREhV.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $298fc1d08428934f$export$3bf645f08efe3292(node) {
    return (0, $hREhV.isTag)(node);
}
function $298fc1d08428934f$export$c2d65aed98d39b56(node) {
    return node.type === (0, $hREhV.ElementType).CDATA;
}
function $298fc1d08428934f$export$1879817ac5c922b7(node) {
    return node.type === (0, $hREhV.ElementType).Text;
}
function $298fc1d08428934f$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $hREhV.ElementType).Comment;
}
function $298fc1d08428934f$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $hREhV.ElementType).Directive;
}
function $298fc1d08428934f$export$62858bae88b53fd0(node) {
    return node.type === (0, $hREhV.ElementType).Root;
}
function $298fc1d08428934f$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $298fc1d08428934f$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($298fc1d08428934f$export$1879817ac5c922b7(node)) result = new $298fc1d08428934f$export$5f1af8db9871e1d6(node.data);
    else if ($298fc1d08428934f$export$3ab01370f5e64ac8(node)) result = new $298fc1d08428934f$export$4d299b491347818a(node.data);
    else if ($298fc1d08428934f$export$3bf645f08efe3292(node)) {
        const children = recursive ? $298fc1d08428934f$var$cloneChildren(node.children) : [];
        const clone = new $298fc1d08428934f$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($298fc1d08428934f$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $298fc1d08428934f$var$cloneChildren(node.children) : [];
        const clone = new $298fc1d08428934f$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($298fc1d08428934f$export$62858bae88b53fd0(node)) {
        const children = recursive ? $298fc1d08428934f$var$cloneChildren(node.children) : [];
        const clone = new $298fc1d08428934f$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($298fc1d08428934f$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $298fc1d08428934f$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $298fc1d08428934f$var$cloneChildren(childs) {
    const children = childs.map((child)=>$298fc1d08428934f$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("k4wK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cd942395a2f848$export$2e2bcd8739ae039);
/*
 * Module dependencies
 */ 
var $hREhV = parcelRequire("hREhV");
parcelRequire("2dcka");
var $jQio7 = parcelRequire("jQio7");

var $h1j8A = parcelRequire("h1j8A");
const $e9cd942395a2f848$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $e9cd942395a2f848$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $e9cd942395a2f848$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $e9cd942395a2f848$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $jQio7.encodeXML) : (0, $jQio7.escapeAttribute);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $h1j8A.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $e9cd942395a2f848$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $e9cd942395a2f848$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $e9cd942395a2f848$var$renderNode(nodes[i], options);
    return output;
}
var $e9cd942395a2f848$export$2e2bcd8739ae039 = $e9cd942395a2f848$export$b3890eb0ae9dca99;
function $e9cd942395a2f848$var$renderNode(node, options) {
    switch(node.type){
        case $hREhV.Root:
            return $e9cd942395a2f848$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $hREhV.Doctype:
        case $hREhV.Directive:
            return $e9cd942395a2f848$var$renderDirective(node);
        case $hREhV.Comment:
            return $e9cd942395a2f848$var$renderComment(node);
        case $hREhV.CDATA:
            return $e9cd942395a2f848$var$renderCdata(node);
        case $hREhV.Script:
        case $hREhV.Style:
        case $hREhV.Tag:
            return $e9cd942395a2f848$var$renderTag(node, options);
        case $hREhV.Text:
            return $e9cd942395a2f848$var$renderText(node, options);
    }
}
const $e9cd942395a2f848$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $e9cd942395a2f848$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $e9cd942395a2f848$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $h1j8A.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $e9cd942395a2f848$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $e9cd942395a2f848$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $e9cd942395a2f848$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $e9cd942395a2f848$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $e9cd942395a2f848$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$e9cd942395a2f848$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $e9cd942395a2f848$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $e9cd942395a2f848$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $e9cd942395a2f848$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $jQio7.encodeXML)(data) : (0, $jQio7.escapeText)(data);
    return data;
}
function $e9cd942395a2f848$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $e9cd942395a2f848$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}

});
parcelRegister("2dcka", function(module, exports) {

$parcel$export(module.exports, "encodeXML", () => (parcelRequire("jQio7")).encodeXML);
$parcel$export(module.exports, "escapeAttribute", () => (parcelRequire("jQio7")).escapeAttribute);
$parcel$export(module.exports, "escapeText", () => (parcelRequire("jQio7")).escapeText);

var $2Tqwy = parcelRequire("2Tqwy");

var $5Ic9T = parcelRequire("5Ic9T");

var $jQio7 = parcelRequire("jQio7");
var $19c65afdc12482fd$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($19c65afdc12482fd$export$b8c86583d9718b50 || ($19c65afdc12482fd$export$b8c86583d9718b50 = {}));
var $19c65afdc12482fd$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($19c65afdc12482fd$export$1851b20d614eb756 || ($19c65afdc12482fd$export$1851b20d614eb756 = {}));
function $19c65afdc12482fd$export$2f872c0f2117be69(data, options = $19c65afdc12482fd$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $19c65afdc12482fd$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $2Tqwy.decodeHTML)(data, mode);
    }
    return (0, $2Tqwy.decodeXML)(data);
}
function $19c65afdc12482fd$export$c94669f4c7d36be4(data, options = $19c65afdc12482fd$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $2Tqwy.DecodingMode).Strict;
    return $19c65afdc12482fd$export$2f872c0f2117be69(data, opts);
}
function $19c65afdc12482fd$export$c564cdbbe6da493(data, options = $19c65afdc12482fd$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.UTF8) return (0, $jQio7.escapeUTF8)(data);
    if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.Attribute) return (0, $jQio7.escapeAttribute)(data);
    if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.Text) return (0, $jQio7.escapeText)(data);
    if (opts.level === $19c65afdc12482fd$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.ASCII) return (0, $5Ic9T.encodeNonAsciiHTML)(data);
        return (0, $5Ic9T.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $jQio7.encodeXML)(data);
}

});
parcelRegister("2Tqwy", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $21b54aeefac41b63$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $21b54aeefac41b63$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $21b54aeefac41b63$export$88e3b9643a8bd06e);

var $cOXMu = parcelRequire("cOXMu");

var $apOGC = parcelRequire("apOGC");

var $1peew = parcelRequire("1peew");
var $21b54aeefac41b63$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($21b54aeefac41b63$var$CharCodes || ($21b54aeefac41b63$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $21b54aeefac41b63$var$TO_LOWER_BIT = 32;
var $21b54aeefac41b63$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($21b54aeefac41b63$export$6a4325c613e0faec || ($21b54aeefac41b63$export$6a4325c613e0faec = {}));
function $21b54aeefac41b63$var$isNumber(code) {
    return code >= $21b54aeefac41b63$var$CharCodes.ZERO && code <= $21b54aeefac41b63$var$CharCodes.NINE;
}
function $21b54aeefac41b63$var$isHexadecimalCharacter(code) {
    return code >= $21b54aeefac41b63$var$CharCodes.UPPER_A && code <= $21b54aeefac41b63$var$CharCodes.UPPER_F || code >= $21b54aeefac41b63$var$CharCodes.LOWER_A && code <= $21b54aeefac41b63$var$CharCodes.LOWER_F;
}
function $21b54aeefac41b63$var$isAsciiAlphaNumeric(code) {
    return code >= $21b54aeefac41b63$var$CharCodes.UPPER_A && code <= $21b54aeefac41b63$var$CharCodes.UPPER_Z || code >= $21b54aeefac41b63$var$CharCodes.LOWER_A && code <= $21b54aeefac41b63$var$CharCodes.LOWER_Z || $21b54aeefac41b63$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $21b54aeefac41b63$var$isEntityInAttributeInvalidEnd(code) {
    return code === $21b54aeefac41b63$var$CharCodes.EQUALS || $21b54aeefac41b63$var$isAsciiAlphaNumeric(code);
}
var $21b54aeefac41b63$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($21b54aeefac41b63$var$EntityDecoderState || ($21b54aeefac41b63$var$EntityDecoderState = {}));
var $21b54aeefac41b63$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($21b54aeefac41b63$export$8c8f129ce60f53c || ($21b54aeefac41b63$export$8c8f129ce60f53c = {}));
class $21b54aeefac41b63$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $21b54aeefac41b63$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $21b54aeefac41b63$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $21b54aeefac41b63$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $21b54aeefac41b63$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $21b54aeefac41b63$var$CharCodes.NUM) {
                    this.state = $21b54aeefac41b63$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $21b54aeefac41b63$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $21b54aeefac41b63$var$TO_LOWER_BIT) === $21b54aeefac41b63$var$CharCodes.LOWER_X) {
            this.state = $21b54aeefac41b63$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $21b54aeefac41b63$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($21b54aeefac41b63$var$isNumber(char) || $21b54aeefac41b63$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($21b54aeefac41b63$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $21b54aeefac41b63$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $21b54aeefac41b63$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $1peew.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $21b54aeefac41b63$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $21b54aeefac41b63$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $21b54aeefac41b63$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $21b54aeefac41b63$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $21b54aeefac41b63$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $21b54aeefac41b63$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $21b54aeefac41b63$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $21b54aeefac41b63$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $21b54aeefac41b63$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $21b54aeefac41b63$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $21b54aeefac41b63$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $21b54aeefac41b63$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $1peew.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $21b54aeefac41b63$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $21b54aeefac41b63$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $21b54aeefac41b63$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $21b54aeefac41b63$var$htmlDecoder = $21b54aeefac41b63$var$getDecoder((0, $cOXMu.default));
const $21b54aeefac41b63$var$xmlDecoder = $21b54aeefac41b63$var$getDecoder((0, $apOGC.default));
function $21b54aeefac41b63$export$f045cb747ce77a19(str, mode = $21b54aeefac41b63$export$8c8f129ce60f53c.Legacy) {
    return $21b54aeefac41b63$var$htmlDecoder(str, mode);
}
function $21b54aeefac41b63$export$49f5e8089adb006a(str) {
    return $21b54aeefac41b63$var$htmlDecoder(str, $21b54aeefac41b63$export$8c8f129ce60f53c.Attribute);
}
function $21b54aeefac41b63$export$da52f4371b3f37de(str) {
    return $21b54aeefac41b63$var$htmlDecoder(str, $21b54aeefac41b63$export$8c8f129ce60f53c.Strict);
}
function $21b54aeefac41b63$export$88e3b9643a8bd06e(str) {
    return $21b54aeefac41b63$var$xmlDecoder(str, $21b54aeefac41b63$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("cOXMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $955886d6453f1f75$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $955886d6453f1f75$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("apOGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $79538e6bbdd097a4$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $79538e6bbdd097a4$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("1peew", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $10632aaf914d6bd1$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $10632aaf914d6bd1$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $10632aaf914d6bd1$var$_a;
const $10632aaf914d6bd1$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $10632aaf914d6bd1$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($10632aaf914d6bd1$var$_a = String.fromCodePoint) !== null && $10632aaf914d6bd1$var$_a !== void 0 ? $10632aaf914d6bd1$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $10632aaf914d6bd1$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $10632aaf914d6bd1$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $10632aaf914d6bd1$export$2e2bcd8739ae039(codePoint) {
    return $10632aaf914d6bd1$export$73bfc63873071f74($10632aaf914d6bd1$export$b978ab756102108a(codePoint));
}

});


parcelRegister("5Ic9T", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $428a7e43bc21742b$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $428a7e43bc21742b$export$e6e86c76506f1190);

var $9Htef = parcelRequire("9Htef");

var $jQio7 = parcelRequire("jQio7");
const $428a7e43bc21742b$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $428a7e43bc21742b$export$f9d6449b9af28dc1(data) {
    return $428a7e43bc21742b$var$encodeHTMLTrieRe($428a7e43bc21742b$var$htmlReplacer, data);
}
function $428a7e43bc21742b$export$e6e86c76506f1190(data) {
    return $428a7e43bc21742b$var$encodeHTMLTrieRe((0, $jQio7.xmlReplacer), data);
}
function $428a7e43bc21742b$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $9Htef.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $jQio7.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("9Htef", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fecd720f63c751$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $70fecd720f63c751$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$70fecd720f63c751$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("jQio7", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $e72123220ae6606b$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $e72123220ae6606b$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $e72123220ae6606b$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $e72123220ae6606b$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $e72123220ae6606b$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $e72123220ae6606b$export$96e6fc3a139b2555);
const $e72123220ae6606b$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $e72123220ae6606b$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $e72123220ae6606b$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $e72123220ae6606b$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $e72123220ae6606b$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $e72123220ae6606b$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$e72123220ae6606b$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $e72123220ae6606b$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $e72123220ae6606b$export$4e7f196112fea3c5 = $e72123220ae6606b$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $e72123220ae6606b$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $e72123220ae6606b$export$9e081872deefdcb0 = $e72123220ae6606b$var$getEscaper(/[&<>'"]/g, $e72123220ae6606b$var$xmlCodeMap);
const $e72123220ae6606b$export$30330f3d5eb70e11 = $e72123220ae6606b$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $e72123220ae6606b$export$96e6fc3a139b2555 = $e72123220ae6606b$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("h1j8A", function(module, exports) {

$parcel$export(module.exports, "elementNames", () => $c6415ff239ea0ed7$export$82b917442d249e05);
$parcel$export(module.exports, "attributeNames", () => $c6415ff239ea0ed7$export$b4cfbfd90280b005);
const $c6415ff239ea0ed7$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $c6415ff239ea0ed7$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));

});



parcelRegister("cWyns", function(module, exports) {

$parcel$export(module.exports, "getChildren", () => $96c591732bbe9fd9$export$f8cf48ee793b41be);
$parcel$export(module.exports, "getParent", () => $96c591732bbe9fd9$export$58081aedf094d85b);
$parcel$export(module.exports, "getSiblings", () => $96c591732bbe9fd9$export$f312c3733b79ac0d);
$parcel$export(module.exports, "getAttributeValue", () => $96c591732bbe9fd9$export$1e335898aa11b111);
$parcel$export(module.exports, "hasAttrib", () => $96c591732bbe9fd9$export$aa37f90c17957f38);
$parcel$export(module.exports, "getName", () => $96c591732bbe9fd9$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "nextElementSibling", () => $96c591732bbe9fd9$export$9be3779649ef9cc7);
$parcel$export(module.exports, "prevElementSibling", () => $96c591732bbe9fd9$export$c8bafb6e59c0b8e);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $96c591732bbe9fd9$export$f8cf48ee793b41be(elem) {
    return (0, $3zekA.hasChildren)(elem) ? elem.children : [];
}
function $96c591732bbe9fd9$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $96c591732bbe9fd9$export$f312c3733b79ac0d(elem) {
    const parent = $96c591732bbe9fd9$export$58081aedf094d85b(elem);
    if (parent != null) return $96c591732bbe9fd9$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $96c591732bbe9fd9$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $96c591732bbe9fd9$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $96c591732bbe9fd9$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $96c591732bbe9fd9$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $3zekA.isTag)(next))({ next: next } = next);
    return next;
}
function $96c591732bbe9fd9$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $3zekA.isTag)(prev))({ prev: prev } = prev);
    return prev;
}

});

parcelRegister("2VlnM", function(module, exports) {

$parcel$export(module.exports, "removeElement", () => $22117dbf00ca9159$export$f883456a56996078);
$parcel$export(module.exports, "replaceElement", () => $22117dbf00ca9159$export$2dfe578f95754f6a);
$parcel$export(module.exports, "appendChild", () => $22117dbf00ca9159$export$1b8e57c9ea42f1d2);
$parcel$export(module.exports, "append", () => $22117dbf00ca9159$export$10d8903dec122b9d);
$parcel$export(module.exports, "prependChild", () => $22117dbf00ca9159$export$47b51e6d100007bc);
$parcel$export(module.exports, "prepend", () => $22117dbf00ca9159$export$68159836694e22c1);
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $22117dbf00ca9159$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $22117dbf00ca9159$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $22117dbf00ca9159$export$1b8e57c9ea42f1d2(parent, child) {
    $22117dbf00ca9159$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $22117dbf00ca9159$export$10d8903dec122b9d(elem, next) {
    $22117dbf00ca9159$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $22117dbf00ca9159$export$47b51e6d100007bc(parent, child) {
    $22117dbf00ca9159$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $22117dbf00ca9159$export$68159836694e22c1(elem, prev) {
    $22117dbf00ca9159$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("bPZtU", function(module, exports) {

$parcel$export(module.exports, "filter", () => $89e4260ec6b7089c$export$3dea766d36a8935f);
$parcel$export(module.exports, "find", () => $89e4260ec6b7089c$export$71aa6c912b956294);
$parcel$export(module.exports, "findOneChild", () => $89e4260ec6b7089c$export$ac03a862904ce329);
$parcel$export(module.exports, "findOne", () => $89e4260ec6b7089c$export$a541876d5d7daf90);
$parcel$export(module.exports, "existsOne", () => $89e4260ec6b7089c$export$9d99dce58ac4a31b);
$parcel$export(module.exports, "findAll", () => $89e4260ec6b7089c$export$18200ea6c8035394);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $89e4260ec6b7089c$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $89e4260ec6b7089c$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $89e4260ec6b7089c$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $3zekA.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $89e4260ec6b7089c$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $89e4260ec6b7089c$export$a541876d5d7daf90(test, nodes, recurse = true) {
    const searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(let i = 0; i < searchedNodes.length; i++){
        const node = searchedNodes[i];
        if ((0, $3zekA.isTag)(node) && test(node)) return node;
        if (recurse && (0, $3zekA.hasChildren)(node) && node.children.length > 0) {
            const found = $89e4260ec6b7089c$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $89e4260ec6b7089c$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some((node)=>(0, $3zekA.isTag)(node) && test(node) || (0, $3zekA.hasChildren)(node) && $89e4260ec6b7089c$export$9d99dce58ac4a31b(test, node.children));
}
function $89e4260ec6b7089c$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if ((0, $3zekA.isTag)(elem) && test(elem)) result.push(elem);
        if ((0, $3zekA.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("dYR1U", function(module, exports) {

$parcel$export(module.exports, "testElement", () => $a2da03981bf43417$export$7b31db6b5a0b2f32);
$parcel$export(module.exports, "getElements", () => $a2da03981bf43417$export$73eac51a39d6b0eb);
$parcel$export(module.exports, "getElementById", () => $a2da03981bf43417$export$83595b84fc78b9b4);
$parcel$export(module.exports, "getElementsByTagName", () => $a2da03981bf43417$export$af941c3c7c3b40f5);
$parcel$export(module.exports, "getElementsByClassName", () => $a2da03981bf43417$export$764e2797d3aa1cff);
$parcel$export(module.exports, "getElementsByTagType", () => $a2da03981bf43417$export$f5d981e30be5545b);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $bPZtU = parcelRequire("bPZtU");
/**
 * A map of functions to check nodes against.
 */ const $a2da03981bf43417$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $3zekA.isTag)(elem) && name(elem.name);
        else if (name === "*") return 0, $3zekA.isTag;
        return (elem)=>(0, $3zekA.isTag)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $3zekA.isText)(elem) && data(elem.data);
        return (elem)=>(0, $3zekA.isText)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $a2da03981bf43417$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $3zekA.isTag)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $3zekA.isTag)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $a2da03981bf43417$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $a2da03981bf43417$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($a2da03981bf43417$var$Checks, key) ? $a2da03981bf43417$var$Checks[key](value) : $a2da03981bf43417$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($a2da03981bf43417$var$combineFuncs);
}
function $a2da03981bf43417$export$7b31db6b5a0b2f32(options, node) {
    const test = $a2da03981bf43417$var$compileTest(options);
    return test ? test(node) : true;
}
function $a2da03981bf43417$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $a2da03981bf43417$var$compileTest(options);
    return test ? (0, $bPZtU.filter)(test, nodes, recurse, limit) : [];
}
function $a2da03981bf43417$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $bPZtU.findOne)($a2da03981bf43417$var$getAttribCheck("id", id), nodes, recurse);
}
function $a2da03981bf43417$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $bPZtU.filter)($a2da03981bf43417$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $a2da03981bf43417$export$764e2797d3aa1cff(className, nodes, recurse = true, limit = Infinity) {
    return (0, $bPZtU.filter)($a2da03981bf43417$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $a2da03981bf43417$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $bPZtU.filter)($a2da03981bf43417$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("7ZYrI", function(module, exports) {

$parcel$export(module.exports, "removeSubsets", () => $5d2d1e3b58306e70$export$171dc294232ebeef);
$parcel$export(module.exports, "DocumentPosition", () => $5d2d1e3b58306e70$export$406a59d989e8005a);
$parcel$export(module.exports, "compareDocumentPosition", () => $5d2d1e3b58306e70$export$17303b8fea718ecc);
$parcel$export(module.exports, "uniqueSort", () => $5d2d1e3b58306e70$export$1c267319665a7e7e);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $5d2d1e3b58306e70$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $5d2d1e3b58306e70$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($5d2d1e3b58306e70$export$406a59d989e8005a || ($5d2d1e3b58306e70$export$406a59d989e8005a = {}));
function $5d2d1e3b58306e70$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $3zekA.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $3zekA.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $5d2d1e3b58306e70$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $5d2d1e3b58306e70$export$406a59d989e8005a.FOLLOWING | $5d2d1e3b58306e70$export$406a59d989e8005a.CONTAINED_BY;
        return $5d2d1e3b58306e70$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $5d2d1e3b58306e70$export$406a59d989e8005a.PRECEDING | $5d2d1e3b58306e70$export$406a59d989e8005a.CONTAINS;
    return $5d2d1e3b58306e70$export$406a59d989e8005a.PRECEDING;
}
function $5d2d1e3b58306e70$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $5d2d1e3b58306e70$export$17303b8fea718ecc(a, b);
        if (relative & $5d2d1e3b58306e70$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $5d2d1e3b58306e70$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("2FnQg", function(module, exports) {

$parcel$export(module.exports, "getFeed", () => $1f11e7a1ecde59b5$export$ad32138c9e09ad4);

var $86PNL = parcelRequire("86PNL");

var $dYR1U = parcelRequire("dYR1U");
function $1f11e7a1ecde59b5$export$ad32138c9e09ad4(doc) {
    const feedRoot = $1f11e7a1ecde59b5$var$getOneElement($1f11e7a1ecde59b5$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $1f11e7a1ecde59b5$var$getAtomFeed(feedRoot) : $1f11e7a1ecde59b5$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $1f11e7a1ecde59b5$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $dYR1U.getElementsByTagName)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $1f11e7a1ecde59b5$var$getMediaElements(children)
            };
            $1f11e7a1ecde59b5$var$addConditionally(entry, "id", "id", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $1f11e7a1ecde59b5$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $1f11e7a1ecde59b5$var$fetch("summary", children) || $1f11e7a1ecde59b5$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $1f11e7a1ecde59b5$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $1f11e7a1ecde59b5$var$addConditionally(feed, "id", "id", childs);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $1f11e7a1ecde59b5$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $1f11e7a1ecde59b5$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $1f11e7a1ecde59b5$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $1f11e7a1ecde59b5$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $1f11e7a1ecde59b5$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $dYR1U.getElementsByTagName)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $1f11e7a1ecde59b5$var$getMediaElements(children)
            };
            $1f11e7a1ecde59b5$var$addConditionally(entry, "id", "guid", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "title", "title", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "link", "link", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "description", "description", children);
            const pubDate = $1f11e7a1ecde59b5$var$fetch("pubDate", children) || $1f11e7a1ecde59b5$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $1f11e7a1ecde59b5$var$addConditionally(feed, "title", "title", childs);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "link", "link", childs);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "description", "description", childs);
    const updated = $1f11e7a1ecde59b5$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $1f11e7a1ecde59b5$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $1f11e7a1ecde59b5$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $1f11e7a1ecde59b5$var$getMediaElements(where) {
    return (0, $dYR1U.getElementsByTagName)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $1f11e7a1ecde59b5$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $1f11e7a1ecde59b5$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $1f11e7a1ecde59b5$var$getOneElement(tagName, node) {
    return (0, $dYR1U.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $1f11e7a1ecde59b5$var$fetch(tagName, where, recurse = false) {
    return (0, $86PNL.textContent)((0, $dYR1U.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $1f11e7a1ecde59b5$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $1f11e7a1ecde59b5$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $1f11e7a1ecde59b5$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});


parcelRegister("7Oe9g", function(module, exports) {

$parcel$export(module.exports, "flattenOptions", () => $5af82d817f466a2e$export$7baa7c13b358b002);
const $5af82d817f466a2e$var$defaultOpts = {
    _useHtmlParser2: false
};
function $5af82d817f466a2e$export$7baa7c13b358b002(options, baseOptions) {
    if (!options) return baseOptions !== null && baseOptions !== void 0 ? baseOptions : $5af82d817f466a2e$var$defaultOpts;
    const opts = {
        _useHtmlParser2: !!options.xmlMode,
        ...baseOptions,
        ...options
    };
    if (options.xml) {
        opts._useHtmlParser2 = true;
        opts.xmlMode = true;
        if (options.xml !== true) Object.assign(opts, options.xml);
    } else if (options.xmlMode) opts._useHtmlParser2 = true;
    return opts;
}

});


parcelRegister("dUdzM", function(module, exports) {

$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "prop", () => prop);
$parcel$export(module.exports, "data", () => data);
$parcel$export(module.exports, "val", () => val);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
/**
 * Methods for getting and modifying attributes.
 *
 * @module cheerio/attributes
 */ 
var $8fHQO = parcelRequire("8fHQO");

var $2oqzI = parcelRequire("2oqzI");
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
parcelRequire("CeYTB");
var $86PNL = parcelRequire("86PNL");
parcelRequire("hq9P0");
var $hREhV = parcelRequire("hREhV");
var _a;
const hasOwn = // @ts-expect-error `hasOwn` is a standard object method
(_a = Object.hasOwn) !== null && _a !== void 0 ? _a : (object, prop)=>Object.prototype.hasOwnProperty.call(object, prop);
const rspace = /\s+/;
const dataAttrPrefix = 'data-';
// Attributes that are booleans
const rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i;
// Matches strings that look like JSON objects or arrays
const rbrace = /^{[^]*}$|^\[[^]*]$/;
function getAttr(elem, name, xmlMode) {
    var _a;
    if (!elem || !(0, $3zekA.isTag)(elem)) return undefined;
    (_a = elem.attribs) !== null && _a !== void 0 ? _a : elem.attribs = {};
    // Return the entire attribs object if no attribute specified
    if (!name) return elem.attribs;
    if (hasOwn(elem.attribs, name)) // Get the (decoded) attribute
    return !xmlMode && rboolean.test(name) ? name : elem.attribs[name];
    // Mimic the DOM and return text content as value for `option's`
    if (elem.name === 'option' && name === 'value') return (0, $8fHQO.text)(elem.children);
    // Mimic DOM with default value for radios/checkboxes
    if (elem.name === 'input' && (elem.attribs['type'] === 'radio' || elem.attribs['type'] === 'checkbox') && name === 'value') return 'on';
    return undefined;
}
/**
 * Sets the value of an attribute. The attribute will be deleted if the value is
 * `null`.
 *
 * @private
 * @param el - The element to set the attribute on.
 * @param name - The attribute's name.
 * @param value - The attribute's value.
 */ function setAttr(el, name, value) {
    if (value === null) removeAttribute(el, name);
    else el.attribs[name] = `${value}`;
}
function attr(name, value) {
    // Set the value (with attr map support)
    if (typeof name === 'object' || value !== undefined) {
        if (typeof value === 'function') {
            if (typeof name !== 'string') throw new Error('Bad combination of arguments.');
            return (0, $2oqzI.domEach)(this, (el, i)=>{
                if ((0, $3zekA.isTag)(el)) setAttr(el, name, value.call(el, i, el.attribs[name]));
            });
        }
        return (0, $2oqzI.domEach)(this, (el)=>{
            if (!(0, $3zekA.isTag)(el)) return;
            if (typeof name === 'object') for (const objName of Object.keys(name)){
                const objValue = name[objName];
                setAttr(el, objName, objValue);
            }
            else setAttr(el, name, value);
        });
    }
    return arguments.length > 1 ? this : getAttr(this[0], name, this.options.xmlMode);
}
/**
 * Gets a node's prop.
 *
 * @private
 * @category Attributes
 * @param el - Element to get the prop of.
 * @param name - Name of the prop.
 * @param xmlMode - Disable handling of special HTML attributes.
 * @returns The prop's value.
 */ function getProp(el, name, xmlMode) {
    return name in el ? el[name] : !xmlMode && rboolean.test(name) ? getAttr(el, name, false) !== undefined : getAttr(el, name, xmlMode);
}
/**
 * Sets the value of a prop.
 *
 * @private
 * @param el - The element to set the prop on.
 * @param name - The prop's name.
 * @param value - The prop's value.
 * @param xmlMode - Disable handling of special HTML attributes.
 */ function setProp(el, name, value, xmlMode) {
    if (name in el) // @ts-expect-error Overriding value
    el[name] = value;
    else setAttr(el, name, !xmlMode && rboolean.test(name) ? value ? '' : null : `${value}`);
}
function prop(name, value) {
    var _a;
    if (typeof name === 'string' && value === undefined) {
        const el = this[0];
        if (!el) return undefined;
        switch(name){
            case 'style':
                {
                    const property = this.css();
                    const keys = Object.keys(property);
                    for(let i = 0; i < keys.length; i++)property[i] = keys[i];
                    property.length = keys.length;
                    return property;
                }
            case 'tagName':
            case 'nodeName':
                if (!(0, $3zekA.isTag)(el)) return undefined;
                return el.name.toUpperCase();
            case 'href':
            case 'src':
                {
                    if (!(0, $3zekA.isTag)(el)) return undefined;
                    const prop = (_a = el.attribs) === null || _a === void 0 ? void 0 : _a[name];
                    if (typeof URL !== 'undefined' && (name === 'href' && (el.tagName === 'a' || el.tagName === 'link') || name === 'src' && (el.tagName === 'img' || el.tagName === 'iframe' || el.tagName === 'audio' || el.tagName === 'video' || el.tagName === 'source')) && prop !== undefined && this.options.baseURI) return new URL(prop, this.options.baseURI).href;
                    return prop;
                }
            case 'innerText':
                return (0, $86PNL.innerText)(el);
            case 'textContent':
                return (0, $86PNL.textContent)(el);
            case 'outerHTML':
                if (el.type === (0, $hREhV).Root) return this.html();
                return this.clone().wrap('<container />').parent().html();
            case 'innerHTML':
                return this.html();
            default:
                if (!(0, $3zekA.isTag)(el)) return undefined;
                return getProp(el, name, this.options.xmlMode);
        }
    }
    if (typeof name === 'object' || value !== undefined) {
        if (typeof value === 'function') {
            if (typeof name === 'object') throw new TypeError('Bad combination of arguments.');
            return (0, $2oqzI.domEach)(this, (el, i)=>{
                if ((0, $3zekA.isTag)(el)) setProp(el, name, value.call(el, i, getProp(el, name, this.options.xmlMode)), this.options.xmlMode);
            });
        }
        return (0, $2oqzI.domEach)(this, (el)=>{
            if (!(0, $3zekA.isTag)(el)) return;
            if (typeof name === 'object') for (const key of Object.keys(name)){
                const val = name[key];
                setProp(el, key, val, this.options.xmlMode);
            }
            else setProp(el, name, value, this.options.xmlMode);
        });
    }
    return undefined;
}
/**
 * Sets the value of a data attribute.
 *
 * @private
 * @param elem - The element to set the data attribute on.
 * @param name - The data attribute's name.
 * @param value - The data attribute's value.
 */ function setData(elem, name, value) {
    var _a;
    (_a = elem.data) !== null && _a !== void 0 ? _a : elem.data = {};
    if (typeof name === 'object') Object.assign(elem.data, name);
    else if (typeof name === 'string' && value !== undefined) elem.data[name] = value;
}
/**
 * Read _all_ HTML5 `data-*` attributes from the equivalent HTML5 `data-*`
 * attribute, and cache the value in the node's internal data store.
 *
 * @private
 * @category Attributes
 * @param el - Element to get the data attribute of.
 * @returns A map with all of the data attributes.
 */ function readAllData(el) {
    for (const domName of Object.keys(el.attribs)){
        if (!domName.startsWith(dataAttrPrefix)) continue;
        const jsName = (0, $2oqzI.camelCase)(domName.slice(dataAttrPrefix.length));
        if (!hasOwn(el.data, jsName)) el.data[jsName] = parseDataValue(el.attribs[domName]);
    }
    return el.data;
}
/**
 * Read the specified attribute from the equivalent HTML5 `data-*` attribute,
 * and (if present) cache the value in the node's internal data store.
 *
 * @private
 * @category Attributes
 * @param el - Element to get the data attribute of.
 * @param name - Name of the data attribute.
 * @returns The data attribute's value.
 */ function readData(el, name) {
    const domName = dataAttrPrefix + (0, $2oqzI.cssCase)(name);
    const data = el.data;
    if (hasOwn(data, name)) return data[name];
    if (hasOwn(el.attribs, domName)) return data[name] = parseDataValue(el.attribs[domName]);
    return undefined;
}
/**
 * Coerce string data-* attributes to their corresponding JavaScript primitives.
 *
 * @private
 * @category Attributes
 * @param value - The value to parse.
 * @returns The parsed value.
 */ function parseDataValue(value) {
    if (value === 'null') return null;
    if (value === 'true') return true;
    if (value === 'false') return false;
    const num = Number(value);
    if (value === String(num)) return num;
    if (rbrace.test(value)) try {
        return JSON.parse(value);
    } catch  {
    /* Ignore */ }
    return value;
}
function data(name, value) {
    var _a;
    const elem = this[0];
    if (!elem || !(0, $3zekA.isTag)(elem)) return;
    const dataEl = elem;
    (_a = dataEl.data) !== null && _a !== void 0 ? _a : dataEl.data = {};
    // Return the entire data object if no data specified
    if (name == null) return readAllData(dataEl);
    // Set the value (with attr map support)
    if (typeof name === 'object' || value !== undefined) {
        (0, $2oqzI.domEach)(this, (el)=>{
            if ((0, $3zekA.isTag)(el)) {
                if (typeof name === 'object') setData(el, name);
                else setData(el, name, value);
            }
        });
        return this;
    }
    return readData(dataEl, name);
}
function val(value) {
    const querying = arguments.length === 0;
    const element = this[0];
    if (!element || !(0, $3zekA.isTag)(element)) return querying ? undefined : this;
    switch(element.name){
        case 'textarea':
            return this.text(value);
        case 'select':
            {
                const option = this.find('option:selected');
                if (!querying) {
                    if (this.attr('multiple') == null && typeof value === 'object') return this;
                    this.find('option').removeAttr('selected');
                    const values = typeof value === 'object' ? value : [
                        value
                    ];
                    for (const val of values)this.find(`option[value="${val}"]`).attr('selected', '');
                    return this;
                }
                return this.attr('multiple') ? option.toArray().map((el)=>(0, $8fHQO.text)(el.children)) : option.attr('value');
            }
        case 'input':
        case 'option':
            return querying ? this.attr('value') : this.attr('value', value);
    }
    return undefined;
}
/**
 * Remove an attribute.
 *
 * @private
 * @param elem - Node to remove attribute from.
 * @param name - Name of the attribute to remove.
 */ function removeAttribute(elem, name) {
    if (!elem.attribs || !hasOwn(elem.attribs, name)) return;
    delete elem.attribs[name];
}
/**
 * Splits a space-separated list of names to individual names.
 *
 * @category Attributes
 * @param names - Names to split.
 * @returns - Split names.
 */ function splitNames(names) {
    return names ? names.trim().split(rspace) : [];
}
function removeAttr(name) {
    const attrNames = splitNames(name);
    for (const attrName of attrNames)(0, $2oqzI.domEach)(this, (elem)=>{
        if ((0, $3zekA.isTag)(elem)) removeAttribute(elem, attrName);
    });
    return this;
}
function hasClass(className) {
    return this.toArray().some((elem)=>{
        const clazz = (0, $3zekA.isTag)(elem) && elem.attribs['class'];
        let idx = -1;
        if (clazz && className.length > 0) while((idx = clazz.indexOf(className, idx + 1)) > -1){
            const end = idx + className.length;
            if ((idx === 0 || rspace.test(clazz[idx - 1])) && (end === clazz.length || rspace.test(clazz[end]))) return true;
        }
        return false;
    });
}
function addClass(value) {
    // Support functions
    if (typeof value === 'function') return (0, $2oqzI.domEach)(this, (el, i)=>{
        if ((0, $3zekA.isTag)(el)) {
            const className = el.attribs['class'] || '';
            addClass.call([
                el
            ], value.call(el, i, className));
        }
    });
    // Return if no value or not a string or function
    if (!value || typeof value !== 'string') return this;
    const classNames = value.split(rspace);
    const numElements = this.length;
    for(let i = 0; i < numElements; i++){
        const el = this[i];
        // If selected element isn't a tag, move on
        if (!(0, $3zekA.isTag)(el)) continue;
        // If we don't already have classes — always set xmlMode to false here, as it doesn't matter for classes
        const className = getAttr(el, 'class', false);
        if (className) {
            let setClass = ` ${className} `;
            // Check if class already exists
            for (const cn of classNames){
                const appendClass = `${cn} `;
                if (!setClass.includes(` ${appendClass}`)) setClass += appendClass;
            }
            setAttr(el, 'class', setClass.trim());
        } else setAttr(el, 'class', classNames.join(' ').trim());
    }
    return this;
}
function removeClass(name) {
    // Handle if value is a function
    if (typeof name === 'function') return (0, $2oqzI.domEach)(this, (el, i)=>{
        if ((0, $3zekA.isTag)(el)) removeClass.call([
            el
        ], name.call(el, i, el.attribs['class'] || ''));
    });
    const classes = splitNames(name);
    const numClasses = classes.length;
    const removeAll = arguments.length === 0;
    return (0, $2oqzI.domEach)(this, (el)=>{
        if (!(0, $3zekA.isTag)(el)) return;
        if (removeAll) // Short circuit the remove all case as this is the nice one
        el.attribs['class'] = '';
        else {
            const elClasses = splitNames(el.attribs['class']);
            let changed = false;
            for(let j = 0; j < numClasses; j++){
                const index = elClasses.indexOf(classes[j]);
                if (index !== -1) {
                    elClasses.splice(index, 1);
                    changed = true;
                    /*
                     * We have to do another pass to ensure that there are not duplicate
                     * classes listed
                     */ j--;
                }
            }
            if (changed) el.attribs['class'] = elClasses.join(' ');
        }
    });
}
function toggleClass(value, stateVal) {
    // Support functions
    if (typeof value === 'function') return (0, $2oqzI.domEach)(this, (el, i)=>{
        if ((0, $3zekA.isTag)(el)) toggleClass.call([
            el
        ], value.call(el, i, el.attribs['class'] || '', stateVal), stateVal);
    });
    // Return if no value or not a string or function
    if (!value || typeof value !== 'string') return this;
    const classNames = value.split(rspace);
    const numClasses = classNames.length;
    const state = typeof stateVal === 'boolean' ? stateVal ? 1 : -1 : 0;
    const numElements = this.length;
    for(let i = 0; i < numElements; i++){
        const el = this[i];
        // If selected element isn't a tag, move on
        if (!(0, $3zekA.isTag)(el)) continue;
        const elementClasses = splitNames(el.attribs['class']);
        // Check if class already exists
        for(let j = 0; j < numClasses; j++){
            // Check if the class name is currently defined
            const index = elementClasses.indexOf(classNames[j]);
            // Add if stateValue === true or we are toggling and there is no value
            if (state >= 0 && index === -1) elementClasses.push(classNames[j]);
            else if (state <= 0 && index !== -1) // Otherwise remove but only if the item exists
            elementClasses.splice(index, 1);
        }
        el.attribs['class'] = elementClasses.join(' ');
    }
    return this;
}

});
parcelRegister("2oqzI", function(module, exports) {

$parcel$export(module.exports, "isCheerio", () => $1be26fe75f44e125$export$799a4b197f11d37);
$parcel$export(module.exports, "camelCase", () => $1be26fe75f44e125$export$8a7688a96d852767);
$parcel$export(module.exports, "cssCase", () => $1be26fe75f44e125$export$53d8919ad8038ec0);
$parcel$export(module.exports, "domEach", () => $1be26fe75f44e125$export$74822c5de6e95c1);
$parcel$export(module.exports, "isHtml", () => $1be26fe75f44e125$export$144ef0648535ac5a);
/**
 * Checks if an object is a Cheerio instance.
 *
 * @category Utils
 * @param maybeCheerio - The object to check.
 * @returns Whether the object is a Cheerio instance.
 */ function $1be26fe75f44e125$export$799a4b197f11d37(maybeCheerio) {
    return maybeCheerio.cheerio != null;
}
function $1be26fe75f44e125$export$8a7688a96d852767(str) {
    return str.replace(/[._-](\w|$)/g, (_, x)=>x.toUpperCase());
}
function $1be26fe75f44e125$export$53d8919ad8038ec0(str) {
    return str.replace(/[A-Z]/g, '-$&').toLowerCase();
}
function $1be26fe75f44e125$export$74822c5de6e95c1(array, fn) {
    const len = array.length;
    for(let i = 0; i < len; i++)fn(array[i], i);
    return array;
}
var $1be26fe75f44e125$var$CharacterCode;
(function(CharacterCode) {
    CharacterCode[CharacterCode["LowerA"] = 97] = "LowerA";
    CharacterCode[CharacterCode["LowerZ"] = 122] = "LowerZ";
    CharacterCode[CharacterCode["UpperA"] = 65] = "UpperA";
    CharacterCode[CharacterCode["UpperZ"] = 90] = "UpperZ";
    CharacterCode[CharacterCode["Exclamation"] = 33] = "Exclamation";
})($1be26fe75f44e125$var$CharacterCode || ($1be26fe75f44e125$var$CharacterCode = {}));
function $1be26fe75f44e125$export$144ef0648535ac5a(str) {
    const tagStart = str.indexOf('<');
    if (tagStart === -1 || tagStart > str.length - 3) return false;
    const tagChar = str.charCodeAt(tagStart + 1);
    return (tagChar >= $1be26fe75f44e125$var$CharacterCode.LowerA && tagChar <= $1be26fe75f44e125$var$CharacterCode.LowerZ || tagChar >= $1be26fe75f44e125$var$CharacterCode.UpperA && tagChar <= $1be26fe75f44e125$var$CharacterCode.UpperZ || tagChar === $1be26fe75f44e125$var$CharacterCode.Exclamation) && str.includes('>', tagStart + 2);
}

});

parcelRegister("hq9P0", function(module, exports) {

$parcel$export(module.exports, "parseDocument", () => $caec7bbc4d24ac98$export$b6a9369736b19f4d);
$parcel$export(module.exports, "ElementType", () => (parcelRequire("hREhV")));

var $4ATMV = parcelRequire("4ATMV");

var $7Z39T = parcelRequire("7Z39T");

var $fcdJQ = parcelRequire("fcdJQ");

var $hREhV = parcelRequire("hREhV");
parcelRequire("CeYTB");
var $2FnQg = parcelRequire("2FnQg");
function $caec7bbc4d24ac98$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $7Z39T.DomHandler)(undefined, options);
    new (0, $4ATMV.Parser)(handler, options).end(data);
    return handler.root;
}
function $caec7bbc4d24ac98$export$d66b332881d9723f(data, options) {
    return $caec7bbc4d24ac98$export$b6a9369736b19f4d(data, options).children;
}
function $caec7bbc4d24ac98$export$d6f7114fde618113(callback, options, elementCallback) {
    const handler = new (0, $7Z39T.DomHandler)((error)=>callback(error, handler.root), options, elementCallback);
    return new (0, $4ATMV.Parser)(handler, options);
}
function $caec7bbc4d24ac98$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $7Z39T.DomHandler)(callback, options, elementCallback);
    return new (0, $4ATMV.Parser)(handler, options);
}
const $caec7bbc4d24ac98$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $caec7bbc4d24ac98$export$5267abf679cd576b(feed, options = $caec7bbc4d24ac98$var$parseFeedDefaultOptions) {
    return (0, $2FnQg.getFeed)($caec7bbc4d24ac98$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("4ATMV", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $3585cc97992ea807$export$7acfa6ed01010e37);

var $fcdJQ = parcelRequire("fcdJQ");

var $9IFEb = parcelRequire("9IFEb");
const $3585cc97992ea807$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $3585cc97992ea807$var$pTag = new Set([
    "p"
]);
const $3585cc97992ea807$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $3585cc97992ea807$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $3585cc97992ea807$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $3585cc97992ea807$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $3585cc97992ea807$var$pTag
    ],
    [
        "h1",
        $3585cc97992ea807$var$pTag
    ],
    [
        "h2",
        $3585cc97992ea807$var$pTag
    ],
    [
        "h3",
        $3585cc97992ea807$var$pTag
    ],
    [
        "h4",
        $3585cc97992ea807$var$pTag
    ],
    [
        "h5",
        $3585cc97992ea807$var$pTag
    ],
    [
        "h6",
        $3585cc97992ea807$var$pTag
    ],
    [
        "select",
        $3585cc97992ea807$var$formTags
    ],
    [
        "input",
        $3585cc97992ea807$var$formTags
    ],
    [
        "output",
        $3585cc97992ea807$var$formTags
    ],
    [
        "button",
        $3585cc97992ea807$var$formTags
    ],
    [
        "datalist",
        $3585cc97992ea807$var$formTags
    ],
    [
        "textarea",
        $3585cc97992ea807$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $3585cc97992ea807$var$ddtTags
    ],
    [
        "dt",
        $3585cc97992ea807$var$ddtTags
    ],
    [
        "address",
        $3585cc97992ea807$var$pTag
    ],
    [
        "article",
        $3585cc97992ea807$var$pTag
    ],
    [
        "aside",
        $3585cc97992ea807$var$pTag
    ],
    [
        "blockquote",
        $3585cc97992ea807$var$pTag
    ],
    [
        "details",
        $3585cc97992ea807$var$pTag
    ],
    [
        "div",
        $3585cc97992ea807$var$pTag
    ],
    [
        "dl",
        $3585cc97992ea807$var$pTag
    ],
    [
        "fieldset",
        $3585cc97992ea807$var$pTag
    ],
    [
        "figcaption",
        $3585cc97992ea807$var$pTag
    ],
    [
        "figure",
        $3585cc97992ea807$var$pTag
    ],
    [
        "footer",
        $3585cc97992ea807$var$pTag
    ],
    [
        "form",
        $3585cc97992ea807$var$pTag
    ],
    [
        "header",
        $3585cc97992ea807$var$pTag
    ],
    [
        "hr",
        $3585cc97992ea807$var$pTag
    ],
    [
        "main",
        $3585cc97992ea807$var$pTag
    ],
    [
        "nav",
        $3585cc97992ea807$var$pTag
    ],
    [
        "ol",
        $3585cc97992ea807$var$pTag
    ],
    [
        "pre",
        $3585cc97992ea807$var$pTag
    ],
    [
        "section",
        $3585cc97992ea807$var$pTag
    ],
    [
        "table",
        $3585cc97992ea807$var$pTag
    ],
    [
        "ul",
        $3585cc97992ea807$var$pTag
    ],
    [
        "rt",
        $3585cc97992ea807$var$rtpTags
    ],
    [
        "rp",
        $3585cc97992ea807$var$rtpTags
    ],
    [
        "tbody",
        $3585cc97992ea807$var$tableSectionTags
    ],
    [
        "tfoot",
        $3585cc97992ea807$var$tableSectionTags
    ]
]);
const $3585cc97992ea807$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $3585cc97992ea807$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $3585cc97992ea807$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $3585cc97992ea807$var$reNameEnd = /\s|\//;
class $3585cc97992ea807$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e, _f;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : this.htmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : this.htmlMode;
        this.recognizeSelfClosing = (_c = options.recognizeSelfClosing) !== null && _c !== void 0 ? _c : !this.htmlMode;
        this.tokenizer = new ((_d = options.Tokenizer) !== null && _d !== void 0 ? _d : (0, $fcdJQ.default))(this.options, this);
        this.foreignContext = [
            !this.htmlMode
        ];
        (_f = (_e = this.cbs).onparserinit) === null || _f === void 0 || _f.call(_e, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp, endIndex) {
        var _a, _b;
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $9IFEb.fromCodePoint)(cp));
        this.startIndex = endIndex;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */ isVoidElement(name) {
        return this.htmlMode && $3585cc97992ea807$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = this.htmlMode && $3585cc97992ea807$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[0])){
            const element = this.stack.shift();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.unshift(name);
            if (this.htmlMode) {
                if ($3585cc97992ea807$var$foreignContextElements.has(name)) this.foreignContext.unshift(true);
                else if ($3585cc97992ea807$var$htmlIntegrationElements.has(name)) this.foreignContext.unshift(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if (this.htmlMode && ($3585cc97992ea807$var$foreignContextElements.has(name) || $3585cc97992ea807$var$htmlIntegrationElements.has(name))) this.foreignContext.shift();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.indexOf(name);
            if (pos !== -1) for(let index = 0; index <= pos; index++){
                const element = this.stack.shift();
                // We know the stack has sufficient elements.
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, index !== pos);
            }
            else if (this.htmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (this.htmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, "br");
            (_f = (_e = this.cbs).onopentag) === null || _f === void 0 || _f.call(_e, "br", {}, true);
            (_h = (_g = this.cbs).onclosetag) === null || _h === void 0 || _h.call(_g, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.recognizeSelfClosing || this.foreignContext[0]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[0] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.shift();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $9IFEb.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $fcdJQ.QuoteType).Double ? '"' : quote === (0, $fcdJQ.QuoteType).Single ? "'" : quote === (0, $fcdJQ.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($3585cc97992ea807$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (!this.htmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = 0; index < this.stack.length; index++)this.cbs.onclosetag(this.stack[index], true);
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.foreignContext.length = 0;
        this.foreignContext.unshift(!this.htmlMode);
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}

});
parcelRegister("fcdJQ", function(module, exports) {

$parcel$export(module.exports, "QuoteType", () => $b102a22aae2bedd4$export$cbf5509cea2ad22);
$parcel$export(module.exports, "default", () => $b102a22aae2bedd4$export$2e2bcd8739ae039);

var $9IFEb = parcelRequire("9IFEb");
var $b102a22aae2bedd4$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($b102a22aae2bedd4$var$CharCodes || ($b102a22aae2bedd4$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $b102a22aae2bedd4$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["BeforeSpecialT"] = 23] = "BeforeSpecialT";
    State[State["SpecialStartSequence"] = 24] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 25] = "InSpecialTag";
    State[State["InEntity"] = 26] = "InEntity";
})($b102a22aae2bedd4$var$State || ($b102a22aae2bedd4$var$State = {}));
function $b102a22aae2bedd4$var$isWhitespace(c) {
    return c === $b102a22aae2bedd4$var$CharCodes.Space || c === $b102a22aae2bedd4$var$CharCodes.NewLine || c === $b102a22aae2bedd4$var$CharCodes.Tab || c === $b102a22aae2bedd4$var$CharCodes.FormFeed || c === $b102a22aae2bedd4$var$CharCodes.CarriageReturn;
}
function $b102a22aae2bedd4$var$isEndOfTagSection(c) {
    return c === $b102a22aae2bedd4$var$CharCodes.Slash || c === $b102a22aae2bedd4$var$CharCodes.Gt || $b102a22aae2bedd4$var$isWhitespace(c);
}
function $b102a22aae2bedd4$var$isASCIIAlpha(c) {
    return c >= $b102a22aae2bedd4$var$CharCodes.LowerA && c <= $b102a22aae2bedd4$var$CharCodes.LowerZ || c >= $b102a22aae2bedd4$var$CharCodes.UpperA && c <= $b102a22aae2bedd4$var$CharCodes.UpperZ;
}
var $b102a22aae2bedd4$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($b102a22aae2bedd4$export$cbf5509cea2ad22 || ($b102a22aae2bedd4$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $b102a22aae2bedd4$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ]),
    TextareaEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x65,
        0x78,
        0x74,
        0x61,
        0x72,
        0x65,
        0x61
    ]),
    XmpEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x78,
        0x6d,
        0x70
    ])
};
class $b102a22aae2bedd4$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $b102a22aae2bedd4$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $b102a22aae2bedd4$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityDecoder = new (0, $9IFEb.EntityDecoder)(xmlMode ? (0, $9IFEb.xmlDecodeTree) : (0, $9IFEb.htmlDecodeTree), (cp, consumed)=>this.emitCodePoint(cp, consumed));
    }
    reset() {
        this.state = $b102a22aae2bedd4$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $b102a22aae2bedd4$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    stateText(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($b102a22aae2bedd4$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $b102a22aae2bedd4$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $b102a22aae2bedd4$var$CharCodes.Amp) this.startEntity();
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $b102a22aae2bedd4$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $b102a22aae2bedd4$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $b102a22aae2bedd4$var$CharCodes.Gt || $b102a22aae2bedd4$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $b102a22aae2bedd4$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $b102a22aae2bedd4$var$CharCodes.Amp) this.startEntity();
            } else if (this.fastForwardTo($b102a22aae2bedd4$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $b102a22aae2bedd4$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $b102a22aae2bedd4$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $b102a22aae2bedd4$var$Sequences.Cdata.length) {
                this.state = $b102a22aae2bedd4$var$State.InCommentLike;
                this.currentSequence = $b102a22aae2bedd4$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $b102a22aae2bedd4$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $b102a22aae2bedd4$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $b102a22aae2bedd4$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$b102a22aae2bedd4$var$isEndOfTagSection(c) : $b102a22aae2bedd4$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $b102a22aae2bedd4$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.ExclamationMark) {
            this.state = $b102a22aae2bedd4$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $b102a22aae2bedd4$var$CharCodes.Questionmark) {
            this.state = $b102a22aae2bedd4$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (this.xmlMode) this.state = $b102a22aae2bedd4$var$State.InTagName;
            else if (lower === $b102a22aae2bedd4$var$Sequences.ScriptEnd[2]) this.state = $b102a22aae2bedd4$var$State.BeforeSpecialS;
            else if (lower === $b102a22aae2bedd4$var$Sequences.TitleEnd[2] || lower === $b102a22aae2bedd4$var$Sequences.XmpEnd[2]) this.state = $b102a22aae2bedd4$var$State.BeforeSpecialT;
            else this.state = $b102a22aae2bedd4$var$State.InTagName;
        } else if (c === $b102a22aae2bedd4$var$CharCodes.Slash) this.state = $b102a22aae2bedd4$var$State.BeforeClosingTagName;
        else {
            this.state = $b102a22aae2bedd4$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($b102a22aae2bedd4$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b102a22aae2bedd4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($b102a22aae2bedd4$var$isWhitespace(c)) ;
        else if (c === $b102a22aae2bedd4$var$CharCodes.Gt) this.state = $b102a22aae2bedd4$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $b102a22aae2bedd4$var$State.InClosingTagName : $b102a22aae2bedd4$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt || $b102a22aae2bedd4$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b102a22aae2bedd4$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt || this.fastForwardTo($b102a22aae2bedd4$var$CharCodes.Gt)) {
            this.state = $b102a22aae2bedd4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $b102a22aae2bedd4$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $b102a22aae2bedd4$var$State.Text;
            this.sectionStart = this.index + 1;
        } else if (c === $b102a22aae2bedd4$var$CharCodes.Slash) this.state = $b102a22aae2bedd4$var$State.InSelfClosingTag;
        else if (!$b102a22aae2bedd4$var$isWhitespace(c)) {
            this.state = $b102a22aae2bedd4$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $b102a22aae2bedd4$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$b102a22aae2bedd4$var$isWhitespace(c)) {
            this.state = $b102a22aae2bedd4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Eq || $b102a22aae2bedd4$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = this.index;
            this.state = $b102a22aae2bedd4$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Eq) this.state = $b102a22aae2bedd4$var$State.BeforeAttributeValue;
        else if (c === $b102a22aae2bedd4$var$CharCodes.Slash || c === $b102a22aae2bedd4$var$CharCodes.Gt) {
            this.cbs.onattribend($b102a22aae2bedd4$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.sectionStart = -1;
            this.state = $b102a22aae2bedd4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$b102a22aae2bedd4$var$isWhitespace(c)) {
            this.cbs.onattribend($b102a22aae2bedd4$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.state = $b102a22aae2bedd4$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.DoubleQuote) {
            this.state = $b102a22aae2bedd4$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $b102a22aae2bedd4$var$CharCodes.SingleQuote) {
            this.state = $b102a22aae2bedd4$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$b102a22aae2bedd4$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $b102a22aae2bedd4$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $b102a22aae2bedd4$var$CharCodes.DoubleQuote ? $b102a22aae2bedd4$export$cbf5509cea2ad22.Double : $b102a22aae2bedd4$export$cbf5509cea2ad22.Single, this.index + 1);
            this.state = $b102a22aae2bedd4$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $b102a22aae2bedd4$var$CharCodes.Amp) this.startEntity();
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $b102a22aae2bedd4$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $b102a22aae2bedd4$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($b102a22aae2bedd4$var$isWhitespace(c) || c === $b102a22aae2bedd4$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($b102a22aae2bedd4$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $b102a22aae2bedd4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $b102a22aae2bedd4$var$CharCodes.Amp) this.startEntity();
    }
    stateBeforeDeclaration(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.OpeningSquareBracket) {
            this.state = $b102a22aae2bedd4$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $b102a22aae2bedd4$var$CharCodes.Dash ? $b102a22aae2bedd4$var$State.BeforeComment : $b102a22aae2bedd4$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt || this.fastForwardTo($b102a22aae2bedd4$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $b102a22aae2bedd4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt || this.fastForwardTo($b102a22aae2bedd4$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $b102a22aae2bedd4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Dash) {
            this.state = $b102a22aae2bedd4$var$State.InCommentLike;
            this.currentSequence = $b102a22aae2bedd4$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $b102a22aae2bedd4$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $b102a22aae2bedd4$var$CharCodes.Gt || this.fastForwardTo($b102a22aae2bedd4$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $b102a22aae2bedd4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $b102a22aae2bedd4$var$Sequences.ScriptEnd[3]) this.startSpecial($b102a22aae2bedd4$var$Sequences.ScriptEnd, 4);
        else if (lower === $b102a22aae2bedd4$var$Sequences.StyleEnd[3]) this.startSpecial($b102a22aae2bedd4$var$Sequences.StyleEnd, 4);
        else {
            this.state = $b102a22aae2bedd4$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeSpecialT(c) {
        const lower = c | 0x20;
        switch(lower){
            case $b102a22aae2bedd4$var$Sequences.TitleEnd[3]:
                this.startSpecial($b102a22aae2bedd4$var$Sequences.TitleEnd, 4);
                break;
            case $b102a22aae2bedd4$var$Sequences.TextareaEnd[3]:
                this.startSpecial($b102a22aae2bedd4$var$Sequences.TextareaEnd, 4);
                break;
            case $b102a22aae2bedd4$var$Sequences.XmpEnd[3]:
                this.startSpecial($b102a22aae2bedd4$var$Sequences.XmpEnd, 4);
                break;
            default:
                this.state = $b102a22aae2bedd4$var$State.InTagName;
                this.stateInTagName(c); // Consume the token again
        }
    }
    startEntity() {
        this.baseState = this.state;
        this.state = $b102a22aae2bedd4$var$State.InEntity;
        this.entityStart = this.index;
        this.entityDecoder.startEntity(this.xmlMode ? (0, $9IFEb.DecodingMode).Strict : this.baseState === $b102a22aae2bedd4$var$State.Text || this.baseState === $b102a22aae2bedd4$var$State.InSpecialTag ? (0, $9IFEb.DecodingMode).Legacy : (0, $9IFEb.DecodingMode).Attribute);
    }
    stateInEntity() {
        const length = this.entityDecoder.write(this.buffer, this.index - this.offset);
        // If `length` is positive, we are done with the entity.
        if (length >= 0) {
            this.state = this.baseState;
            if (length === 0) this.index = this.entityStart;
        } else // Mark buffer as consumed.
        this.index = this.offset + this.buffer.length - 1;
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $b102a22aae2bedd4$var$State.Text || this.state === $b102a22aae2bedd4$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $b102a22aae2bedd4$var$State.InAttributeValueDq || this.state === $b102a22aae2bedd4$var$State.InAttributeValueSq || this.state === $b102a22aae2bedd4$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $b102a22aae2bedd4$var$State.Text:
                    this.stateText(c);
                    break;
                case $b102a22aae2bedd4$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $b102a22aae2bedd4$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $b102a22aae2bedd4$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $b102a22aae2bedd4$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $b102a22aae2bedd4$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $b102a22aae2bedd4$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $b102a22aae2bedd4$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $b102a22aae2bedd4$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $b102a22aae2bedd4$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $b102a22aae2bedd4$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $b102a22aae2bedd4$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $b102a22aae2bedd4$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeSpecialT:
                    this.stateBeforeSpecialT(c);
                    break;
                case $b102a22aae2bedd4$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $b102a22aae2bedd4$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $b102a22aae2bedd4$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $b102a22aae2bedd4$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $b102a22aae2bedd4$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $b102a22aae2bedd4$var$State.InEntity:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $b102a22aae2bedd4$var$State.InEntity) {
            this.entityDecoder.end();
            this.state = this.baseState;
        }
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        // If there is no remaining data, we are done.
        if (this.sectionStart >= endIndex) return;
        if (this.state === $b102a22aae2bedd4$var$State.InCommentLike) {
            if (this.currentSequence === $b102a22aae2bedd4$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $b102a22aae2bedd4$var$State.InTagName || this.state === $b102a22aae2bedd4$var$State.BeforeAttributeName || this.state === $b102a22aae2bedd4$var$State.BeforeAttributeValue || this.state === $b102a22aae2bedd4$var$State.AfterAttributeName || this.state === $b102a22aae2bedd4$var$State.InAttributeName || this.state === $b102a22aae2bedd4$var$State.InAttributeValueSq || this.state === $b102a22aae2bedd4$var$State.InAttributeValueDq || this.state === $b102a22aae2bedd4$var$State.InAttributeValueNq || this.state === $b102a22aae2bedd4$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {
        if (this.baseState !== $b102a22aae2bedd4$var$State.Text && this.baseState !== $b102a22aae2bedd4$var$State.InSpecialTag) {
            if (this.sectionStart < this.entityStart) this.cbs.onattribdata(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.onattribentity(cp);
        } else {
            if (this.sectionStart < this.entityStart) this.cbs.ontext(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.ontextentity(cp, this.sectionStart);
        }
    }
}

});
parcelRegister("9IFEb", function(module, exports) {
// Make exports work in Node < 12
// eslint-disable-next-line no-undef, unicorn/prefer-module

module.exports = (parcelRequire("93kzK"));

});
parcelRegister("93kzK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = void 0;
module.exports.determineBranch = $69745abbbd9a364b$var$determineBranch;
module.exports.decodeHTML = $69745abbbd9a364b$var$decodeHTML;
module.exports.decodeHTMLAttribute = $69745abbbd9a364b$var$decodeHTMLAttribute;
module.exports.decodeHTMLStrict = $69745abbbd9a364b$var$decodeHTMLStrict;
module.exports.decodeXML = $69745abbbd9a364b$var$decodeXML;

var $5SAyt = parcelRequire("5SAyt");

var $15x9D = parcelRequire("15x9D");

var $btko2 = parcelRequire("btko2");
var $69745abbbd9a364b$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($69745abbbd9a364b$var$CharCodes || ($69745abbbd9a364b$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $69745abbbd9a364b$var$TO_LOWER_BIT = 32;
var $69745abbbd9a364b$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($69745abbbd9a364b$var$BinTrieFlags || (module.exports.BinTrieFlags = $69745abbbd9a364b$var$BinTrieFlags = {}));
function $69745abbbd9a364b$var$isNumber(code) {
    return code >= $69745abbbd9a364b$var$CharCodes.ZERO && code <= $69745abbbd9a364b$var$CharCodes.NINE;
}
function $69745abbbd9a364b$var$isHexadecimalCharacter(code) {
    return code >= $69745abbbd9a364b$var$CharCodes.UPPER_A && code <= $69745abbbd9a364b$var$CharCodes.UPPER_F || code >= $69745abbbd9a364b$var$CharCodes.LOWER_A && code <= $69745abbbd9a364b$var$CharCodes.LOWER_F;
}
function $69745abbbd9a364b$var$isAsciiAlphaNumeric(code) {
    return code >= $69745abbbd9a364b$var$CharCodes.UPPER_A && code <= $69745abbbd9a364b$var$CharCodes.UPPER_Z || code >= $69745abbbd9a364b$var$CharCodes.LOWER_A && code <= $69745abbbd9a364b$var$CharCodes.LOWER_Z || $69745abbbd9a364b$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $69745abbbd9a364b$var$isEntityInAttributeInvalidEnd(code) {
    return code === $69745abbbd9a364b$var$CharCodes.EQUALS || $69745abbbd9a364b$var$isAsciiAlphaNumeric(code);
}
var $69745abbbd9a364b$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($69745abbbd9a364b$var$EntityDecoderState || ($69745abbbd9a364b$var$EntityDecoderState = {}));
var $69745abbbd9a364b$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($69745abbbd9a364b$var$DecodingMode || (module.exports.DecodingMode = $69745abbbd9a364b$var$DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ class $69745abbbd9a364b$var$EntityDecoder {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $69745abbbd9a364b$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $69745abbbd9a364b$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $69745abbbd9a364b$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(input, offset) {
        switch(this.state){
            case $69745abbbd9a364b$var$EntityDecoderState.EntityStart:
                if (input.charCodeAt(offset) === $69745abbbd9a364b$var$CharCodes.NUM) {
                    this.state = $69745abbbd9a364b$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(input, offset + 1);
                }
                this.state = $69745abbbd9a364b$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(input, offset);
            case $69745abbbd9a364b$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(input, offset);
            case $69745abbbd9a364b$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(input, offset);
            case $69745abbbd9a364b$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(input, offset);
            case $69745abbbd9a364b$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(input, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(input, offset) {
        if (offset >= input.length) return -1;
        if ((input.charCodeAt(offset) | $69745abbbd9a364b$var$TO_LOWER_BIT) === $69745abbbd9a364b$var$CharCodes.LOWER_X) {
            this.state = $69745abbbd9a364b$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(input, offset + 1);
        }
        this.state = $69745abbbd9a364b$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(input, offset);
    }
    addToNumericResult(input, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($69745abbbd9a364b$var$isNumber(char) || $69745abbbd9a364b$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($69745abbbd9a364b$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $69745abbbd9a364b$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $69745abbbd9a364b$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $btko2.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $69745abbbd9a364b$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(input, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $69745abbbd9a364b$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < input.length; offset++, this.excess++){
            const char = input.charCodeAt(offset);
            this.treeIndex = $69745abbbd9a364b$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $69745abbbd9a364b$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $69745abbbd9a364b$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $69745abbbd9a364b$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $69745abbbd9a364b$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $69745abbbd9a364b$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $69745abbbd9a364b$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$69745abbbd9a364b$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $69745abbbd9a364b$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $69745abbbd9a364b$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $69745abbbd9a364b$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $69745abbbd9a364b$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $69745abbbd9a364b$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $69745abbbd9a364b$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
module.exports.EntityDecoder = $69745abbbd9a364b$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $69745abbbd9a364b$var$getDecoder(decodeTree) {
    let returnValue = "";
    const decoder = new $69745abbbd9a364b$var$EntityDecoder(decodeTree, (data)=>returnValue += (0, $btko2.fromCodePoint)(data));
    return function decodeWithTrie(input, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = input.indexOf("&", offset)) >= 0){
            returnValue += input.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const length = decoder.write(input, // Skip the "&"
            offset + 1);
            if (length < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + length;
            // If `length` is 0, skip the current `&` and continue.
            offset = length === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = returnValue + input.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        returnValue = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $69745abbbd9a364b$var$determineBranch(decodeTree, current, nodeIndex, char) {
    const branchCount = (current & $69745abbbd9a364b$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $69745abbbd9a364b$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIndex : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIndex;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midValue = decodeTree[mid];
        if (midValue < char) lo = mid + 1;
        else if (midValue > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $69745abbbd9a364b$var$htmlDecoder = /* #__PURE__ */ $69745abbbd9a364b$var$getDecoder($5SAyt.htmlDecodeTree);
const $69745abbbd9a364b$var$xmlDecoder = /* #__PURE__ */ $69745abbbd9a364b$var$getDecoder($15x9D.xmlDecodeTree);
/**
 * Decodes an HTML string.
 *
 * @param htmlString The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $69745abbbd9a364b$var$decodeHTML(htmlString, mode = $69745abbbd9a364b$var$DecodingMode.Legacy) {
    return $69745abbbd9a364b$var$htmlDecoder(htmlString, mode);
}
/**
 * Decodes an HTML string in an attribute.
 *
 * @param htmlAttribute The string to decode.
 * @returns The decoded string.
 */ function $69745abbbd9a364b$var$decodeHTMLAttribute(htmlAttribute) {
    return $69745abbbd9a364b$var$htmlDecoder(htmlAttribute, $69745abbbd9a364b$var$DecodingMode.Attribute);
}
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param htmlString The string to decode.
 * @returns The decoded string.
 */ function $69745abbbd9a364b$var$decodeHTMLStrict(htmlString) {
    return $69745abbbd9a364b$var$htmlDecoder(htmlString, $69745abbbd9a364b$var$DecodingMode.Strict);
}
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param xmlString The string to decode.
 * @returns The decoded string.
 */ function $69745abbbd9a364b$var$decodeXML(xmlString) {
    return $69745abbbd9a364b$var$xmlDecoder(xmlString, $69745abbbd9a364b$var$DecodingMode.Strict);
}

var $5SAyt = parcelRequire("5SAyt");
Object.defineProperty(module.exports, "htmlDecodeTree", {
    enumerable: true,
    get: function() {
        return $5SAyt.htmlDecodeTree;
    }
});

var $15x9D = parcelRequire("15x9D");
Object.defineProperty(module.exports, "xmlDecodeTree", {
    enumerable: true,
    get: function() {
        return $15x9D.xmlDecodeTree;
    }
});

var $btko2 = parcelRequire("btko2");
Object.defineProperty(module.exports, "decodeCodePoint", {
    enumerable: true,
    get: function() {
        return $btko2.decodeCodePoint;
    }
});
Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return $btko2.replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return $btko2.fromCodePoint;
    }
});

});
parcelRegister("5SAyt", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.htmlDecodeTree = void 0;
module.exports.htmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("15x9D", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.xmlDecodeTree = void 0;
module.exports.xmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("btko2", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $85a23786f2004565$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = void 0;
module.exports.replaceCodePoint = $85a23786f2004565$var$replaceCodePoint;
module.exports.decodeCodePoint = $85a23786f2004565$var$decodeCodePoint;
const $85a23786f2004565$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
($85a23786f2004565$var$_a = String.fromCodePoint) !== null && $85a23786f2004565$var$_a !== void 0 ? $85a23786f2004565$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $85a23786f2004565$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
    return (_a = $85a23786f2004565$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $85a23786f2004565$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($85a23786f2004565$var$replaceCodePoint(codePoint));
}

});







parcelRegister("f2WFc", function(module, exports) {

$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "_findBySelector", () => _findBySelector);
$parcel$export(module.exports, "filterArray", () => filterArray);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "parentsUntil", () => parentsUntil);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "nextUntil", () => nextUntil);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "prevUntil", () => prevUntil);
$parcel$export(module.exports, "siblings", () => siblings);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "contents", () => contents);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "map", () => map);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "not", () => not);
$parcel$export(module.exports, "has", () => has);
$parcel$export(module.exports, "first", () => first);
$parcel$export(module.exports, "last", () => last);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "toArray", () => toArray);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "slice", () => slice);
$parcel$export(module.exports, "end", () => end);
$parcel$export(module.exports, "add", () => add);
$parcel$export(module.exports, "addBack", () => addBack);
/**
 * Methods for traversing the DOM structure.
 *
 * @module cheerio/traversing
 */ parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $6RSk2 = parcelRequire("6RSk2");

var $2oqzI = parcelRequire("2oqzI");

var $8fHQO = parcelRequire("8fHQO");
parcelRequire("CeYTB");
var $cWyns = parcelRequire("cWyns");
var $7ZYrI = parcelRequire("7ZYrI");
const reSiblingSelector = /^\s*[+~]/;
function find(selectorOrHaystack) {
    if (!selectorOrHaystack) return this._make([]);
    if (typeof selectorOrHaystack !== 'string') {
        const haystack = (0, $2oqzI.isCheerio)(selectorOrHaystack) ? selectorOrHaystack.toArray() : [
            selectorOrHaystack
        ];
        const context = this.toArray();
        return this._make(haystack.filter((elem)=>context.some((node)=>(0, $8fHQO.contains)(node, elem))));
    }
    return this._findBySelector(selectorOrHaystack, Number.POSITIVE_INFINITY);
}
function _findBySelector(selector, limit) {
    var _a;
    const context = this.toArray();
    const elems = reSiblingSelector.test(selector) ? context : this.children().toArray();
    const options = {
        context: context,
        root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0],
        // Pass options that are recognized by `cheerio-select`
        xmlMode: this.options.xmlMode,
        lowerCaseTags: this.options.lowerCaseTags,
        lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
        pseudos: this.options.pseudos,
        quirksMode: this.options.quirksMode
    };
    return this._make($6RSk2.select(selector, elems, options, limit));
}
/**
 * Creates a matcher, using a particular mapping function. Matchers provide a
 * function that finds elements using a generating function, supporting
 * filtering.
 *
 * @private
 * @param matchMap - Mapping function.
 * @returns - Function for wrapping generating functions.
 */ function _getMatcher(matchMap) {
    return function(fn, ...postFns) {
        return function(selector) {
            var _a;
            let matched = matchMap(fn, this);
            if (selector) matched = filterArray(matched, selector, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]);
            return this._make(// Post processing is only necessary if there is more than one element.
            this.length > 1 && matched.length > 1 ? postFns.reduce((elems, fn)=>fn(elems), matched) : matched);
        };
    };
}
/** Matcher that adds multiple elements for each entry in the input. */ const _matcher = _getMatcher((fn, elems)=>{
    let ret = [];
    for(let i = 0; i < elems.length; i++){
        const value = fn(elems[i]);
        if (value.length > 0) ret = ret.concat(value);
    }
    return ret;
});
/** Matcher that adds at most one element for each entry in the input. */ const _singleMatcher = _getMatcher((fn, elems)=>{
    const ret = [];
    for(let i = 0; i < elems.length; i++){
        const value = fn(elems[i]);
        if (value !== null) ret.push(value);
    }
    return ret;
});
/**
 * Matcher that supports traversing until a condition is met.
 *
 * @param nextElem - Function that returns the next element.
 * @param postFns - Post processing functions.
 * @returns A function usable for `*Until` methods.
 */ function _matchUntil(nextElem, ...postFns) {
    // We use a variable here that is used from within the matcher.
    let matches = null;
    const innerMatcher = _getMatcher((nextElem, elems)=>{
        const matched = [];
        (0, $2oqzI.domEach)(elems, (elem)=>{
            for(let next; next = nextElem(elem); elem = next){
                // FIXME: `matched` might contain duplicates here and the index is too large.
                if (matches === null || matches === void 0 ? void 0 : matches(next, matched.length)) break;
                matched.push(next);
            }
        });
        return matched;
    })(nextElem, ...postFns);
    return function(selector, filterSelector) {
        // Override `matches` variable with the new target.
        matches = typeof selector === 'string' ? (elem)=>$6RSk2.is(elem, selector, this.options) : selector ? getFilterFn(selector) : null;
        const ret = innerMatcher.call(this, filterSelector);
        // Set `matches` to `null`, so we don't waste memory.
        matches = null;
        return ret;
    };
}
function _removeDuplicates(elems) {
    return elems.length > 1 ? Array.from(new Set(elems)) : elems;
}
const parent = _singleMatcher(({ parent })=>parent && !(0, $3zekA.isDocument)(parent) ? parent : null, _removeDuplicates);
const parents = _matcher((elem)=>{
    const matched = [];
    while(elem.parent && !(0, $3zekA.isDocument)(elem.parent)){
        matched.push(elem.parent);
        elem = elem.parent;
    }
    return matched;
}, (0, $7ZYrI.uniqueSort), (elems)=>elems.reverse());
const parentsUntil = _matchUntil(({ parent })=>parent && !(0, $3zekA.isDocument)(parent) ? parent : null, (0, $7ZYrI.uniqueSort), (elems)=>elems.reverse());
function closest(selector) {
    var _a;
    const set = [];
    if (!selector) return this._make(set);
    const selectOpts = {
        xmlMode: this.options.xmlMode,
        root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]
    };
    const selectFn = typeof selector === 'string' ? (elem)=>$6RSk2.is(elem, selector, selectOpts) : getFilterFn(selector);
    (0, $2oqzI.domEach)(this, (elem)=>{
        if (elem && !(0, $3zekA.isDocument)(elem) && !(0, $3zekA.isTag)(elem)) elem = elem.parent;
        while(elem && (0, $3zekA.isTag)(elem)){
            if (selectFn(elem, 0)) {
                // Do not add duplicate elements to the set
                if (!set.includes(elem)) set.push(elem);
                break;
            }
            elem = elem.parent;
        }
    });
    return this._make(set);
}
const next = _singleMatcher((elem)=>(0, $cWyns.nextElementSibling)(elem));
const nextAll = _matcher((elem)=>{
    const matched = [];
    while(elem.next){
        elem = elem.next;
        if ((0, $3zekA.isTag)(elem)) matched.push(elem);
    }
    return matched;
}, _removeDuplicates);
const nextUntil = _matchUntil((el)=>(0, $cWyns.nextElementSibling)(el), _removeDuplicates);
const prev = _singleMatcher((elem)=>(0, $cWyns.prevElementSibling)(elem));
const prevAll = _matcher((elem)=>{
    const matched = [];
    while(elem.prev){
        elem = elem.prev;
        if ((0, $3zekA.isTag)(elem)) matched.push(elem);
    }
    return matched;
}, _removeDuplicates);
const prevUntil = _matchUntil((el)=>(0, $cWyns.prevElementSibling)(el), _removeDuplicates);
const siblings = _matcher((elem)=>(0, $cWyns.getSiblings)(elem).filter((el)=>(0, $3zekA.isTag)(el) && el !== elem), (0, $7ZYrI.uniqueSort));
const children = _matcher((elem)=>(0, $cWyns.getChildren)(elem).filter((0, $3zekA.isTag)), _removeDuplicates);
function contents() {
    const elems = this.toArray().reduce((newElems, elem)=>(0, $3zekA.hasChildren)(elem) ? newElems.concat(elem.children) : newElems, []);
    return this._make(elems);
}
function each(fn) {
    let i = 0;
    const len = this.length;
    while(i < len && fn.call(this[i], i, this[i]) !== false)++i;
    return this;
}
function map(fn) {
    let elems = [];
    for(let i = 0; i < this.length; i++){
        const el = this[i];
        const val = fn.call(el, i, el);
        if (val != null) elems = elems.concat(val);
    }
    return this._make(elems);
}
/**
 * Creates a function to test if a filter is matched.
 *
 * @param match - A filter.
 * @returns A function that determines if a filter has been matched.
 */ function getFilterFn(match) {
    if (typeof match === 'function') return (el, i)=>match.call(el, i, el);
    if ((0, $2oqzI.isCheerio)(match)) return (el)=>Array.prototype.includes.call(match, el);
    return function(el) {
        return match === el;
    };
}
function filter(match) {
    var _a;
    return this._make(filterArray(this.toArray(), match, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]));
}
function filterArray(nodes, match, xmlMode, root) {
    return typeof match === 'string' ? $6RSk2.filter(match, nodes, {
        xmlMode: xmlMode,
        root: root
    }) : nodes.filter(getFilterFn(match));
}
function is(selector) {
    const nodes = this.toArray();
    return typeof selector === 'string' ? $6RSk2.some(nodes.filter((0, $3zekA.isTag)), selector, this.options) : selector ? nodes.some(getFilterFn(selector)) : false;
}
function not(match) {
    let nodes = this.toArray();
    if (typeof match === 'string') {
        const matches = new Set($6RSk2.filter(match, nodes, this.options));
        nodes = nodes.filter((el)=>!matches.has(el));
    } else {
        const filterFn = getFilterFn(match);
        nodes = nodes.filter((el, i)=>!filterFn(el, i));
    }
    return this._make(nodes);
}
function has(selectorOrHaystack) {
    return this.filter(typeof selectorOrHaystack === 'string' ? `:has(${selectorOrHaystack})` : (_, el)=>this._make(el).find(selectorOrHaystack).length > 0);
}
function first() {
    return this.length > 1 ? this._make(this[0]) : this;
}
function last() {
    return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
function eq(i) {
    var _a;
    i = +i;
    // Use the first identity optimization if possible
    if (i === 0 && this.length <= 1) return this;
    if (i < 0) i = this.length + i;
    return this._make((_a = this[i]) !== null && _a !== void 0 ? _a : []);
}
function get(i) {
    if (i == null) return this.toArray();
    return this[i < 0 ? this.length + i : i];
}
function toArray() {
    return Array.prototype.slice.call(this);
}
function index(selectorOrNeedle) {
    let $haystack;
    let needle;
    if (selectorOrNeedle == null) {
        $haystack = this.parent().children();
        needle = this[0];
    } else if (typeof selectorOrNeedle === 'string') {
        $haystack = this._make(selectorOrNeedle);
        needle = this[0];
    } else {
        // eslint-disable-next-line @typescript-eslint/no-this-alias, unicorn/no-this-assignment
        $haystack = this;
        needle = (0, $2oqzI.isCheerio)(selectorOrNeedle) ? selectorOrNeedle[0] : selectorOrNeedle;
    }
    return Array.prototype.indexOf.call($haystack, needle);
}
function slice(start, end) {
    return this._make(Array.prototype.slice.call(this, start, end));
}
function end() {
    var _a;
    return (_a = this.prevObject) !== null && _a !== void 0 ? _a : this._make([]);
}
function add(other, context) {
    const selection = this._make(other, context);
    const contents = (0, $7ZYrI.uniqueSort)([
        ...this.get(),
        ...selection.get()
    ]);
    return this._make(contents);
}
function addBack(selector) {
    return this.prevObject ? this.add(selector ? this.prevObject.filter(selector) : this.prevObject) : this;
}

});
parcelRegister("6RSk2", function(module, exports) {

$parcel$export(module.exports, "is", () => $5001d4900bd59287$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "some", () => $5001d4900bd59287$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "filter", () => $5001d4900bd59287$export$3dea766d36a8935f);
$parcel$export(module.exports, "select", () => $5001d4900bd59287$export$2e6c959c16ff56b8);

var $Nbvfz = parcelRequire("Nbvfz");
var $9qW55 = parcelRequire("9qW55");

var $kX9Bh = parcelRequire("kX9Bh");

var $CeYTB = parcelRequire("CeYTB");

var $eRELI = parcelRequire("eRELI");

var $dQF0N = parcelRequire("dQF0N");

var $Hc8DK = parcelRequire("Hc8DK");
const $5001d4900bd59287$var$UNIVERSAL_SELECTOR = {
    type: (0, $9qW55.SelectorType).Universal,
    namespace: null
};
const $5001d4900bd59287$var$SCOPE_PSEUDO = {
    type: (0, $9qW55.SelectorType).Pseudo,
    name: "scope",
    data: null
};
function $5001d4900bd59287$export$226b3eccf92c9ed9(element, selector, options = {}) {
    return $5001d4900bd59287$export$ad14ef4001db2bcd([
        element
    ], selector, options);
}
function $5001d4900bd59287$export$ad14ef4001db2bcd(elements, selector, options = {}) {
    if (typeof selector === "function") return elements.some(selector);
    const [plain, filtered] = (0, $dQF0N.groupSelectors)((0, $Nbvfz.parse)(selector));
    return plain.length > 0 && elements.some((0, $kX9Bh._compileToken)(plain, options)) || filtered.some((sel)=>$5001d4900bd59287$var$filterBySelector(sel, elements, options).length > 0);
}
function $5001d4900bd59287$var$filterByPosition(filter, elems, data, options) {
    const num = typeof data === "string" ? parseInt(data, 10) : NaN;
    switch(filter){
        case "first":
        case "lt":
            // Already done in `getLimit`
            return elems;
        case "last":
            return elems.length > 0 ? [
                elems[elems.length - 1]
            ] : elems;
        case "nth":
        case "eq":
            return isFinite(num) && Math.abs(num) < elems.length ? [
                num < 0 ? elems[elems.length + num] : elems[num]
            ] : [];
        case "gt":
            return isFinite(num) ? elems.slice(num + 1) : [];
        case "even":
            return elems.filter((_, i)=>i % 2 === 0);
        case "odd":
            return elems.filter((_, i)=>i % 2 === 1);
        case "not":
            {
                const filtered = new Set($5001d4900bd59287$var$filterParsed(data, elems, options));
                return elems.filter((e)=>!filtered.has(e));
            }
    }
}
function $5001d4900bd59287$export$3dea766d36a8935f(selector, elements, options = {}) {
    return $5001d4900bd59287$var$filterParsed((0, $Nbvfz.parse)(selector), elements, options);
}
/**
 * Filter a set of elements by a selector.
 *
 * Will return elements in the original order.
 *
 * @param selector Selector to filter by.
 * @param elements Elements to filter.
 * @param options Options for selector.
 */ function $5001d4900bd59287$var$filterParsed(selector, elements, options) {
    if (elements.length === 0) return [];
    const [plainSelectors, filteredSelectors] = (0, $dQF0N.groupSelectors)(selector);
    let found;
    if (plainSelectors.length) {
        const filtered = $5001d4900bd59287$var$filterElements(elements, plainSelectors, options);
        // If there are no filters, just return
        if (filteredSelectors.length === 0) return filtered;
        // Otherwise, we have to do some filtering
        if (filtered.length) found = new Set(filtered);
    }
    for(let i = 0; i < filteredSelectors.length && (found === null || found === void 0 ? void 0 : found.size) !== elements.length; i++){
        const filteredSelector = filteredSelectors[i];
        const missing = found ? elements.filter((e)=>$CeYTB.isTag(e) && !found.has(e)) : elements;
        if (missing.length === 0) break;
        const filtered = $5001d4900bd59287$var$filterBySelector(filteredSelector, elements, options);
        if (filtered.length) {
            if (!found) {
                /*
                 * If we haven't found anything before the last selector,
                 * just return what we found now.
                 */ if (i === filteredSelectors.length - 1) return filtered;
                found = new Set(filtered);
            } else filtered.forEach((el)=>found.add(el));
        }
    }
    return typeof found !== "undefined" ? found.size === elements.length ? elements : elements.filter((el)=>found.has(el)) : [];
}
function $5001d4900bd59287$var$filterBySelector(selector, elements, options) {
    var _a;
    if (selector.some((0, $Nbvfz.isTraversal))) {
        /*
         * Get root node, run selector with the scope
         * set to all of our nodes.
         */ const root = (_a = options.root) !== null && _a !== void 0 ? _a : (0, $dQF0N.getDocumentRoot)(elements[0]);
        const opts = {
            ...options,
            context: elements,
            relativeSelector: false
        };
        selector.push($5001d4900bd59287$var$SCOPE_PSEUDO);
        return $5001d4900bd59287$var$findFilterElements(root, selector, opts, true, elements.length);
    }
    // Performance optimization: If we don't have to traverse, just filter set.
    return $5001d4900bd59287$var$findFilterElements(elements, selector, options, false, elements.length);
}
function $5001d4900bd59287$export$2e6c959c16ff56b8(selector, root, options = {}, limit = Infinity) {
    if (typeof selector === "function") return $5001d4900bd59287$var$find(root, selector);
    const [plain, filtered] = (0, $dQF0N.groupSelectors)((0, $Nbvfz.parse)(selector));
    const results = filtered.map((sel)=>$5001d4900bd59287$var$findFilterElements(root, sel, options, true, limit));
    // Plain selectors can be queried in a single go
    if (plain.length) results.push($5001d4900bd59287$var$findElements(root, plain, options, limit));
    if (results.length === 0) return [];
    // If there was only a single selector, just return the result
    if (results.length === 1) return results[0];
    // Sort results, filtering for duplicates
    return $CeYTB.uniqueSort(results.reduce((a, b)=>[
            ...a,
            ...b
        ]));
}
/**
 *
 * @param root Element(s) to search from.
 * @param selector Selector to look for.
 * @param options Options for querying.
 * @param queryForSelector Query multiple levels deep for the initial selector, even if it doesn't contain a traversal.
 */ function $5001d4900bd59287$var$findFilterElements(root, selector, options, queryForSelector, totalLimit) {
    const filterIndex = selector.findIndex((0, $Hc8DK.isFilter));
    const sub = selector.slice(0, filterIndex);
    const filter = selector[filterIndex];
    // If we are at the end of the selector, we can limit the number of elements to retrieve.
    const partLimit = selector.length - 1 === filterIndex ? totalLimit : Infinity;
    /*
     * Set the number of elements to retrieve.
     * Eg. for :first, we only have to get a single element.
     */ const limit = (0, $Hc8DK.getLimit)(filter.name, filter.data, partLimit);
    if (limit === 0) return [];
    /*
     * Skip `findElements` call if our selector starts with a positional
     * pseudo.
     */ const elemsNoLimit = sub.length === 0 && !Array.isArray(root) ? $CeYTB.getChildren(root).filter($CeYTB.isTag) : sub.length === 0 ? (Array.isArray(root) ? root : [
        root
    ]).filter($CeYTB.isTag) : queryForSelector || sub.some((0, $Nbvfz.isTraversal)) ? $5001d4900bd59287$var$findElements(root, [
        sub
    ], options, limit) : $5001d4900bd59287$var$filterElements(root, [
        sub
    ], options);
    const elems = elemsNoLimit.slice(0, limit);
    let result = $5001d4900bd59287$var$filterByPosition(filter.name, elems, filter.data, options);
    if (result.length === 0 || selector.length === filterIndex + 1) return result;
    const remainingSelector = selector.slice(filterIndex + 1);
    const remainingHasTraversal = remainingSelector.some((0, $Nbvfz.isTraversal));
    if (remainingHasTraversal) {
        if ((0, $Nbvfz.isTraversal)(remainingSelector[0])) {
            const { type: type } = remainingSelector[0];
            if (type === (0, $9qW55.SelectorType).Sibling || type === (0, $9qW55.SelectorType).Adjacent) // If we have a sibling traversal, we need to also look at the siblings.
            result = (0, $kX9Bh.prepareContext)(result, $CeYTB, true);
            // Avoid a traversal-first selector error.
            remainingSelector.unshift($5001d4900bd59287$var$UNIVERSAL_SELECTOR);
        }
        options = {
            ...options,
            // Avoid absolutizing the selector
            relativeSelector: false,
            /*
             * Add a custom root func, to make sure traversals don't match elements
             * that aren't a part of the considered tree.
             */ rootFunc: (el)=>result.includes(el)
        };
    } else if (options.rootFunc && options.rootFunc !== $eRELI.trueFunc) options = {
        ...options,
        rootFunc: $eRELI.trueFunc
    };
    /*
     * If we have another filter, recursively call `findFilterElements`,
     * with the `recursive` flag disabled. We only have to look for more
     * elements when we see a traversal.
     *
     * Otherwise,
     */ return remainingSelector.some((0, $Hc8DK.isFilter)) ? $5001d4900bd59287$var$findFilterElements(result, remainingSelector, options, false, totalLimit) : remainingHasTraversal ? $5001d4900bd59287$var$findElements(result, [
        remainingSelector
    ], options, totalLimit) : $5001d4900bd59287$var$filterElements(result, [
        remainingSelector
    ], options);
}
function $5001d4900bd59287$var$findElements(root, sel, options, limit) {
    const query = (0, $kX9Bh._compileToken)(sel, options, root);
    return $5001d4900bd59287$var$find(root, query, limit);
}
function $5001d4900bd59287$var$find(root, query, limit = Infinity) {
    const elems = (0, $kX9Bh.prepareContext)(root, $CeYTB, query.shouldTestNextSiblings);
    return $CeYTB.find((node)=>$CeYTB.isTag(node) && query(node), elems, true, limit);
}
function $5001d4900bd59287$var$filterElements(elements, sel, options) {
    const els = (Array.isArray(elements) ? elements : [
        elements
    ]).filter($CeYTB.isTag);
    if (els.length === 0) return els;
    const query = (0, $kX9Bh._compileToken)(sel, options);
    return query === $eRELI.trueFunc ? els : els.filter(query);
}

});
parcelRegister("Nbvfz", function(module, exports) {

$parcel$export(module.exports, "isTraversal", () => $093d7ffb078d3faf$export$41d1fe2780697dca);
$parcel$export(module.exports, "parse", () => $093d7ffb078d3faf$export$98e6a39c04603d36);

var $9qW55 = parcelRequire("9qW55");
const $093d7ffb078d3faf$var$reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const $093d7ffb078d3faf$var$reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const $093d7ffb078d3faf$var$actionTypes = new Map([
    [
        126 /* Tilde */ ,
        (0, $9qW55.AttributeAction).Element
    ],
    [
        94 /* Circumflex */ ,
        (0, $9qW55.AttributeAction).Start
    ],
    [
        36 /* Dollar */ ,
        (0, $9qW55.AttributeAction).End
    ],
    [
        42 /* Asterisk */ ,
        (0, $9qW55.AttributeAction).Any
    ],
    [
        33 /* ExclamationMark */ ,
        (0, $9qW55.AttributeAction).Not
    ],
    [
        124 /* Pipe */ ,
        (0, $9qW55.AttributeAction).Hyphen
    ]
]);
// Pseudos, whose data property is parsed as well.
const $093d7ffb078d3faf$var$unpackPseudos = new Set([
    "has",
    "not",
    "matches",
    "is",
    "where",
    "host",
    "host-context"
]);
function $093d7ffb078d3faf$export$41d1fe2780697dca(selector) {
    switch(selector.type){
        case (0, $9qW55.SelectorType).Adjacent:
        case (0, $9qW55.SelectorType).Child:
        case (0, $9qW55.SelectorType).Descendant:
        case (0, $9qW55.SelectorType).Parent:
        case (0, $9qW55.SelectorType).Sibling:
        case (0, $9qW55.SelectorType).ColumnCombinator:
            return true;
        default:
            return false;
    }
}
const $093d7ffb078d3faf$var$stripQuotesFromPseudos = new Set([
    "contains",
    "icontains"
]);
// Unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L152
function $093d7ffb078d3faf$var$funescape(_, escaped, escapedWhitespace) {
    const high = parseInt(escaped, 16) - 0x10000;
    // NaN means non-codepoint
    return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xd800, high & 0x3ff | 0xdc00);
}
function $093d7ffb078d3faf$var$unescapeCSS(str) {
    return str.replace($093d7ffb078d3faf$var$reEscape, $093d7ffb078d3faf$var$funescape);
}
function $093d7ffb078d3faf$var$isQuote(c) {
    return c === 39 /* SingleQuote */  || c === 34 /* DoubleQuote */ ;
}
function $093d7ffb078d3faf$var$isWhitespace(c) {
    return c === 32 /* Space */  || c === 9 /* Tab */  || c === 10 /* NewLine */  || c === 12 /* FormFeed */  || c === 13 /* CarriageReturn */ ;
}
function $093d7ffb078d3faf$export$98e6a39c04603d36(selector) {
    const subselects = [];
    const endIndex = $093d7ffb078d3faf$var$parseSelector(subselects, `${selector}`, 0);
    if (endIndex < selector.length) throw new Error(`Unmatched selector: ${selector.slice(endIndex)}`);
    return subselects;
}
function $093d7ffb078d3faf$var$parseSelector(subselects, selector, selectorIndex) {
    let tokens = [];
    function getName(offset) {
        const match = selector.slice(selectorIndex + offset).match($093d7ffb078d3faf$var$reName);
        if (!match) throw new Error(`Expected name, found ${selector.slice(selectorIndex)}`);
        const [name] = match;
        selectorIndex += offset + name.length;
        return $093d7ffb078d3faf$var$unescapeCSS(name);
    }
    function stripWhitespace(offset) {
        selectorIndex += offset;
        while(selectorIndex < selector.length && $093d7ffb078d3faf$var$isWhitespace(selector.charCodeAt(selectorIndex)))selectorIndex++;
    }
    function readValueWithParenthesis() {
        selectorIndex += 1;
        const start = selectorIndex;
        let counter = 1;
        for(; counter > 0 && selectorIndex < selector.length; selectorIndex++){
            if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  && !isEscaped(selectorIndex)) counter++;
            else if (selector.charCodeAt(selectorIndex) === 41 /* RightParenthesis */  && !isEscaped(selectorIndex)) counter--;
        }
        if (counter) throw new Error("Parenthesis not matched");
        return $093d7ffb078d3faf$var$unescapeCSS(selector.slice(start, selectorIndex - 1));
    }
    function isEscaped(pos) {
        let slashCount = 0;
        while(selector.charCodeAt(--pos) === 92 /* BackSlash */ )slashCount++;
        return (slashCount & 1) === 1;
    }
    function ensureNotTraversal() {
        if (tokens.length > 0 && $093d7ffb078d3faf$export$41d1fe2780697dca(tokens[tokens.length - 1])) throw new Error("Did not expect successive traversals.");
    }
    function addTraversal(type) {
        if (tokens.length > 0 && tokens[tokens.length - 1].type === (0, $9qW55.SelectorType).Descendant) {
            tokens[tokens.length - 1].type = type;
            return;
        }
        ensureNotTraversal();
        tokens.push({
            type: type
        });
    }
    function addSpecialAttribute(name, action) {
        tokens.push({
            type: (0, $9qW55.SelectorType).Attribute,
            name: name,
            action: action,
            value: getName(1),
            namespace: null,
            ignoreCase: "quirks"
        });
    }
    /**
     * We have finished parsing the current part of the selector.
     *
     * Remove descendant tokens at the end if they exist,
     * and return the last index, so that parsing can be
     * picked up from here.
     */ function finalizeSubselector() {
        if (tokens.length && tokens[tokens.length - 1].type === (0, $9qW55.SelectorType).Descendant) tokens.pop();
        if (tokens.length === 0) throw new Error("Empty sub-selector");
        subselects.push(tokens);
    }
    stripWhitespace(0);
    if (selector.length === selectorIndex) return selectorIndex;
    loop: while(selectorIndex < selector.length){
        const firstChar = selector.charCodeAt(selectorIndex);
        switch(firstChar){
            // Whitespace
            case 32 /* Space */ :
            case 9 /* Tab */ :
            case 10 /* NewLine */ :
            case 12 /* FormFeed */ :
            case 13 /* CarriageReturn */ :
                if (tokens.length === 0 || tokens[0].type !== (0, $9qW55.SelectorType).Descendant) {
                    ensureNotTraversal();
                    tokens.push({
                        type: (0, $9qW55.SelectorType).Descendant
                    });
                }
                stripWhitespace(1);
                break;
            // Traversals
            case 62 /* GreaterThan */ :
                addTraversal((0, $9qW55.SelectorType).Child);
                stripWhitespace(1);
                break;
            case 60 /* LessThan */ :
                addTraversal((0, $9qW55.SelectorType).Parent);
                stripWhitespace(1);
                break;
            case 126 /* Tilde */ :
                addTraversal((0, $9qW55.SelectorType).Sibling);
                stripWhitespace(1);
                break;
            case 43 /* Plus */ :
                addTraversal((0, $9qW55.SelectorType).Adjacent);
                stripWhitespace(1);
                break;
            // Special attribute selectors: .class, #id
            case 46 /* Period */ :
                addSpecialAttribute("class", (0, $9qW55.AttributeAction).Element);
                break;
            case 35 /* Hash */ :
                addSpecialAttribute("id", (0, $9qW55.AttributeAction).Equals);
                break;
            case 91 /* LeftSquareBracket */ :
                {
                    stripWhitespace(1);
                    // Determine attribute name and namespace
                    let name;
                    let namespace = null;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ ) // Equivalent to no namespace
                    name = getName(1);
                    else if (selector.startsWith("*|", selectorIndex)) {
                        namespace = "*";
                        name = getName(2);
                    } else {
                        name = getName(0);
                        if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) {
                            namespace = name;
                            name = getName(1);
                        }
                    }
                    stripWhitespace(0);
                    // Determine comparison operation
                    let action = (0, $9qW55.AttributeAction).Exists;
                    const possibleAction = $093d7ffb078d3faf$var$actionTypes.get(selector.charCodeAt(selectorIndex));
                    if (possibleAction) {
                        action = possibleAction;
                        if (selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) throw new Error("Expected `=`");
                        stripWhitespace(2);
                    } else if (selector.charCodeAt(selectorIndex) === 61 /* Equal */ ) {
                        action = (0, $9qW55.AttributeAction).Equals;
                        stripWhitespace(1);
                    }
                    // Determine value
                    let value = "";
                    let ignoreCase = null;
                    if (action !== "exists") {
                        if ($093d7ffb078d3faf$var$isQuote(selector.charCodeAt(selectorIndex))) {
                            const quote = selector.charCodeAt(selectorIndex);
                            let sectionEnd = selectorIndex + 1;
                            while(sectionEnd < selector.length && (selector.charCodeAt(sectionEnd) !== quote || isEscaped(sectionEnd)))sectionEnd += 1;
                            if (selector.charCodeAt(sectionEnd) !== quote) throw new Error("Attribute value didn't end");
                            value = $093d7ffb078d3faf$var$unescapeCSS(selector.slice(selectorIndex + 1, sectionEnd));
                            selectorIndex = sectionEnd + 1;
                        } else {
                            const valueStart = selectorIndex;
                            while(selectorIndex < selector.length && (!$093d7ffb078d3faf$var$isWhitespace(selector.charCodeAt(selectorIndex)) && selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */  || isEscaped(selectorIndex)))selectorIndex += 1;
                            value = $093d7ffb078d3faf$var$unescapeCSS(selector.slice(valueStart, selectorIndex));
                        }
                        stripWhitespace(0);
                        // See if we have a force ignore flag
                        const forceIgnore = selector.charCodeAt(selectorIndex) | 0x20;
                        // If the forceIgnore flag is set (either `i` or `s`), use that value
                        if (forceIgnore === 115 /* LowerS */ ) {
                            ignoreCase = false;
                            stripWhitespace(1);
                        } else if (forceIgnore === 105 /* LowerI */ ) {
                            ignoreCase = true;
                            stripWhitespace(1);
                        }
                    }
                    if (selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */ ) throw new Error("Attribute selector didn't terminate");
                    selectorIndex += 1;
                    const attributeSelector = {
                        type: (0, $9qW55.SelectorType).Attribute,
                        name: name,
                        action: action,
                        value: value,
                        namespace: namespace,
                        ignoreCase: ignoreCase
                    };
                    tokens.push(attributeSelector);
                    break;
                }
            case 58 /* Colon */ :
                {
                    if (selector.charCodeAt(selectorIndex + 1) === 58 /* Colon */ ) {
                        tokens.push({
                            type: (0, $9qW55.SelectorType).PseudoElement,
                            name: getName(2).toLowerCase(),
                            data: selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  ? readValueWithParenthesis() : null
                        });
                        continue;
                    }
                    const name = getName(1).toLowerCase();
                    let data = null;
                    if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */ ) {
                        if ($093d7ffb078d3faf$var$unpackPseudos.has(name)) {
                            if ($093d7ffb078d3faf$var$isQuote(selector.charCodeAt(selectorIndex + 1))) throw new Error(`Pseudo-selector ${name} cannot be quoted`);
                            data = [];
                            selectorIndex = $093d7ffb078d3faf$var$parseSelector(data, selector, selectorIndex + 1);
                            if (selector.charCodeAt(selectorIndex) !== 41 /* RightParenthesis */ ) throw new Error(`Missing closing parenthesis in :${name} (${selector})`);
                            selectorIndex += 1;
                        } else {
                            data = readValueWithParenthesis();
                            if ($093d7ffb078d3faf$var$stripQuotesFromPseudos.has(name)) {
                                const quot = data.charCodeAt(0);
                                if (quot === data.charCodeAt(data.length - 1) && $093d7ffb078d3faf$var$isQuote(quot)) data = data.slice(1, -1);
                            }
                            data = $093d7ffb078d3faf$var$unescapeCSS(data);
                        }
                    }
                    tokens.push({
                        type: (0, $9qW55.SelectorType).Pseudo,
                        name: name,
                        data: data
                    });
                    break;
                }
            case 44 /* Comma */ :
                finalizeSubselector();
                tokens = [];
                stripWhitespace(1);
                break;
            default:
                {
                    if (selector.startsWith("/*", selectorIndex)) {
                        const endIndex = selector.indexOf("*/", selectorIndex + 2);
                        if (endIndex < 0) throw new Error("Comment was not terminated");
                        selectorIndex = endIndex + 2;
                        // Remove leading whitespace
                        if (tokens.length === 0) stripWhitespace(0);
                        break;
                    }
                    let namespace = null;
                    let name;
                    if (firstChar === 42 /* Asterisk */ ) {
                        selectorIndex += 1;
                        name = "*";
                    } else if (firstChar === 124 /* Pipe */ ) {
                        name = "";
                        if (selector.charCodeAt(selectorIndex + 1) === 124 /* Pipe */ ) {
                            addTraversal((0, $9qW55.SelectorType).ColumnCombinator);
                            stripWhitespace(2);
                            break;
                        }
                    } else if ($093d7ffb078d3faf$var$reName.test(selector.slice(selectorIndex))) name = getName(0);
                    else break loop;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 124 /* Pipe */ ) {
                        namespace = name;
                        if (selector.charCodeAt(selectorIndex + 1) === 42 /* Asterisk */ ) {
                            name = "*";
                            selectorIndex += 2;
                        } else name = getName(1);
                    }
                    tokens.push(name === "*" ? {
                        type: (0, $9qW55.SelectorType).Universal,
                        namespace: namespace
                    } : {
                        type: (0, $9qW55.SelectorType).Tag,
                        name: name,
                        namespace: namespace
                    });
                }
        }
    }
    finalizeSubselector();
    return selectorIndex;
}

});
parcelRegister("9qW55", function(module, exports) {

$parcel$export(module.exports, "SelectorType", () => $6de3987936ef985e$export$4e8b093ec8dcab0d);
$parcel$export(module.exports, "AttributeAction", () => $6de3987936ef985e$export$dbc3de62b8fcdc89);
var $6de3987936ef985e$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["Attribute"] = "attribute";
    SelectorType["Pseudo"] = "pseudo";
    SelectorType["PseudoElement"] = "pseudo-element";
    SelectorType["Tag"] = "tag";
    SelectorType["Universal"] = "universal";
    // Traversals
    SelectorType["Adjacent"] = "adjacent";
    SelectorType["Child"] = "child";
    SelectorType["Descendant"] = "descendant";
    SelectorType["Parent"] = "parent";
    SelectorType["Sibling"] = "sibling";
    SelectorType["ColumnCombinator"] = "column-combinator";
})($6de3987936ef985e$export$4e8b093ec8dcab0d || ($6de3987936ef985e$export$4e8b093ec8dcab0d = {}));
const $6de3987936ef985e$export$b378b9ead145a8a4 = {
    Unknown: null,
    QuirksMode: "quirks",
    IgnoreCase: true,
    CaseSensitive: false
};
var $6de3987936ef985e$export$dbc3de62b8fcdc89;
(function(AttributeAction) {
    AttributeAction["Any"] = "any";
    AttributeAction["Element"] = "element";
    AttributeAction["End"] = "end";
    AttributeAction["Equals"] = "equals";
    AttributeAction["Exists"] = "exists";
    AttributeAction["Hyphen"] = "hyphen";
    AttributeAction["Not"] = "not";
    AttributeAction["Start"] = "start";
})($6de3987936ef985e$export$dbc3de62b8fcdc89 || ($6de3987936ef985e$export$dbc3de62b8fcdc89 = {}));

});


parcelRegister("kX9Bh", function(module, exports) {

$parcel$export(module.exports, "_compileToken", () => $f410c3bb47955b9f$export$3ed2edee2e7c5e35);
$parcel$export(module.exports, "prepareContext", () => $f410c3bb47955b9f$export$9c634076e0a91d1f);

var $CeYTB = parcelRequire("CeYTB");

var $eRELI = parcelRequire("eRELI");

var $j6xP2 = parcelRequire("j6xP2");

var $XVVA1 = parcelRequire("XVVA1");
parcelRequire("aMnfa");
var $9X950 = parcelRequire("9X950");
var $aNaTT = parcelRequire("aNaTT");
var $7Ot5E = parcelRequire("7Ot5E");
const $f410c3bb47955b9f$var$defaultEquals = (a, b)=>a === b;
const $f410c3bb47955b9f$var$defaultOptions = {
    adapter: $CeYTB,
    equals: $f410c3bb47955b9f$var$defaultEquals
};
function $f410c3bb47955b9f$var$convertOptionFormats(options) {
    var _a, _b, _c, _d;
    /*
     * We force one format of options to the other one.
     */ // @ts-expect-error Default options may have incompatible `Node` / `ElementNode`.
    const opts = options !== null && options !== void 0 ? options : $f410c3bb47955b9f$var$defaultOptions;
    // @ts-expect-error Same as above.
    (_a = opts.adapter) !== null && _a !== void 0 ? _a : opts.adapter = $CeYTB;
    // @ts-expect-error `equals` does not exist on `Options`
    (_b = opts.equals) !== null && _b !== void 0 ? _b : opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : $f410c3bb47955b9f$var$defaultEquals;
    return opts;
}
function $f410c3bb47955b9f$var$wrapCompile(func) {
    return function addAdapter(selector, options, context) {
        const opts = $f410c3bb47955b9f$var$convertOptionFormats(options);
        return func(selector, opts, context);
    };
}
const $f410c3bb47955b9f$export$ef7acd7185315e22 = $f410c3bb47955b9f$var$wrapCompile((0, $j6xP2.compile));
const $f410c3bb47955b9f$export$ff8dfdd3f753dc11 = $f410c3bb47955b9f$var$wrapCompile((0, $j6xP2.compileUnsafe));
const $f410c3bb47955b9f$export$3ed2edee2e7c5e35 = $f410c3bb47955b9f$var$wrapCompile((0, $j6xP2.compileToken));
function $f410c3bb47955b9f$var$getSelectorFunc(searchFunc) {
    return function select(query, elements, options) {
        const opts = $f410c3bb47955b9f$var$convertOptionFormats(options);
        if (typeof query !== "function") query = (0, $j6xP2.compileUnsafe)(query, opts, elements);
        const filteredElements = $f410c3bb47955b9f$export$9c634076e0a91d1f(elements, opts.adapter, query.shouldTestNextSiblings);
        return searchFunc(query, filteredElements, opts);
    };
}
function $f410c3bb47955b9f$export$9c634076e0a91d1f(elems, adapter, shouldTestNextSiblings = false) {
    /*
     * Add siblings if the query requires them.
     * See https://github.com/fb55/css-select/pull/43#issuecomment-225414692
     */ if (shouldTestNextSiblings) elems = $f410c3bb47955b9f$var$appendNextSiblings(elems, adapter);
    return Array.isArray(elems) ? adapter.removeSubsets(elems) : adapter.getChildren(elems);
}
function $f410c3bb47955b9f$var$appendNextSiblings(elem, adapter) {
    // Order matters because jQuery seems to check the children before the siblings
    const elems = Array.isArray(elem) ? elem.slice(0) : [
        elem
    ];
    const elemsLength = elems.length;
    for(let i = 0; i < elemsLength; i++){
        const nextSiblings = (0, $XVVA1.getNextSiblings)(elems[i], adapter);
        elems.push(...nextSiblings);
    }
    return elems;
}
const $f410c3bb47955b9f$export$90aca4adda6ff0f5 = $f410c3bb47955b9f$var$getSelectorFunc((query, elems, options)=>query === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc || !elems || elems.length === 0 ? [] : options.adapter.findAll(query, elems));
const $f410c3bb47955b9f$export$9633ae49ba77655e = $f410c3bb47955b9f$var$getSelectorFunc((query, elems, options)=>query === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc || !elems || elems.length === 0 ? null : options.adapter.findOne(query, elems));
function $f410c3bb47955b9f$export$226b3eccf92c9ed9(elem, query, options) {
    const opts = $f410c3bb47955b9f$var$convertOptionFormats(options);
    return (typeof query === "function" ? query : (0, $j6xP2.compile)(query, opts))(elem);
}
var /**
 * Alias for selectAll(query, elems, options).
 * @see [compile] for supported selector queries.
 */ $f410c3bb47955b9f$export$2e2bcd8739ae039 = $f410c3bb47955b9f$export$90aca4adda6ff0f5;

});
parcelRegister("eRELI", function(module, exports) {
module.exports = {
    trueFunc: function trueFunc() {
        return true;
    },
    falseFunc: function falseFunc() {
        return false;
    }
};

});

parcelRegister("j6xP2", function(module, exports) {

$parcel$export(module.exports, "compile", () => $de88d041f0c89979$export$ef7acd7185315e22);
$parcel$export(module.exports, "compileUnsafe", () => $de88d041f0c89979$export$bbd36b99ab1dd6af);
$parcel$export(module.exports, "compileToken", () => $de88d041f0c89979$export$9ac76eb524b317ec);

var $Nbvfz = parcelRequire("Nbvfz");
var $9qW55 = parcelRequire("9qW55");

var $eRELI = parcelRequire("eRELI");

var $aIsUZ = parcelRequire("aIsUZ");

var $1ONRA = parcelRequire("1ONRA");

var $XVVA1 = parcelRequire("XVVA1");
function $de88d041f0c89979$export$ef7acd7185315e22(selector, options, context) {
    const next = $de88d041f0c89979$export$bbd36b99ab1dd6af(selector, options, context);
    return (0, $XVVA1.ensureIsTag)(next, options.adapter);
}
function $de88d041f0c89979$export$bbd36b99ab1dd6af(selector, options, context) {
    const token = typeof selector === "string" ? (0, $Nbvfz.parse)(selector) : selector;
    return $de88d041f0c89979$export$9ac76eb524b317ec(token, options, context);
}
function $de88d041f0c89979$var$includesScopePseudo(t) {
    return t.type === (0, $9qW55.SelectorType).Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some((data)=>data.some($de88d041f0c89979$var$includesScopePseudo)));
}
const $de88d041f0c89979$var$DESCENDANT_TOKEN = {
    type: (0, $9qW55.SelectorType).Descendant
};
const $de88d041f0c89979$var$FLEXIBLE_DESCENDANT_TOKEN = {
    type: "_flexibleDescendant"
};
const $de88d041f0c89979$var$SCOPE_TOKEN = {
    type: (0, $9qW55.SelectorType).Pseudo,
    name: "scope",
    data: null
};
/*
 * CSS 4 Spec (Draft): 3.4.1. Absolutizing a Relative Selector
 * http://www.w3.org/TR/selectors4/#absolutizing
 */ function $de88d041f0c89979$var$absolutize(token, { adapter: adapter }, context) {
    // TODO Use better check if the context is a document
    const hasContext = !!(context === null || context === void 0 ? void 0 : context.every((e)=>{
        const parent = adapter.isTag(e) && adapter.getParent(e);
        return e === (0, $XVVA1.PLACEHOLDER_ELEMENT) || parent && adapter.isTag(parent);
    }));
    for (const t of token){
        if (t.length > 0 && (0, $aIsUZ.isTraversal)(t[0]) && t[0].type !== (0, $9qW55.SelectorType).Descendant) ;
        else if (hasContext && !t.some($de88d041f0c89979$var$includesScopePseudo)) t.unshift($de88d041f0c89979$var$DESCENDANT_TOKEN);
        else continue;
        t.unshift($de88d041f0c89979$var$SCOPE_TOKEN);
    }
}
function $de88d041f0c89979$export$9ac76eb524b317ec(token, options, context) {
    var _a;
    token.forEach((0, $aIsUZ.default));
    context = (_a = options.context) !== null && _a !== void 0 ? _a : context;
    const isArrayContext = Array.isArray(context);
    const finalContext = context && (Array.isArray(context) ? context : [
        context
    ]);
    // Check if the selector is relative
    if (options.relativeSelector !== false) $de88d041f0c89979$var$absolutize(token, options, finalContext);
    else if (token.some((t)=>t.length > 0 && (0, $aIsUZ.isTraversal)(t[0]))) throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
    let shouldTestNextSiblings = false;
    const query = token.map((rules)=>{
        if (rules.length >= 2) {
            const [first, second] = rules;
            if (first.type !== (0, $9qW55.SelectorType).Pseudo || first.name !== "scope") ;
            else if (isArrayContext && second.type === (0, $9qW55.SelectorType).Descendant) rules[1] = $de88d041f0c89979$var$FLEXIBLE_DESCENDANT_TOKEN;
            else if (second.type === (0, $9qW55.SelectorType).Adjacent || second.type === (0, $9qW55.SelectorType).Sibling) shouldTestNextSiblings = true;
        }
        return $de88d041f0c89979$var$compileRules(rules, options, finalContext);
    }).reduce($de88d041f0c89979$var$reduceRules, (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc);
    query.shouldTestNextSiblings = shouldTestNextSiblings;
    return query;
}
function $de88d041f0c89979$var$compileRules(rules, options, context) {
    var _a;
    return rules.reduce((previous, rule)=>previous === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc ? (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc : (0, $1ONRA.compileGeneralSelector)(previous, rule, options, context, $de88d041f0c89979$export$9ac76eb524b317ec), (_a = options.rootFunc) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc);
}
function $de88d041f0c89979$var$reduceRules(a, b) {
    if (b === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc || a === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) return a;
    if (a === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc || b === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) return b;
    return function combine(elem) {
        return a(elem) || b(elem);
    };
}

});
parcelRegister("aIsUZ", function(module, exports) {

$parcel$export(module.exports, "isTraversal", () => $7cd471faad23c8d0$export$41d1fe2780697dca);
$parcel$export(module.exports, "default", () => $7cd471faad23c8d0$export$2e2bcd8739ae039);

var $9qW55 = parcelRequire("9qW55");
const $7cd471faad23c8d0$var$procedure = new Map([
    [
        (0, $9qW55.SelectorType).Universal,
        50
    ],
    [
        (0, $9qW55.SelectorType).Tag,
        30
    ],
    [
        (0, $9qW55.SelectorType).Attribute,
        1
    ],
    [
        (0, $9qW55.SelectorType).Pseudo,
        0
    ]
]);
function $7cd471faad23c8d0$export$41d1fe2780697dca(token) {
    return !$7cd471faad23c8d0$var$procedure.has(token.type);
}
const $7cd471faad23c8d0$var$attributes = new Map([
    [
        (0, $9qW55.AttributeAction).Exists,
        10
    ],
    [
        (0, $9qW55.AttributeAction).Equals,
        8
    ],
    [
        (0, $9qW55.AttributeAction).Not,
        7
    ],
    [
        (0, $9qW55.AttributeAction).Start,
        6
    ],
    [
        (0, $9qW55.AttributeAction).End,
        6
    ],
    [
        (0, $9qW55.AttributeAction).Any,
        5
    ]
]);
function $7cd471faad23c8d0$export$2e2bcd8739ae039(arr) {
    const procs = arr.map($7cd471faad23c8d0$var$getProcedure);
    for(let i = 1; i < arr.length; i++){
        const procNew = procs[i];
        if (procNew < 0) continue;
        for(let j = i - 1; j >= 0 && procNew < procs[j]; j--){
            const token = arr[j + 1];
            arr[j + 1] = arr[j];
            arr[j] = token;
            procs[j + 1] = procs[j];
            procs[j] = procNew;
        }
    }
}
function $7cd471faad23c8d0$var$getProcedure(token) {
    var _a, _b;
    let proc = (_a = $7cd471faad23c8d0$var$procedure.get(token.type)) !== null && _a !== void 0 ? _a : -1;
    if (token.type === (0, $9qW55.SelectorType).Attribute) {
        proc = (_b = $7cd471faad23c8d0$var$attributes.get(token.action)) !== null && _b !== void 0 ? _b : 4;
        if (token.action === (0, $9qW55.AttributeAction).Equals && token.name === "id") // Prefer ID selectors (eg. #ID)
        proc = 9;
        if (token.ignoreCase) /*
             * IgnoreCase adds some overhead, prefer "normal" token
             * this is a binary operation, to ensure it's still an int
             */ proc >>= 1;
    } else if (token.type === (0, $9qW55.SelectorType).Pseudo) {
        if (!token.data) proc = 3;
        else if (token.name === "has" || token.name === "contains") proc = 0; // Expensive in any case
        else if (Array.isArray(token.data)) {
            // Eg. :matches, :not
            proc = Math.min(...token.data.map((d)=>Math.min(...d.map($7cd471faad23c8d0$var$getProcedure))));
            // If we have traversals, try to avoid executing this selector
            if (proc < 0) proc = 0;
        } else proc = 2;
    }
    return proc;
}

});

parcelRegister("1ONRA", function(module, exports) {

$parcel$export(module.exports, "compileGeneralSelector", () => $153123c67a28bf54$export$afd2165e507ce8c5);

var $35ulQ = parcelRequire("35ulQ");

var $aMnfa = parcelRequire("aMnfa");

var $9qW55 = parcelRequire("9qW55");
function $153123c67a28bf54$var$getElementParent(node, adapter) {
    const parent = adapter.getParent(node);
    if (parent && adapter.isTag(parent)) return parent;
    return null;
}
function $153123c67a28bf54$export$afd2165e507ce8c5(next, selector, options, context, compileToken) {
    const { adapter: adapter, equals: equals } = options;
    switch(selector.type){
        case (0, $9qW55.SelectorType).PseudoElement:
            throw new Error("Pseudo-elements are not supported by css-select");
        case (0, $9qW55.SelectorType).ColumnCombinator:
            throw new Error("Column combinators are not yet supported by css-select");
        case (0, $9qW55.SelectorType).Attribute:
            if (selector.namespace != null) throw new Error("Namespaced attributes are not yet supported by css-select");
            if (!options.xmlMode || options.lowerCaseAttributeNames) selector.name = selector.name.toLowerCase();
            return (0, $35ulQ.attributeRules)[selector.action](next, selector, options);
        case (0, $9qW55.SelectorType).Pseudo:
            return (0, $aMnfa.compilePseudoSelector)(next, selector, options, context, compileToken);
        // Tags
        case (0, $9qW55.SelectorType).Tag:
            {
                if (selector.namespace != null) throw new Error("Namespaced tag names are not yet supported by css-select");
                let { name: name } = selector;
                if (!options.xmlMode || options.lowerCaseTags) name = name.toLowerCase();
                return function tag(elem) {
                    return adapter.getName(elem) === name && next(elem);
                };
            }
        // Traversal
        case (0, $9qW55.SelectorType).Descendant:
            {
                if (options.cacheResults === false || typeof WeakSet === "undefined") return function descendant(elem) {
                    let current = elem;
                    while(current = $153123c67a28bf54$var$getElementParent(current, adapter)){
                        if (next(current)) return true;
                    }
                    return false;
                };
                // @ts-expect-error `ElementNode` is not extending object
                const isFalseCache = new WeakSet();
                return function cachedDescendant(elem) {
                    let current = elem;
                    while(current = $153123c67a28bf54$var$getElementParent(current, adapter))if (!isFalseCache.has(current)) {
                        if (adapter.isTag(current) && next(current)) return true;
                        isFalseCache.add(current);
                    }
                    return false;
                };
            }
        case "_flexibleDescendant":
            // Include element itself, only used while querying an array
            return function flexibleDescendant(elem) {
                let current = elem;
                do {
                    if (next(current)) return true;
                }while (current = $153123c67a28bf54$var$getElementParent(current, adapter));
                return false;
            };
        case (0, $9qW55.SelectorType).Parent:
            return function parent(elem) {
                return adapter.getChildren(elem).some((elem)=>adapter.isTag(elem) && next(elem));
            };
        case (0, $9qW55.SelectorType).Child:
            return function child(elem) {
                const parent = adapter.getParent(elem);
                return parent != null && adapter.isTag(parent) && next(parent);
            };
        case (0, $9qW55.SelectorType).Sibling:
            return function sibling(elem) {
                const siblings = adapter.getSiblings(elem);
                for(let i = 0; i < siblings.length; i++){
                    const currentSibling = siblings[i];
                    if (equals(elem, currentSibling)) break;
                    if (adapter.isTag(currentSibling) && next(currentSibling)) return true;
                }
                return false;
            };
        case (0, $9qW55.SelectorType).Adjacent:
            if (adapter.prevElementSibling) return function adjacent(elem) {
                const previous = adapter.prevElementSibling(elem);
                return previous != null && next(previous);
            };
            return function adjacent(elem) {
                const siblings = adapter.getSiblings(elem);
                let lastElement;
                for(let i = 0; i < siblings.length; i++){
                    const currentSibling = siblings[i];
                    if (equals(elem, currentSibling)) break;
                    if (adapter.isTag(currentSibling)) lastElement = currentSibling;
                }
                return !!lastElement && next(lastElement);
            };
        case (0, $9qW55.SelectorType).Universal:
            if (selector.namespace != null && selector.namespace !== "*") throw new Error("Namespaced universal selectors are not yet supported by css-select");
            return next;
    }
}

});
parcelRegister("35ulQ", function(module, exports) {

$parcel$export(module.exports, "attributeRules", () => $23f961d93aca4e45$export$ebf1ecb9197f27e);

var $eRELI = parcelRequire("eRELI");
/**
 * All reserved characters in a regex, used for escaping.
 *
 * Taken from XRegExp, (c) 2007-2020 Steven Levithan under the MIT license
 * https://github.com/slevithan/xregexp/blob/95eeebeb8fac8754d54eafe2b4743661ac1cf028/src/xregexp.js#L794
 */ const $23f961d93aca4e45$var$reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
function $23f961d93aca4e45$var$escapeRegex(value) {
    return value.replace($23f961d93aca4e45$var$reChars, "\\$&");
}
/**
 * Attributes that are case-insensitive in HTML.
 *
 * @private
 * @see https://html.spec.whatwg.org/multipage/semantics-other.html#case-sensitivity-of-selectors
 */ const $23f961d93aca4e45$var$caseInsensitiveAttributes = new Set([
    "accept",
    "accept-charset",
    "align",
    "alink",
    "axis",
    "bgcolor",
    "charset",
    "checked",
    "clear",
    "codetype",
    "color",
    "compact",
    "declare",
    "defer",
    "dir",
    "direction",
    "disabled",
    "enctype",
    "face",
    "frame",
    "hreflang",
    "http-equiv",
    "lang",
    "language",
    "link",
    "media",
    "method",
    "multiple",
    "nohref",
    "noresize",
    "noshade",
    "nowrap",
    "readonly",
    "rel",
    "rev",
    "rules",
    "scope",
    "scrolling",
    "selected",
    "shape",
    "target",
    "text",
    "type",
    "valign",
    "valuetype",
    "vlink"
]);
function $23f961d93aca4e45$var$shouldIgnoreCase(selector, options) {
    return typeof selector.ignoreCase === "boolean" ? selector.ignoreCase : selector.ignoreCase === "quirks" ? !!options.quirksMode : !options.xmlMode && $23f961d93aca4e45$var$caseInsensitiveAttributes.has(selector.name);
}
const $23f961d93aca4e45$export$ebf1ecb9197f27e = {
    equals (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        if ($23f961d93aca4e45$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length === value.length && attr.toLowerCase() === value && next(elem);
            };
        }
        return (elem)=>adapter.getAttributeValue(elem, name) === value && next(elem);
    },
    hyphen (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        const len = value.length;
        if ($23f961d93aca4e45$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function hyphenIC(elem) {
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len).toLowerCase() === value && next(elem);
            };
        }
        return function hyphen(elem) {
            const attr = adapter.getAttributeValue(elem, name);
            return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len) === value && next(elem);
        };
    },
    element (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name, value: value } = data;
        if (/\s/.test(value)) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        const regex = new RegExp(`(?:^|\\s)${$23f961d93aca4e45$var$escapeRegex(value)}(?:$|\\s)`, $23f961d93aca4e45$var$shouldIgnoreCase(data, options) ? "i" : "");
        return function element(elem) {
            const attr = adapter.getAttributeValue(elem, name);
            return attr != null && attr.length >= value.length && regex.test(attr) && next(elem);
        };
    },
    exists (next, { name: name }, { adapter: adapter }) {
        return (elem)=>adapter.hasAttrib(elem, name) && next(elem);
    },
    start (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        const len = value.length;
        if (len === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if ($23f961d93aca4e45$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length >= len && attr.substr(0, len).toLowerCase() === value && next(elem);
            };
        }
        return (elem)=>{
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value)) && next(elem);
        };
    },
    end (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        const len = -value.length;
        if (len === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if ($23f961d93aca4e45$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                var _a;
                return ((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value && next(elem);
            };
        }
        return (elem)=>{
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value)) && next(elem);
        };
    },
    any (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name, value: value } = data;
        if (value === "") return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if ($23f961d93aca4e45$var$shouldIgnoreCase(data, options)) {
            const regex = new RegExp($23f961d93aca4e45$var$escapeRegex(value), "i");
            return function anyIC(elem) {
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length >= value.length && regex.test(attr) && next(elem);
            };
        }
        return (elem)=>{
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value)) && next(elem);
        };
    },
    not (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        if (value === "") return (elem)=>!!adapter.getAttributeValue(elem, name) && next(elem);
        else if ($23f961d93aca4e45$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                const attr = adapter.getAttributeValue(elem, name);
                return (attr == null || attr.length !== value.length || attr.toLowerCase() !== value) && next(elem);
            };
        }
        return (elem)=>adapter.getAttributeValue(elem, name) !== value && next(elem);
    }
};

});

parcelRegister("aMnfa", function(module, exports) {

$parcel$export(module.exports, "compilePseudoSelector", () => $7d906ac18899cb97$export$1a67b9bcd42231f5);

var $Nbvfz = parcelRequire("Nbvfz");

var $9X950 = parcelRequire("9X950");

var $aNaTT = parcelRequire("aNaTT");

var $7Ot5E = parcelRequire("7Ot5E");

var $XVVA1 = parcelRequire("XVVA1");
function $7d906ac18899cb97$export$1a67b9bcd42231f5(next, selector, options, context, compileToken) {
    var _a;
    const { name: name, data: data } = selector;
    if (Array.isArray(data)) {
        if (!(name in (0, $XVVA1.subselects))) throw new Error(`Unknown pseudo-class :${name}(${data})`);
        return (0, $XVVA1.subselects)[name](next, data, options, context, compileToken);
    }
    const userPseudo = (_a = options.pseudos) === null || _a === void 0 ? void 0 : _a[name];
    const stringPseudo = typeof userPseudo === "string" ? userPseudo : (0, $7Ot5E.aliases)[name];
    if (typeof stringPseudo === "string") {
        if (data != null) throw new Error(`Pseudo ${name} doesn't have any arguments`);
        // The alias has to be parsed here, to make sure options are respected.
        const alias = (0, $Nbvfz.parse)(stringPseudo);
        return (0, $XVVA1.subselects)["is"](next, alias, options, context, compileToken);
    }
    if (typeof userPseudo === "function") {
        (0, $aNaTT.verifyPseudoArgs)(userPseudo, name, data, 1);
        return (elem)=>userPseudo(elem, data) && next(elem);
    }
    if (name in (0, $9X950.filters)) return (0, $9X950.filters)[name](next, data, options, context);
    if (name in (0, $aNaTT.pseudos)) {
        const pseudo = (0, $aNaTT.pseudos)[name];
        (0, $aNaTT.verifyPseudoArgs)(pseudo, name, data, 2);
        return (elem)=>pseudo(elem, options, data) && next(elem);
    }
    throw new Error(`Unknown pseudo-class :${name}`);
}

});
parcelRegister("9X950", function(module, exports) {

$parcel$export(module.exports, "filters", () => $73f0aac9eef44ea3$export$82462a21aead86ed);

var $4BLVt = parcelRequire("4BLVt");

var $eRELI = parcelRequire("eRELI");
function $73f0aac9eef44ea3$var$getChildFunc(next, adapter) {
    return (elem)=>{
        const parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(elem);
    };
}
const $73f0aac9eef44ea3$export$82462a21aead86ed = {
    contains (next, text, { adapter: adapter }) {
        return function contains(elem) {
            return next(elem) && adapter.getText(elem).includes(text);
        };
    },
    icontains (next, text, { adapter: adapter }) {
        const itext = text.toLowerCase();
        return function icontains(elem) {
            return next(elem) && adapter.getText(elem).toLowerCase().includes(itext);
        };
    },
    // Location specific methods
    "nth-child" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $4BLVt.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) return $73f0aac9eef44ea3$var$getChildFunc(next, adapter);
        return function nthChild(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = 0; i < siblings.length; i++){
                if (equals(elem, siblings[i])) break;
                if (adapter.isTag(siblings[i])) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-child" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $4BLVt.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) return $73f0aac9eef44ea3$var$getChildFunc(next, adapter);
        return function nthLastChild(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = siblings.length - 1; i >= 0; i--){
                if (equals(elem, siblings[i])) break;
                if (adapter.isTag(siblings[i])) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-of-type" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $4BLVt.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) return $73f0aac9eef44ea3$var$getChildFunc(next, adapter);
        return function nthOfType(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = 0; i < siblings.length; i++){
                const currentSibling = siblings[i];
                if (equals(elem, currentSibling)) break;
                if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-of-type" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $4BLVt.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) return $73f0aac9eef44ea3$var$getChildFunc(next, adapter);
        return function nthLastOfType(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = siblings.length - 1; i >= 0; i--){
                const currentSibling = siblings[i];
                if (equals(elem, currentSibling)) break;
                if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    // TODO determine the actual root element
    root (next, _rule, { adapter: adapter }) {
        return (elem)=>{
            const parent = adapter.getParent(elem);
            return (parent == null || !adapter.isTag(parent)) && next(elem);
        };
    },
    scope (next, rule, options, context) {
        const { equals: equals } = options;
        if (!context || context.length === 0) // Equivalent to :root
        return $73f0aac9eef44ea3$export$82462a21aead86ed["root"](next, rule, options);
        if (context.length === 1) // NOTE: can't be unpacked, as :has uses this for side-effects
        return (elem)=>equals(context[0], elem) && next(elem);
        return (elem)=>context.includes(elem) && next(elem);
    },
    hover: $73f0aac9eef44ea3$var$dynamicStatePseudo("isHovered"),
    visited: $73f0aac9eef44ea3$var$dynamicStatePseudo("isVisited"),
    active: $73f0aac9eef44ea3$var$dynamicStatePseudo("isActive")
};
/**
 * Dynamic state pseudos. These depend on optional Adapter methods.
 *
 * @param name The name of the adapter method to call.
 * @returns Pseudo for the `filters` object.
 */ function $73f0aac9eef44ea3$var$dynamicStatePseudo(name) {
    return function dynamicPseudo(next, _rule, { adapter: adapter }) {
        const func = adapter[name];
        if (typeof func !== "function") return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        return function active(elem) {
            return func(elem) && next(elem);
        };
    };
}

});
parcelRegister("4BLVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $35afcb4041d84e02$export$2e2bcd8739ae039);

var $aMjnU = parcelRequire("aMjnU");

var $39u21 = parcelRequire("39u21");
function $35afcb4041d84e02$export$2e2bcd8739ae039(formula) {
    return (0, $39u21.compile)((0, $aMjnU.parse)(formula));
}
function $35afcb4041d84e02$export$49bb65c2ea163039(formula) {
    return (0, $39u21.generate)((0, $aMjnU.parse)(formula));
}

});
parcelRegister("aMjnU", function(module, exports) {

$parcel$export(module.exports, "parse", () => $7d8d6c745cb85c4e$export$98e6a39c04603d36);
// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
const $7d8d6c745cb85c4e$var$whitespace = new Set([
    9,
    10,
    12,
    13,
    32
]);
const $7d8d6c745cb85c4e$var$ZERO = "0".charCodeAt(0);
const $7d8d6c745cb85c4e$var$NINE = "9".charCodeAt(0);
function $7d8d6c745cb85c4e$export$98e6a39c04603d36(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") return [
        2,
        0
    ];
    else if (formula === "odd") return [
        2,
        1
    ];
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    let idx = 0;
    let a = 0;
    let sign = readSign();
    let number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        } else sign = number = 0;
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) throw new Error(`n-th rule couldn't be parsed ('${formula}')`);
    return [
        a,
        sign * number
    ];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") idx++;
        return 1;
    }
    function readNumber() {
        const start = idx;
        let value = 0;
        while(idx < formula.length && formula.charCodeAt(idx) >= $7d8d6c745cb85c4e$var$ZERO && formula.charCodeAt(idx) <= $7d8d6c745cb85c4e$var$NINE){
            value = value * 10 + (formula.charCodeAt(idx) - $7d8d6c745cb85c4e$var$ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while(idx < formula.length && $7d8d6c745cb85c4e$var$whitespace.has(formula.charCodeAt(idx)))idx++;
    }
}

});

parcelRegister("39u21", function(module, exports) {

$parcel$export(module.exports, "compile", () => $24b98207e0a42e86$export$ef7acd7185315e22);
$parcel$export(module.exports, "generate", () => $24b98207e0a42e86$export$80d376111cc09ad7);

var $eRELI = parcelRequire("eRELI");
function $24b98207e0a42e86$export$ef7acd7185315e22(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    const b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */ if (b < 0 && a <= 0) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1) return (index)=>index <= b;
    if (a === 0) return (index)=>index === b;
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1) return b < 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc : (index)=>index >= b;
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */ const absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    const bMod = (b % absA + absA) % absA;
    return a > 1 ? (index)=>index >= b && index % absA === bMod : (index)=>index <= b && index % absA === bMod;
}
function $24b98207e0a42e86$export$80d376111cc09ad7(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    let b = parsed[1] - 1;
    let n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        const aPos = -a;
        // Get `b mod a`
        const minValue = (b % aPos + aPos) % aPos;
        return ()=>{
            const val = minValue + aPos * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0) return b < 0 ? ()=>null : ()=>n++ === 0 ? b : null;
    if (b < 0) b += a * Math.ceil(-b / a);
    return ()=>a * n++ + b;
}

});



parcelRegister("aNaTT", function(module, exports) {

$parcel$export(module.exports, "pseudos", () => $7db6ef9e5e533fe0$export$8dc723548151ed12);
$parcel$export(module.exports, "verifyPseudoArgs", () => $7db6ef9e5e533fe0$export$d62f7d28fa725e36);
// While filters are precompiled, pseudos get called when they are needed
const $7db6ef9e5e533fe0$export$8dc723548151ed12 = {
    empty (elem, { adapter: adapter }) {
        return !adapter.getChildren(elem).some((elem)=>// FIXME: `getText` call is potentially expensive.
            adapter.isTag(elem) || adapter.getText(elem) !== "");
    },
    "first-child" (elem, { adapter: adapter, equals: equals }) {
        if (adapter.prevElementSibling) return adapter.prevElementSibling(elem) == null;
        const firstChild = adapter.getSiblings(elem).find((elem)=>adapter.isTag(elem));
        return firstChild != null && equals(elem, firstChild);
    },
    "last-child" (elem, { adapter: adapter, equals: equals }) {
        const siblings = adapter.getSiblings(elem);
        for(let i = siblings.length - 1; i >= 0; i--){
            if (equals(elem, siblings[i])) return true;
            if (adapter.isTag(siblings[i])) break;
        }
        return false;
    },
    "first-of-type" (elem, { adapter: adapter, equals: equals }) {
        const siblings = adapter.getSiblings(elem);
        const elemName = adapter.getName(elem);
        for(let i = 0; i < siblings.length; i++){
            const currentSibling = siblings[i];
            if (equals(elem, currentSibling)) return true;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) break;
        }
        return false;
    },
    "last-of-type" (elem, { adapter: adapter, equals: equals }) {
        const siblings = adapter.getSiblings(elem);
        const elemName = adapter.getName(elem);
        for(let i = siblings.length - 1; i >= 0; i--){
            const currentSibling = siblings[i];
            if (equals(elem, currentSibling)) return true;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) break;
        }
        return false;
    },
    "only-of-type" (elem, { adapter: adapter, equals: equals }) {
        const elemName = adapter.getName(elem);
        return adapter.getSiblings(elem).every((sibling)=>equals(elem, sibling) || !adapter.isTag(sibling) || adapter.getName(sibling) !== elemName);
    },
    "only-child" (elem, { adapter: adapter, equals: equals }) {
        return adapter.getSiblings(elem).every((sibling)=>equals(elem, sibling) || !adapter.isTag(sibling));
    }
};
function $7db6ef9e5e533fe0$export$d62f7d28fa725e36(func, name, subselect, argIndex) {
    if (subselect === null) {
        if (func.length > argIndex) throw new Error(`Pseudo-class :${name} requires an argument`);
    } else if (func.length === argIndex) throw new Error(`Pseudo-class :${name} doesn't have any arguments`);
}

});

parcelRegister("7Ot5E", function(module, exports) {

$parcel$export(module.exports, "aliases", () => $5b03c4a18b37e361$export$9af93bb9e9126a2);
/**
 * Aliases are pseudos that are expressed as selectors.
 */ const $5b03c4a18b37e361$export$9af93bb9e9126a2 = {
    // Links
    "any-link": ":is(a, area, link)[href]",
    link: ":any-link:not(:visited)",
    // Forms
    // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
    disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
    enabled: ":not(:disabled)",
    checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
    required: ":is(input, select, textarea)[required]",
    optional: ":is(input, select, textarea):not([required])",
    // JQuery extensions
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
    selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
    checkbox: "[type=checkbox]",
    file: "[type=file]",
    password: "[type=password]",
    radio: "[type=radio]",
    reset: "[type=reset]",
    image: "[type=image]",
    submit: "[type=submit]",
    parent: ":not(:empty)",
    header: ":is(h1, h2, h3, h4, h5, h6)",
    button: ":is(button, input[type=button])",
    input: ":is(input, textarea, select, button)",
    text: "input:is(:not([type!='']), [type=text])"
};

});

parcelRegister("XVVA1", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDER_ELEMENT", () => $0b42720a09cf7c92$export$f2f25fe26aaee026);
$parcel$export(module.exports, "ensureIsTag", () => $0b42720a09cf7c92$export$a48279061b25ff7);
$parcel$export(module.exports, "getNextSiblings", () => $0b42720a09cf7c92$export$8666503a05bdce46);
$parcel$export(module.exports, "subselects", () => $0b42720a09cf7c92$export$f3666d140abaf082);

var $eRELI = parcelRequire("eRELI");

var $aIsUZ = parcelRequire("aIsUZ");
const $0b42720a09cf7c92$export$f2f25fe26aaee026 = {};
function $0b42720a09cf7c92$export$a48279061b25ff7(next, adapter) {
    if (next === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
    return (elem)=>adapter.isTag(elem) && next(elem);
}
function $0b42720a09cf7c92$export$8666503a05bdce46(elem, adapter) {
    const siblings = adapter.getSiblings(elem);
    if (siblings.length <= 1) return [];
    const elemIndex = siblings.indexOf(elem);
    if (elemIndex < 0 || elemIndex === siblings.length - 1) return [];
    return siblings.slice(elemIndex + 1).filter(adapter.isTag);
}
function $0b42720a09cf7c92$var$copyOptions(options) {
    // Not copied: context, rootFunc
    return {
        xmlMode: !!options.xmlMode,
        lowerCaseAttributeNames: !!options.lowerCaseAttributeNames,
        lowerCaseTags: !!options.lowerCaseTags,
        quirksMode: !!options.quirksMode,
        cacheResults: !!options.cacheResults,
        pseudos: options.pseudos,
        adapter: options.adapter,
        equals: options.equals
    };
}
const $0b42720a09cf7c92$var$is = (next, token, options, context, compileToken)=>{
    const func = compileToken(token, $0b42720a09cf7c92$var$copyOptions(options), context);
    return func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc ? next : func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc ? (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc : (elem)=>func(elem) && next(elem);
};
const $0b42720a09cf7c92$export$f3666d140abaf082 = {
    is: $0b42720a09cf7c92$var$is,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */ matches: $0b42720a09cf7c92$var$is,
    where: $0b42720a09cf7c92$var$is,
    not (next, token, options, context, compileToken) {
        const func = compileToken(token, $0b42720a09cf7c92$var$copyOptions(options), context);
        return func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc ? next : func === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc ? (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc : (elem)=>!func(elem) && next(elem);
    },
    has (next, subselect, options, _context, compileToken) {
        const { adapter: adapter } = options;
        const opts = $0b42720a09cf7c92$var$copyOptions(options);
        opts.relativeSelector = true;
        const context = subselect.some((s)=>s.some((0, $aIsUZ.isTraversal))) ? [
            $0b42720a09cf7c92$export$f2f25fe26aaee026
        ] : undefined;
        const compiled = compileToken(subselect, opts, context);
        if (compiled === (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).falseFunc;
        const hasElement = $0b42720a09cf7c92$export$a48279061b25ff7(compiled, adapter);
        // If `compiled` is `trueFunc`, we can skip this.
        if (context && compiled !== (0, (/*@__PURE__*/$parcel$interopDefault($eRELI))).trueFunc) {
            /*
             * `shouldTestNextSiblings` will only be true if the query starts with
             * a traversal (sibling or adjacent). That means we will always have a context.
             */ const { shouldTestNextSiblings: shouldTestNextSiblings = false } = compiled;
            return (elem)=>{
                if (!next(elem)) return false;
                context[0] = elem;
                const childs = adapter.getChildren(elem);
                const nextElements = shouldTestNextSiblings ? [
                    ...childs,
                    ...$0b42720a09cf7c92$export$8666503a05bdce46(elem, adapter)
                ] : childs;
                return adapter.existsOne(hasElement, nextElements);
            };
        }
        return (elem)=>next(elem) && adapter.existsOne(hasElement, adapter.getChildren(elem));
    }
};

});





parcelRegister("dQF0N", function(module, exports) {

$parcel$export(module.exports, "getDocumentRoot", () => $a14ff1cb26f79621$export$6492b66915332185);
$parcel$export(module.exports, "groupSelectors", () => $a14ff1cb26f79621$export$12837f7a14c656c9);

var $Hc8DK = parcelRequire("Hc8DK");
function $a14ff1cb26f79621$export$6492b66915332185(node) {
    while(node.parent)node = node.parent;
    return node;
}
function $a14ff1cb26f79621$export$12837f7a14c656c9(selectors) {
    const filteredSelectors = [];
    const plainSelectors = [];
    for (const selector of selectors)if (selector.some((0, $Hc8DK.isFilter))) filteredSelectors.push(selector);
    else plainSelectors.push(selector);
    return [
        plainSelectors,
        filteredSelectors
    ];
}

});
parcelRegister("Hc8DK", function(module, exports) {

$parcel$export(module.exports, "isFilter", () => $081d6eb11a64f3f7$export$b169a94581f05ec);
$parcel$export(module.exports, "getLimit", () => $081d6eb11a64f3f7$export$fb8ce379717a383d);
const $081d6eb11a64f3f7$export$899efafbba5f734f = new Set([
    "first",
    "last",
    "eq",
    "gt",
    "nth",
    "lt",
    "even",
    "odd"
]);
function $081d6eb11a64f3f7$export$b169a94581f05ec(s) {
    if (s.type !== "pseudo") return false;
    if ($081d6eb11a64f3f7$export$899efafbba5f734f.has(s.name)) return true;
    if (s.name === "not" && Array.isArray(s.data)) // Only consider `:not` with embedded filters
    return s.data.some((s)=>s.some($081d6eb11a64f3f7$export$b169a94581f05ec));
    return false;
}
function $081d6eb11a64f3f7$export$fb8ce379717a383d(filter, data, partLimit) {
    const num = data != null ? parseInt(data, 10) : NaN;
    switch(filter){
        case "first":
            return 1;
        case "nth":
        case "eq":
            return isFinite(num) ? num >= 0 ? num + 1 : Infinity : 0;
        case "lt":
            return isFinite(num) ? num >= 0 ? Math.min(num, partLimit) : Infinity : 0;
        case "gt":
            return isFinite(num) ? Infinity : 0;
        case "odd":
            return 2 * partLimit;
        case "even":
            return 2 * partLimit - 1;
        case "last":
        case "not":
            return Infinity;
    }
}

});




parcelRegister("g9e7m", function(module, exports) {

$parcel$export(module.exports, "_makeDomArray", () => _makeDomArray);
$parcel$export(module.exports, "appendTo", () => appendTo);
$parcel$export(module.exports, "prependTo", () => prependTo);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "wrap", () => wrap);
$parcel$export(module.exports, "wrapInner", () => wrapInner);
$parcel$export(module.exports, "unwrap", () => unwrap);
$parcel$export(module.exports, "wrapAll", () => wrapAll);
$parcel$export(module.exports, "after", () => after);
$parcel$export(module.exports, "insertAfter", () => insertAfter);
$parcel$export(module.exports, "before", () => before);
$parcel$export(module.exports, "insertBefore", () => insertBefore);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replaceWith", () => replaceWith);
$parcel$export(module.exports, "empty", () => empty);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "toString", () => toString);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "clone", () => clone);
/**
 * Methods for modifying the DOM structure.
 *
 * @module cheerio/manipulation
 */ parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $hrVkI = parcelRequire("hrVkI");

var $8fHQO = parcelRequire("8fHQO");

var $2oqzI = parcelRequire("2oqzI");
parcelRequire("CeYTB");
var $2VlnM = parcelRequire("2VlnM");
parcelRequire("hq9P0");
var $hREhV = parcelRequire("hREhV");
function _makeDomArray(elem, clone) {
    if (elem == null) return [];
    if (typeof elem === 'string') return this._parse(elem, this.options, false, null).children.slice(0);
    if ('length' in elem) {
        if (elem.length === 1) return this._makeDomArray(elem[0], clone);
        const result = [];
        for(let i = 0; i < elem.length; i++){
            const el = elem[i];
            if (typeof el === 'object') {
                if (el == null) continue;
                if (!('length' in el)) {
                    result.push(clone ? (0, $3zekA.cloneNode)(el, true) : el);
                    continue;
                }
            }
            result.push(...this._makeDomArray(el, clone));
        }
        return result;
    }
    return [
        clone ? (0, $3zekA.cloneNode)(elem, true) : elem
    ];
}
function _insert(concatenator) {
    return function(...elems) {
        const lastIdx = this.length - 1;
        return (0, $2oqzI.domEach)(this, (el, i)=>{
            if (!(0, $3zekA.hasChildren)(el)) return;
            const domSrc = typeof elems[0] === 'function' ? elems[0].call(el, i, this._render(el.children)) : elems;
            const dom = this._makeDomArray(domSrc, i < lastIdx);
            concatenator(dom, el.children, el);
        });
    };
}
/**
 * Modify an array in-place, removing some number of elements and adding new
 * elements directly following them.
 *
 * @private
 * @category Manipulation
 * @param array - Target array to splice.
 * @param spliceIdx - Index at which to begin changing the array.
 * @param spliceCount - Number of elements to remove from the array.
 * @param newElems - Elements to insert into the array.
 * @param parent - The parent of the node.
 * @returns The spliced array.
 */ function uniqueSplice(array, spliceIdx, spliceCount, newElems, parent) {
    var _a, _b;
    const spliceArgs = [
        spliceIdx,
        spliceCount,
        ...newElems
    ];
    const prev = spliceIdx === 0 ? null : array[spliceIdx - 1];
    const next = spliceIdx + spliceCount >= array.length ? null : array[spliceIdx + spliceCount];
    /*
     * Before splicing in new elements, ensure they do not already appear in the
     * current array.
     */ for(let idx = 0; idx < newElems.length; ++idx){
        const node = newElems[idx];
        const oldParent = node.parent;
        if (oldParent) {
            const oldSiblings = oldParent.children;
            const prevIdx = oldSiblings.indexOf(node);
            if (prevIdx !== -1) {
                oldParent.children.splice(prevIdx, 1);
                if (parent === oldParent && spliceIdx > prevIdx) spliceArgs[0]--;
            }
        }
        node.parent = parent;
        if (node.prev) node.prev.next = (_a = node.next) !== null && _a !== void 0 ? _a : null;
        if (node.next) node.next.prev = (_b = node.prev) !== null && _b !== void 0 ? _b : null;
        node.prev = idx === 0 ? prev : newElems[idx - 1];
        node.next = idx === newElems.length - 1 ? next : newElems[idx + 1];
    }
    if (prev) prev.next = newElems[0];
    if (next) next.prev = newElems[newElems.length - 1];
    return array.splice(...spliceArgs);
}
function appendTo(target) {
    const appendTarget = (0, $2oqzI.isCheerio)(target) ? target : this._make(target);
    appendTarget.append(this);
    return this;
}
function prependTo(target) {
    const prependTarget = (0, $2oqzI.isCheerio)(target) ? target : this._make(target);
    prependTarget.prepend(this);
    return this;
}
const append = _insert((dom, children, parent)=>{
    uniqueSplice(children, children.length, 0, dom, parent);
});
const prepend = _insert((dom, children, parent)=>{
    uniqueSplice(children, 0, 0, dom, parent);
});
function _wrap(insert) {
    return function(wrapper) {
        const lastIdx = this.length - 1;
        const lastParent = this.parents().last();
        for(let i = 0; i < this.length; i++){
            const el = this[i];
            const wrap = typeof wrapper === 'function' ? wrapper.call(el, i, el) : typeof wrapper === 'string' && !(0, $2oqzI.isHtml)(wrapper) ? lastParent.find(wrapper).clone() : wrapper;
            const [wrapperDom] = this._makeDomArray(wrap, i < lastIdx);
            if (!wrapperDom || !(0, $3zekA.hasChildren)(wrapperDom)) continue;
            let elInsertLocation = wrapperDom;
            /*
             * Find the deepest child. Only consider the first tag child of each node
             * (ignore text); stop if no children are found.
             */ let j = 0;
            while(j < elInsertLocation.children.length){
                const child = elInsertLocation.children[j];
                if ((0, $3zekA.isTag)(child)) {
                    elInsertLocation = child;
                    j = 0;
                } else j++;
            }
            insert(el, elInsertLocation, [
                wrapperDom
            ]);
        }
        return this;
    };
}
const wrap = _wrap((el, elInsertLocation, wrapperDom)=>{
    const { parent } = el;
    if (!parent) return;
    const siblings = parent.children;
    const index = siblings.indexOf(el);
    (0, $hrVkI.update)([
        el
    ], elInsertLocation);
    /*
     * The previous operation removed the current element from the `siblings`
     * array, so the `dom` array can be inserted without removing any
     * additional elements.
     */ uniqueSplice(siblings, index, 0, wrapperDom, parent);
});
const wrapInner = _wrap((el, elInsertLocation, wrapperDom)=>{
    if (!(0, $3zekA.hasChildren)(el)) return;
    (0, $hrVkI.update)(el.children, elInsertLocation);
    (0, $hrVkI.update)(wrapperDom, el);
});
function unwrap(selector) {
    this.parent(selector).not('body').each((_, el)=>{
        this._make(el).replaceWith(el.children);
    });
    return this;
}
function wrapAll(wrapper) {
    const el = this[0];
    if (el) {
        const wrap = this._make(typeof wrapper === 'function' ? wrapper.call(el, 0, el) : wrapper).insertBefore(el);
        // If html is given as wrapper, wrap may contain text elements
        let elInsertLocation;
        for(let i = 0; i < wrap.length; i++)if (wrap[i].type === (0, $hREhV).Tag) elInsertLocation = wrap[i];
        let j = 0;
        /*
         * Find the deepest child. Only consider the first tag child of each node
         * (ignore text); stop if no children are found.
         */ while(elInsertLocation && j < elInsertLocation.children.length){
            const child = elInsertLocation.children[j];
            if (child.type === (0, $hREhV).Tag) {
                elInsertLocation = child;
                j = 0;
            } else j++;
        }
        if (elInsertLocation) this._make(elInsertLocation).append(this);
    }
    return this;
}
function after(...elems) {
    const lastIdx = this.length - 1;
    return (0, $2oqzI.domEach)(this, (el, i)=>{
        if (!(0, $3zekA.hasChildren)(el) || !el.parent) return;
        const siblings = el.parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index === -1) return;
        const domSrc = typeof elems[0] === 'function' ? elems[0].call(el, i, this._render(el.children)) : elems;
        const dom = this._makeDomArray(domSrc, i < lastIdx);
        // Add element after `this` element
        uniqueSplice(siblings, index + 1, 0, dom, el.parent);
    });
}
function insertAfter(target) {
    if (typeof target === 'string') target = this._make(target);
    this.remove();
    const clones = [];
    for (const el of this._makeDomArray(target)){
        const clonedSelf = this.clone().toArray();
        const { parent } = el;
        if (!parent) continue;
        const siblings = parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index === -1) continue;
        // Add cloned `this` element(s) after target element
        uniqueSplice(siblings, index + 1, 0, clonedSelf, parent);
        clones.push(...clonedSelf);
    }
    return this._make(clones);
}
function before(...elems) {
    const lastIdx = this.length - 1;
    return (0, $2oqzI.domEach)(this, (el, i)=>{
        if (!(0, $3zekA.hasChildren)(el) || !el.parent) return;
        const siblings = el.parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index === -1) return;
        const domSrc = typeof elems[0] === 'function' ? elems[0].call(el, i, this._render(el.children)) : elems;
        const dom = this._makeDomArray(domSrc, i < lastIdx);
        // Add element before `el` element
        uniqueSplice(siblings, index, 0, dom, el.parent);
    });
}
function insertBefore(target) {
    const targetArr = this._make(target);
    this.remove();
    const clones = [];
    (0, $2oqzI.domEach)(targetArr, (el)=>{
        const clonedSelf = this.clone().toArray();
        const { parent } = el;
        if (!parent) return;
        const siblings = parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index === -1) return;
        // Add cloned `this` element(s) after target element
        uniqueSplice(siblings, index, 0, clonedSelf, parent);
        clones.push(...clonedSelf);
    });
    return this._make(clones);
}
function remove(selector) {
    // Filter if we have selector
    const elems = selector ? this.filter(selector) : this;
    (0, $2oqzI.domEach)(elems, (el)=>{
        (0, $2VlnM.removeElement)(el);
        el.prev = el.next = el.parent = null;
    });
    return this;
}
function replaceWith(content) {
    return (0, $2oqzI.domEach)(this, (el, i)=>{
        const { parent } = el;
        if (!parent) return;
        const siblings = parent.children;
        const cont = typeof content === 'function' ? content.call(el, i, el) : content;
        const dom = this._makeDomArray(cont);
        /*
         * In the case that `dom` contains nodes that already exist in other
         * structures, ensure those nodes are properly removed.
         */ (0, $hrVkI.update)(dom, null);
        const index = siblings.indexOf(el);
        // Completely remove old element
        uniqueSplice(siblings, index, 1, dom, parent);
        if (!dom.includes(el)) el.parent = el.prev = el.next = null;
    });
}
function empty() {
    return (0, $2oqzI.domEach)(this, (el)=>{
        if (!(0, $3zekA.hasChildren)(el)) return;
        for (const child of el.children)child.next = child.prev = child.parent = null;
        el.children.length = 0;
    });
}
function html(str) {
    if (str === undefined) {
        const el = this[0];
        if (!el || !(0, $3zekA.hasChildren)(el)) return null;
        return this._render(el.children);
    }
    return (0, $2oqzI.domEach)(this, (el)=>{
        if (!(0, $3zekA.hasChildren)(el)) return;
        for (const child of el.children)child.next = child.prev = child.parent = null;
        const content = (0, $2oqzI.isCheerio)(str) ? str.toArray() : this._parse(`${str}`, this.options, false, el).children;
        (0, $hrVkI.update)(content, el);
    });
}
function toString() {
    return this._render(this);
}
function text(str) {
    // If `str` is undefined, act as a "getter"
    if (str === undefined) return (0, $8fHQO.text)(this);
    if (typeof str === 'function') // Function support
    return (0, $2oqzI.domEach)(this, (el, i)=>this._make(el).text(str.call(el, i, (0, $8fHQO.text)([
            el
        ]))));
    // Append text node to each selected elements
    return (0, $2oqzI.domEach)(this, (el)=>{
        if (!(0, $3zekA.hasChildren)(el)) return;
        for (const child of el.children)child.next = child.prev = child.parent = null;
        const textNode = new (0, $3zekA.Text)(`${str}`);
        (0, $hrVkI.update)(textNode, el);
    });
}
function clone() {
    const clone = Array.prototype.map.call(this.get(), (el)=>(0, $3zekA.cloneNode)(el, true));
    // Add a root node around the cloned nodes
    const root = new (0, $3zekA.Document)(clone);
    for (const node of clone)node.parent = root;
    return this._make(clone);
}

});
parcelRegister("hrVkI", function(module, exports) {

$parcel$export(module.exports, "getParse", () => $cb416e742a8f1fde$export$c94b5dd2e133d87c);
$parcel$export(module.exports, "update", () => $cb416e742a8f1fde$export$722fbec263ad908a);
parcelRequire("CeYTB");
var $2VlnM = parcelRequire("2VlnM");
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $6ZWSX = parcelRequire("6ZWSX");
var $cb416e742a8f1fde$require$Buffer = $6ZWSX.Buffer;
function $cb416e742a8f1fde$export$c94b5dd2e133d87c(parser) {
    /**
     * Parse a HTML string or a node.
     *
     * @param content - The HTML string or node.
     * @param options - The parser options.
     * @param isDocument - If `content` is a document.
     * @param context - The context node in the DOM tree.
     * @returns The parsed document node.
     */ return function parse(content, options, isDocument, context) {
        if (typeof $cb416e742a8f1fde$require$Buffer !== 'undefined' && $cb416e742a8f1fde$require$Buffer.isBuffer(content)) content = content.toString();
        if (typeof content === 'string') return parser(content, options, isDocument, context);
        const doc = content;
        if (!Array.isArray(doc) && (0, $3zekA.isDocument)(doc)) // If `doc` is already a root, just return it
        return doc;
        // Add conent to new root element
        const root = new (0, $3zekA.Document)([]);
        // Update the DOM using the root
        $cb416e742a8f1fde$export$722fbec263ad908a(doc, root);
        return root;
    };
}
function $cb416e742a8f1fde$export$722fbec263ad908a(newChilds, parent) {
    // Normalize
    const arr = Array.isArray(newChilds) ? newChilds : [
        newChilds
    ];
    // Update parent
    if (parent) parent.children = arr;
    else parent = null;
    // Update neighbors
    for(let i = 0; i < arr.length; i++){
        const node = arr[i];
        // Cleanly remove existing nodes from their previous structures.
        if (node.parent && node.parent.children !== arr) (0, $2VlnM.removeElement)(node);
        if (parent) {
            node.prev = arr[i - 1] || null;
            node.next = arr[i + 1] || null;
        } else node.prev = node.next = null;
        node.parent = parent;
    }
    return parent;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("10cJb", function(module, exports) {

$parcel$export(module.exports, "serialize", () => serialize);
$parcel$export(module.exports, "serializeArray", () => serializeArray);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
/*
 * https://github.com/jquery/jquery/blob/2.1.3/src/manipulation/var/rcheckableType.js
 * https://github.com/jquery/jquery/blob/2.1.3/src/serialize.js
 */ const submittableSelector = 'input,select,textarea,keygen';
const r20 = /%20/g;
const rCRLF = /\r?\n/g;
function serialize() {
    // Convert form elements into name/value objects
    const arr = this.serializeArray();
    // Serialize each element into a key/value string
    const retArr = arr.map((data)=>`${encodeURIComponent(data.name)}=${encodeURIComponent(data.value)}`);
    // Return the resulting serialization
    return retArr.join('&').replace(r20, '+');
}
function serializeArray() {
    // Resolve all form elements from either forms or collections of form elements
    return this.map((_, elem)=>{
        const $elem = this._make(elem);
        if ((0, $3zekA.isTag)(elem) && elem.name === 'form') return $elem.find(submittableSelector).toArray();
        return $elem.filter(submittableSelector).toArray();
    }).filter(// Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))').map((_, elem)=>{
        var _a;
        const $elem = this._make(elem);
        const name = $elem.attr('name'); // We have filtered for elements with a name before.
        // If there is no value set (e.g. `undefined`, `null`), then default value to empty
        const value = (_a = $elem.val()) !== null && _a !== void 0 ? _a : '';
        // If we have an array of values (e.g. `<select multiple>`), return an array of key/value pairs
        if (Array.isArray(value)) return value.map((val)=>/*
             * We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
             * These can occur inside of `<textarea>'s`
             */ ({
                name: name,
                value: val.replace(rCRLF, '\r\n')
            }));
        // Otherwise (e.g. `<input type="text">`, return only one key/value pair
        return {
            name: name,
            value: value.replace(rCRLF, '\r\n')
        };
    }).toArray();
}

});

parcelRegister("3yvCV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = void 0;
module.exports.determineBranch = $296d147d75a5856f$var$determineBranch;
module.exports.decodeHTML = $296d147d75a5856f$var$decodeHTML;
module.exports.decodeHTMLAttribute = $296d147d75a5856f$var$decodeHTMLAttribute;
module.exports.decodeHTMLStrict = $296d147d75a5856f$var$decodeHTMLStrict;
module.exports.decodeXML = $296d147d75a5856f$var$decodeXML;

var $4h5pb = parcelRequire("4h5pb");

var $8MBpF = parcelRequire("8MBpF");

var $8IvHL = parcelRequire("8IvHL");
var $296d147d75a5856f$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($296d147d75a5856f$var$CharCodes || ($296d147d75a5856f$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $296d147d75a5856f$var$TO_LOWER_BIT = 32;
var $296d147d75a5856f$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($296d147d75a5856f$var$BinTrieFlags || (module.exports.BinTrieFlags = $296d147d75a5856f$var$BinTrieFlags = {}));
function $296d147d75a5856f$var$isNumber(code) {
    return code >= $296d147d75a5856f$var$CharCodes.ZERO && code <= $296d147d75a5856f$var$CharCodes.NINE;
}
function $296d147d75a5856f$var$isHexadecimalCharacter(code) {
    return code >= $296d147d75a5856f$var$CharCodes.UPPER_A && code <= $296d147d75a5856f$var$CharCodes.UPPER_F || code >= $296d147d75a5856f$var$CharCodes.LOWER_A && code <= $296d147d75a5856f$var$CharCodes.LOWER_F;
}
function $296d147d75a5856f$var$isAsciiAlphaNumeric(code) {
    return code >= $296d147d75a5856f$var$CharCodes.UPPER_A && code <= $296d147d75a5856f$var$CharCodes.UPPER_Z || code >= $296d147d75a5856f$var$CharCodes.LOWER_A && code <= $296d147d75a5856f$var$CharCodes.LOWER_Z || $296d147d75a5856f$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $296d147d75a5856f$var$isEntityInAttributeInvalidEnd(code) {
    return code === $296d147d75a5856f$var$CharCodes.EQUALS || $296d147d75a5856f$var$isAsciiAlphaNumeric(code);
}
var $296d147d75a5856f$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($296d147d75a5856f$var$EntityDecoderState || ($296d147d75a5856f$var$EntityDecoderState = {}));
var $296d147d75a5856f$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($296d147d75a5856f$var$DecodingMode || (module.exports.DecodingMode = $296d147d75a5856f$var$DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ class $296d147d75a5856f$var$EntityDecoder {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $296d147d75a5856f$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $296d147d75a5856f$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $296d147d75a5856f$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(input, offset) {
        switch(this.state){
            case $296d147d75a5856f$var$EntityDecoderState.EntityStart:
                if (input.charCodeAt(offset) === $296d147d75a5856f$var$CharCodes.NUM) {
                    this.state = $296d147d75a5856f$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(input, offset + 1);
                }
                this.state = $296d147d75a5856f$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(input, offset);
            case $296d147d75a5856f$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(input, offset);
            case $296d147d75a5856f$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(input, offset);
            case $296d147d75a5856f$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(input, offset);
            case $296d147d75a5856f$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(input, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(input, offset) {
        if (offset >= input.length) return -1;
        if ((input.charCodeAt(offset) | $296d147d75a5856f$var$TO_LOWER_BIT) === $296d147d75a5856f$var$CharCodes.LOWER_X) {
            this.state = $296d147d75a5856f$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(input, offset + 1);
        }
        this.state = $296d147d75a5856f$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(input, offset);
    }
    addToNumericResult(input, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($296d147d75a5856f$var$isNumber(char) || $296d147d75a5856f$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($296d147d75a5856f$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $296d147d75a5856f$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $296d147d75a5856f$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $8IvHL.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $296d147d75a5856f$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(input, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $296d147d75a5856f$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < input.length; offset++, this.excess++){
            const char = input.charCodeAt(offset);
            this.treeIndex = $296d147d75a5856f$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $296d147d75a5856f$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $296d147d75a5856f$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $296d147d75a5856f$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $296d147d75a5856f$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $296d147d75a5856f$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $296d147d75a5856f$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$296d147d75a5856f$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $296d147d75a5856f$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $296d147d75a5856f$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $296d147d75a5856f$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $296d147d75a5856f$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $296d147d75a5856f$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $296d147d75a5856f$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
module.exports.EntityDecoder = $296d147d75a5856f$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $296d147d75a5856f$var$getDecoder(decodeTree) {
    let returnValue = "";
    const decoder = new $296d147d75a5856f$var$EntityDecoder(decodeTree, (data)=>returnValue += (0, $8IvHL.fromCodePoint)(data));
    return function decodeWithTrie(input, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = input.indexOf("&", offset)) >= 0){
            returnValue += input.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const length = decoder.write(input, // Skip the "&"
            offset + 1);
            if (length < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + length;
            // If `length` is 0, skip the current `&` and continue.
            offset = length === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = returnValue + input.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        returnValue = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $296d147d75a5856f$var$determineBranch(decodeTree, current, nodeIndex, char) {
    const branchCount = (current & $296d147d75a5856f$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $296d147d75a5856f$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIndex : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIndex;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midValue = decodeTree[mid];
        if (midValue < char) lo = mid + 1;
        else if (midValue > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $296d147d75a5856f$var$htmlDecoder = /* #__PURE__ */ $296d147d75a5856f$var$getDecoder($4h5pb.htmlDecodeTree);
const $296d147d75a5856f$var$xmlDecoder = /* #__PURE__ */ $296d147d75a5856f$var$getDecoder($8MBpF.xmlDecodeTree);
/**
 * Decodes an HTML string.
 *
 * @param htmlString The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $296d147d75a5856f$var$decodeHTML(htmlString, mode = $296d147d75a5856f$var$DecodingMode.Legacy) {
    return $296d147d75a5856f$var$htmlDecoder(htmlString, mode);
}
/**
 * Decodes an HTML string in an attribute.
 *
 * @param htmlAttribute The string to decode.
 * @returns The decoded string.
 */ function $296d147d75a5856f$var$decodeHTMLAttribute(htmlAttribute) {
    return $296d147d75a5856f$var$htmlDecoder(htmlAttribute, $296d147d75a5856f$var$DecodingMode.Attribute);
}
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param htmlString The string to decode.
 * @returns The decoded string.
 */ function $296d147d75a5856f$var$decodeHTMLStrict(htmlString) {
    return $296d147d75a5856f$var$htmlDecoder(htmlString, $296d147d75a5856f$var$DecodingMode.Strict);
}
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param xmlString The string to decode.
 * @returns The decoded string.
 */ function $296d147d75a5856f$var$decodeXML(xmlString) {
    return $296d147d75a5856f$var$xmlDecoder(xmlString, $296d147d75a5856f$var$DecodingMode.Strict);
}

var $4h5pb = parcelRequire("4h5pb");
Object.defineProperty(module.exports, "htmlDecodeTree", {
    enumerable: true,
    get: function() {
        return $4h5pb.htmlDecodeTree;
    }
});

var $8MBpF = parcelRequire("8MBpF");
Object.defineProperty(module.exports, "xmlDecodeTree", {
    enumerable: true,
    get: function() {
        return $8MBpF.xmlDecodeTree;
    }
});

var $8IvHL = parcelRequire("8IvHL");
Object.defineProperty(module.exports, "decodeCodePoint", {
    enumerable: true,
    get: function() {
        return $8IvHL.decodeCodePoint;
    }
});
Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return $8IvHL.replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return $8IvHL.fromCodePoint;
    }
});

});
parcelRegister("4h5pb", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.htmlDecodeTree = void 0;
module.exports.htmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("8MBpF", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.xmlDecodeTree = void 0;
module.exports.xmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("8IvHL", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $658b06b2db163ce9$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = void 0;
module.exports.replaceCodePoint = $658b06b2db163ce9$var$replaceCodePoint;
module.exports.decodeCodePoint = $658b06b2db163ce9$var$decodeCodePoint;
const $658b06b2db163ce9$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
($658b06b2db163ce9$var$_a = String.fromCodePoint) !== null && $658b06b2db163ce9$var$_a !== void 0 ? $658b06b2db163ce9$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $658b06b2db163ce9$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
    return (_a = $658b06b2db163ce9$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $658b06b2db163ce9$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($658b06b2db163ce9$var$replaceCodePoint(codePoint));
}

});


parcelRegister("bpIMV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.getCodePoint = module.exports.xmlReplacer = void 0;
module.exports.encodeXML = $84f4c58458ee5252$var$encodeXML;
module.exports.xmlReplacer = /["$&'<>\u0080-\uFFFF]/g;
const $84f4c58458ee5252$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
// For compatibility with node < 4, we wrap `codePointAt`
module.exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt == null ? (c, index)=>(c.charCodeAt(index) & 64512) === 55296 ? (c.charCodeAt(index) - 55296) * 1024 + c.charCodeAt(index + 1) - 56320 + 65536 : c.charCodeAt(index) : (input, index)=>input.codePointAt(index);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ function $84f4c58458ee5252$var$encodeXML(input) {
    let returnValue = "";
    let lastIndex = 0;
    let match;
    while((match = module.exports.xmlReplacer.exec(input)) !== null){
        const { index: index } = match;
        const char = input.charCodeAt(index);
        const next = $84f4c58458ee5252$var$xmlCodeMap.get(char);
        if (next === undefined) {
            returnValue += `${input.substring(lastIndex, index)}&#x${(0, module.exports.getCodePoint)(input, index).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIndex = module.exports.xmlReplacer.lastIndex += Number((char & 64512) === 55296);
        } else {
            returnValue += input.substring(lastIndex, index) + next;
            lastIndex = index + 1;
        }
    }
    return returnValue + input.substr(lastIndex);
}
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ module.exports.escape = $84f4c58458ee5252$var$encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $84f4c58458ee5252$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIndex = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIndex !== match.index) result += data.substring(lastIndex, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIndex = match.index + 1;
        }
        return result + data.substring(lastIndex);
    };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ module.exports.escapeUTF8 = $84f4c58458ee5252$var$getEscaper(/["&'<>]/g, $84f4c58458ee5252$var$xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeAttribute = /* #__PURE__ */ $84f4c58458ee5252$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeText = $84f4c58458ee5252$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});

var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$p = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$d = Array.isArray;
function $13c40c34b78c8ee2$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, e = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = u[r];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === e[r] && (e[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$m(l, e, i, o, null);
}
function $13c40c34b78c8ee2$var$m(n, t, i, o, r) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$S(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$S(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$$.__r++ || $13c40c34b78c8ee2$var$o != $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$$);
}
function $13c40c34b78c8ee2$var$$() {
    for(var n, u, t, o, r, f, c, s = 1; $13c40c34b78c8ee2$var$i.length;)$13c40c34b78c8ee2$var$i.length > s && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$e), n = $13c40c34b78c8ee2$var$i.shift(), s = $13c40c34b78c8ee2$var$i.length, n.__d && (t = void 0, o = void 0, r = (o = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $13c40c34b78c8ee2$var$w({}, o)).__v = o.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(t), $13c40c34b78c8ee2$var$O(u.__P, t, o, u.__n, u.__P.namespaceURI, 32 & o.__u ? [
        r
    ] : null, f, null == r ? $13c40c34b78c8ee2$var$S(o) : r, !!(32 & o.__u), c), t.__v = o.__v, t.__.__k[t.__i] = t, $13c40c34b78c8ee2$var$N(f, t, c), o.__e = o.__ = null, t.__e != r && $13c40c34b78c8ee2$var$C(t)));
    $13c40c34b78c8ee2$var$$.__r = 0;
}
function $13c40c34b78c8ee2$var$I(n, l, u, t, i, o, r, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $13c40c34b78c8ee2$var$v, b = l.length;
    for(f = $13c40c34b78c8ee2$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $13c40c34b78c8ee2$var$p : m[y.__i] || $13c40c34b78c8ee2$var$p, y.__i = a, g = $13c40c34b78c8ee2$var$O(n, y, h, i, o, r, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $13c40c34b78c8ee2$var$B(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $13c40c34b78c8ee2$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $13c40c34b78c8ee2$var$P(n, l, u, t, i) {
    var o, r, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), o = 0; o < i; o++)null != (r = l[o]) && "boolean" != typeof r && "function" != typeof r ? ("string" == typeof r || "number" == typeof r || "bigint" == typeof r || r.constructor == String ? r = n.__k[o] = $13c40c34b78c8ee2$var$m(null, r, null, null, null) : $13c40c34b78c8ee2$var$d(r) ? r = n.__k[o] = $13c40c34b78c8ee2$var$m($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: r
    }, null, null, null) : void 0 === r.constructor && r.__b > 0 ? r = n.__k[o] = $13c40c34b78c8ee2$var$m(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : n.__k[o] = r, f = o + h, r.__ = n, r.__b = n.__b + 1, e = null, -1 != (c = r.__i = $13c40c34b78c8ee2$var$L(r, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof r.type && (r.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, r.__u |= 4))) : n.__k[o] = null;
    if (a) for(o = 0; o < s; o++)null != (e = u[o]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c40c34b78c8ee2$var$S(e)), $13c40c34b78c8ee2$var$D(e, e));
    return t;
}
function $13c40c34b78c8ee2$var$A(n, l, u, t) {
    var i, o;
    if ("function" == typeof n.type) {
        for(i = n.__k, o = 0; i && o < i.length; o++)i[o] && (i[o].__ = n, l = $13c40c34b78c8ee2$var$A(i[o], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $13c40c34b78c8ee2$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$d(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, u, t) {
    var i, o, r, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, o = u + 1; i >= 0 || o < l.length;)if (null != (c = l[r = i >= 0 ? i-- : o++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return r;
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$y.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$j(n, l, u, t, i) {
    var o, r;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c40c34b78c8ee2$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) o = l != (l = l.replace($13c40c34b78c8ee2$var$f, "$1")), r = l.toLowerCase(), l = r in n || "onFocusOut" == l || "onFocusIn" == l ? r.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $13c40c34b78c8ee2$var$c, n.addEventListener(l, o ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c40c34b78c8ee2$var$c++;
            else if (u.t < t.u) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, u, t, i, o, r, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        f = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $13c40c34b78c8ee2$var$E), C && C.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$w({}, h.__s)), $13c40c34b78c8ee2$var$w(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$w($13c40c34b78c8ee2$var$w({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key && (L = $13c40c34b78c8ee2$var$V(a.props.children)), f = $13c40c34b78c8ee2$var$I(n, $13c40c34b78c8ee2$var$d(L) ? L : [
            L
        ], u, t, i, o, r, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                r[r.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = r.length; T--;)$13c40c34b78c8ee2$var$g(r[T]);
                $13c40c34b78c8ee2$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $13c40c34b78c8ee2$var$z(u);
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c40c34b78c8ee2$var$q(t.__e, u, t, i, o, r, e, c, s);
    return (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $13c40c34b78c8ee2$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($13c40c34b78c8ee2$var$z);
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$B(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $13c40c34b78c8ee2$var$d(n) ? n.map($13c40c34b78c8ee2$var$V) : $13c40c34b78c8ee2$var$w({}, n);
}
function $13c40c34b78c8ee2$var$q(u, t, i, o, r, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $13c40c34b78c8ee2$var$p, k = t.props, x = t.type;
    if ("svg" == x ? r = "http://www.w3.org/2000/svg" : "math" == x ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(r, x, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $13c40c34b78c8ee2$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)if (w = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = w;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$j(u, a, null, w, r);
        }
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $13c40c34b78c8ee2$var$j(u, a, w, b[a], r);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $13c40c34b78c8ee2$var$I("template" == t.type ? u.content : u, $13c40c34b78c8ee2$var$d(y) ? y : [
            y
        ], t, i, o, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : r, e, f, e ? e[0] : i.__k && $13c40c34b78c8ee2$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$13c40c34b78c8ee2$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $13c40c34b78c8ee2$var$j(u, a, _, b[a], r), a = "checked", null != m && m != u[a] && $13c40c34b78c8ee2$var$j(u, a, m, b[a], r));
    }
    return u;
}
function $13c40c34b78c8ee2$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$D(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c40c34b78c8ee2$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$D(i[o], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c40c34b78c8ee2$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, e, f;
    t == document && (t = document.documentElement), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c40c34b78c8ee2$var$O(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$p, $13c40c34b78c8ee2$var$p, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, e, !o && i ? i : r ? r.__e : t.firstChild, o, f), $13c40c34b78c8ee2$var$N(e, u, f);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, e, f = $13c40c34b78c8ee2$var$w({}, l.props);
    for(r in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = void 0 === u[r] && null != e ? e[r] : u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$m(l.type, f, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c40c34b78c8ee2$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c40c34b78c8ee2$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$w({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$w({}, u), this.props)), n && $13c40c34b78c8ee2$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$$.__r = 0, $13c40c34b78c8ee2$var$f = /(PointerCapture)$|Capture$/i, $13c40c34b78c8ee2$var$c = 0, $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$a = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$h = 0;




var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2), $204a33a7557cbbd0$var$e = $204a33a7557cbbd0$var$c.__b, $204a33a7557cbbd0$var$a = $204a33a7557cbbd0$var$c.__r, $204a33a7557cbbd0$var$v = $204a33a7557cbbd0$var$c.diffed, $204a33a7557cbbd0$var$l = $204a33a7557cbbd0$var$c.__c, $204a33a7557cbbd0$var$m = $204a33a7557cbbd0$var$c.unmount, $204a33a7557cbbd0$var$s = $204a33a7557cbbd0$var$c.__;
function $204a33a7557cbbd0$var$p(n, t) {
    $204a33a7557cbbd0$var$c.__h && $204a33a7557cbbd0$var$c.__h($204a33a7557cbbd0$var$r, n, $204a33a7557cbbd0$var$o || t), $204a33a7557cbbd0$var$o = 0;
    var u = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$D, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $204a33a7557cbbd0$var$r.__f = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(n, u) {
    var i = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 3);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.u = u, $204a33a7557cbbd0$var$r.__H.__h.push(i));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(n, u) {
    var i = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 4);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.u = u, $204a33a7557cbbd0$var$r.__h.push(i));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(n, t) {
    $204a33a7557cbbd0$var$c.useDebugValue && $204a33a7557cbbd0$var$c.useDebugValue(t ? t(n) : n);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$j() {
    for(var n; n = $204a33a7557cbbd0$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($204a33a7557cbbd0$var$z), n.__H.__h.forEach($204a33a7557cbbd0$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $204a33a7557cbbd0$var$c.__e(t, n.__v);
    }
}
$204a33a7557cbbd0$var$c.__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, $204a33a7557cbbd0$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $204a33a7557cbbd0$var$s && $204a33a7557cbbd0$var$s(n, t);
}, $204a33a7557cbbd0$var$c.__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$z), i.__h.forEach($204a33a7557cbbd0$var$B), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, $204a33a7557cbbd0$var$c.diffed = function(n) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(t) && $204a33a7557cbbd0$var$i === $204a33a7557cbbd0$var$c.requestAnimationFrame || (($204a33a7557cbbd0$var$i = $204a33a7557cbbd0$var$c.requestAnimationFrame) || $204a33a7557cbbd0$var$w)($204a33a7557cbbd0$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, $204a33a7557cbbd0$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($204a33a7557cbbd0$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $204a33a7557cbbd0$var$c.__e(r, n.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(n, t);
}, $204a33a7557cbbd0$var$c.unmount = function(n) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $204a33a7557cbbd0$var$c.__e(t, r.__v));
};
var $204a33a7557cbbd0$var$k = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $204a33a7557cbbd0$var$k && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$z(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$B(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}





var $6ZWSX = parcelRequire("6ZWSX");
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}



var $8fHQO = parcelRequire("8fHQO");

var $7Oe9g = parcelRequire("7Oe9g");

var $8fHQO = parcelRequire("8fHQO");

var $dUdzM = parcelRequire("dUdzM");

var $f2WFc = parcelRequire("f2WFc");

var $g9e7m = parcelRequire("g9e7m");
var $524afedf0cc072e6$exports = {};

$parcel$export($524afedf0cc072e6$exports, "css", () => $524afedf0cc072e6$export$dbf350e5966cf602);

var $2oqzI = parcelRequire("2oqzI");
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $524afedf0cc072e6$export$dbf350e5966cf602(prop, val) {
    if (prop != null && val != null || // When `prop` is a "plain" object
    typeof prop === 'object' && !Array.isArray(prop)) return (0, $2oqzI.domEach)(this, (el, i)=>{
        if ((0, $3zekA.isTag)(el)) // `prop` can't be an array here anymore.
        $524afedf0cc072e6$var$setCss(el, prop, val, i);
    });
    if (this.length === 0) return undefined;
    return $524afedf0cc072e6$var$getCss(this[0], prop);
}
/**
 * Set styles of all elements.
 *
 * @private
 * @param el - Element to set style of.
 * @param prop - Name of property.
 * @param value - Value to set property to.
 * @param idx - Optional index within the selection.
 */ function $524afedf0cc072e6$var$setCss(el, prop, value, idx) {
    if (typeof prop === 'string') {
        const styles = $524afedf0cc072e6$var$getCss(el);
        const val = typeof value === 'function' ? value.call(el, idx, styles[prop]) : value;
        if (val === '') delete styles[prop];
        else if (val != null) styles[prop] = val;
        el.attribs['style'] = $524afedf0cc072e6$var$stringify(styles);
    } else if (typeof prop === 'object') {
        const keys = Object.keys(prop);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            $524afedf0cc072e6$var$setCss(el, k, prop[k], i);
        }
    }
}
function $524afedf0cc072e6$var$getCss(el, prop) {
    if (!el || !(0, $3zekA.isTag)(el)) return;
    const styles = $524afedf0cc072e6$var$parse(el.attribs['style']);
    if (typeof prop === 'string') return styles[prop];
    if (Array.isArray(prop)) {
        const newStyles = {};
        for (const item of prop)if (styles[item] != null) newStyles[item] = styles[item];
        return newStyles;
    }
    return styles;
}
/**
 * Stringify `obj` to styles.
 *
 * @private
 * @category CSS
 * @param obj - Object to stringify.
 * @returns The serialized styles.
 */ function $524afedf0cc072e6$var$stringify(obj) {
    return Object.keys(obj).reduce((str, prop)=>`${str}${str ? ' ' : ''}${prop}: ${obj[prop]};`, '');
}
/**
 * Parse `styles`.
 *
 * @private
 * @category CSS
 * @param styles - Styles to be parsed.
 * @returns The parsed styles.
 */ function $524afedf0cc072e6$var$parse(styles) {
    styles = (styles || '').trim();
    if (!styles) return {};
    const obj = {};
    let key;
    for (const str of styles.split(';')){
        const n = str.indexOf(':');
        // If there is no :, or if it is the first/last character, add to the previous item's value
        if (n < 1 || n === str.length - 1) {
            const trimmed = str.trimEnd();
            if (trimmed.length > 0 && key !== undefined) obj[key] += `;${trimmed}`;
        } else {
            key = str.slice(0, n).trim();
            obj[key] = str.slice(n + 1).trim();
        }
    }
    return obj;
}



var $10cJb = parcelRequire("10cJb");
var $84a76b11dd7c235f$exports = {};

$parcel$export($84a76b11dd7c235f$exports, "extract", () => $84a76b11dd7c235f$export$f9380c9a627682d3);
function $84a76b11dd7c235f$var$getExtractDescr(descr) {
    var _a;
    if (typeof descr === 'string') return {
        selector: descr,
        value: 'textContent'
    };
    return {
        selector: descr.selector,
        value: (_a = descr.value) !== null && _a !== void 0 ? _a : 'textContent'
    };
}
function $84a76b11dd7c235f$export$f9380c9a627682d3(map) {
    const ret = {};
    for(const key in map){
        const descr = map[key];
        const isArray = Array.isArray(descr);
        const { selector: selector, value: value } = $84a76b11dd7c235f$var$getExtractDescr(isArray ? descr[0] : descr);
        const fn = typeof value === 'function' ? value : typeof value === 'string' ? (el)=>this._make(el).prop(value) : (el)=>this._make(el).extract(value);
        if (isArray) ret[key] = this._findBySelector(selector, Number.POSITIVE_INFINITY).map((_, el)=>fn(el, key, ret)).get();
        else {
            const $ = this._findBySelector(selector, 1);
            ret[key] = $.length > 0 ? fn($[0], key, ret) : undefined;
        }
    }
    return ret;
}


class $1e8de0ec69af23c0$export$a25e727e7f7b9892 {
    /**
     * Instance of cheerio. Methods are specified in the modules. Usage of this
     * constructor is not recommended. Please use `$.load` instead.
     *
     * @private
     * @param elements - The new selection.
     * @param root - Sets the root node.
     * @param options - Options for the instance.
     */ constructor(elements, root, options){
        this.length = 0;
        this.options = options;
        this._root = root;
        if (elements) {
            for(let idx = 0; idx < elements.length; idx++)this[idx] = elements[idx];
            this.length = elements.length;
        }
    }
}
/** Set a signature of the object. */ $1e8de0ec69af23c0$export$a25e727e7f7b9892.prototype.cheerio = '[cheerio object]';
/*
 * Make cheerio an array-like object
 */ $1e8de0ec69af23c0$export$a25e727e7f7b9892.prototype.splice = Array.prototype.splice;
// Support for (const element of $(...)) iteration:
$1e8de0ec69af23c0$export$a25e727e7f7b9892.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
// Plug in the API
Object.assign($1e8de0ec69af23c0$export$a25e727e7f7b9892.prototype, $dUdzM, $f2WFc, $g9e7m, $524afedf0cc072e6$exports, $10cJb, $84a76b11dd7c235f$exports);



var $2oqzI = parcelRequire("2oqzI");
parcelRequire("hq9P0");
var $hREhV = parcelRequire("hREhV");
function $7cd6fa5314d5f81f$export$8b469b2b7efa8d79(parse, render) {
    /**
     * Create a querying function, bound to a document created from the provided
     * markup.
     *
     * Note that similar to web browser contexts, this operation may introduce
     * `<html>`, `<head>`, and `<body>` elements; set `isDocument` to `false` to
     * switch to fragment mode and disable this.
     *
     * @param content - Markup to be loaded.
     * @param options - Options for the created instance.
     * @param isDocument - Allows parser to be switched to fragment mode.
     * @returns The loaded document.
     * @see {@link https://cheerio.js.org/docs/basics/loading#load} for additional usage information.
     */ return function load(content, options, isDocument = true) {
        if (content == null) throw new Error('cheerio.load() expects a string');
        const internalOpts = (0, $7Oe9g.flattenOptions)(options);
        const initialRoot = parse(content, internalOpts, isDocument, null);
        /**
         * Create an extended class here, so that extensions only live on one
         * instance.
         */ class LoadedCheerio extends (0, $1e8de0ec69af23c0$export$a25e727e7f7b9892) {
            _make(selector, context) {
                const cheerio = initialize(selector, context);
                cheerio.prevObject = this;
                return cheerio;
            }
            _parse(content, options, isDocument, context) {
                return parse(content, options, isDocument, context);
            }
            _render(dom) {
                return render(dom, this.options);
            }
        }
        function initialize(selector, context, root = initialRoot, opts) {
            // $($)
            if (selector && (0, $2oqzI.isCheerio)(selector)) return selector;
            const options = (0, $7Oe9g.flattenOptions)(opts, internalOpts);
            const r = typeof root === 'string' ? [
                parse(root, options, false, null)
            ] : 'length' in root ? root : [
                root
            ];
            const rootInstance = (0, $2oqzI.isCheerio)(r) ? r : new LoadedCheerio(r, null, options);
            // Add a cyclic reference, so that calling methods on `_root` never fails.
            rootInstance._root = rootInstance;
            // $(), $(null), $(undefined), $(false)
            if (!selector) return new LoadedCheerio(undefined, rootInstance, options);
            const elements = typeof selector === 'string' && (0, $2oqzI.isHtml)(selector) ? parse(selector, options, false, null).children : $7cd6fa5314d5f81f$var$isNode(selector) ? [
                selector
            ] : Array.isArray(selector) ? selector : undefined;
            const instance = new LoadedCheerio(elements, rootInstance, options);
            if (elements) return instance;
            if (typeof selector !== 'string') throw new TypeError('Unexpected type of selector');
            // We know that our selector is a string now.
            let search = selector;
            const searchContext = context ? typeof context === 'string' ? (0, $2oqzI.isHtml)(context) ? new LoadedCheerio([
                parse(context, options, false, null)
            ], rootInstance, options) : (search = `${context} ${search}`, rootInstance) : (0, $2oqzI.isCheerio)(context) ? context : new LoadedCheerio(Array.isArray(context) ? context : [
                context
            ], rootInstance, options) : rootInstance;
            // If we still don't have a context, return
            if (!searchContext) return instance;
            /*
             * #id, .class, tag
             */ return searchContext.find(search);
        }
        // Add in static methods & properties
        Object.assign(initialize, $8fHQO, {
            load: load,
            // `_root` and `_options` are used in static methods.
            _root: initialRoot,
            _options: internalOpts,
            // Add `fn` for plugins
            fn: LoadedCheerio.prototype,
            // Add the prototype here to maintain `instanceof` behavior.
            prototype: LoadedCheerio.prototype
        });
        return initialize;
    };
}
function $7cd6fa5314d5f81f$var$isNode(obj) {
    return(// @ts-expect-error: TS doesn't know about the `name` property.
    !!obj.name || // @ts-expect-error: TS doesn't know about the `type` property.
    obj.type === (0, $hREhV).Root || // @ts-expect-error: TS doesn't know about the `type` property.
    obj.type === (0, $hREhV).Text || // @ts-expect-error: TS doesn't know about the `type` property.
    obj.type === (0, $hREhV).Comment);
}



var $hrVkI = parcelRequire("hrVkI");
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
const $13b6aff9b77366c5$var$UNDEFINED_CODE_POINTS = new Set([
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
]);
const $13b6aff9b77366c5$export$e8d20e7a50e6c279 = '\uFFFD';
var $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0;
(function(CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
})($13b6aff9b77366c5$export$e3f6c2feb5c0ecc0 || ($13b6aff9b77366c5$export$e3f6c2feb5c0ecc0 = {}));
const $13b6aff9b77366c5$export$5abac700f947e2 = {
    DASH_DASH: '--',
    CDATA_START: '[CDATA[',
    DOCTYPE: 'doctype',
    SCRIPT: 'script',
    PUBLIC: 'public',
    SYSTEM: 'system'
};
function $13b6aff9b77366c5$export$7e678b42035e707f(cp) {
    return cp >= 55296 && cp <= 57343;
}
function $13b6aff9b77366c5$export$e7f1d94bb17e4055(cp) {
    return cp >= 56320 && cp <= 57343;
}
function $13b6aff9b77366c5$export$91e83256751ec906(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
}
function $13b6aff9b77366c5$export$d6953a6077926e(cp) {
    return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
}
function $13b6aff9b77366c5$export$b3484aaf321bda02(cp) {
    return cp >= 64976 && cp <= 65007 || $13b6aff9b77366c5$var$UNDEFINED_CODE_POINTS.has(cp);
}


var $0d242c12c37a5644$export$9e0efcb140234d2;
(function(ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
})($0d242c12c37a5644$export$9e0efcb140234d2 || ($0d242c12c37a5644$export$9e0efcb140234d2 = {}));


//Const
const $18505f1274889f1f$var$DEFAULT_BUFFER_WATERLINE = 65536;
class $18505f1274889f1f$export$35db5c8036a15ad1 {
    constructor(handler){
        this.handler = handler;
        this.html = '';
        this.pos = -1;
        // NOTE: Initial `lastGapPos` is -2, to ensure `col` on initialisation is 0
        this.lastGapPos = -2;
        this.gapStack = [];
        this.skipNextNewLine = false;
        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = $18505f1274889f1f$var$DEFAULT_BUFFER_WATERLINE;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;
        this.line = 1;
        //NOTE: avoid reporting errors twice on advance/retreat
        this.lastErrOffset = -1;
    }
    /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */ get col() {
        return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
    get offset() {
        return this.droppedBufferSize + this.pos;
    }
    getError(code, cpOffset) {
        const { line: line, col: col, offset: offset } = this;
        const startCol = col + cpOffset;
        const startOffset = offset + cpOffset;
        return {
            code: code,
            startLine: line,
            endLine: line,
            startCol: startCol,
            endCol: startCol,
            startOffset: startOffset,
            endOffset: startOffset
        };
    }
    _err(code) {
        if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
            this.lastErrOffset = this.offset;
            this.handler.onParseError(this.getError(code, 0));
        }
    }
    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }
    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.html.length - 1) {
            const nextCp = this.html.charCodeAt(this.pos + 1);
            if ((0, $13b6aff9b77366c5$export$e7f1d94bb17e4055)(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;
                //NOTE: add a gap that should be avoided during retreat
                this._addGap();
                return (0, $13b6aff9b77366c5$export$91e83256751ec906)(cp, nextCp);
            }
        } else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF;
        }
        //NOTE: isolated surrogate
        this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).surrogateInInputStream);
        return cp;
    }
    willDropParsedChunk() {
        return this.pos > this.bufferWaterline;
    }
    dropParsedChunk() {
        if (this.willDropParsedChunk()) {
            this.html = this.html.substring(this.pos);
            this.lineStartPos -= this.pos;
            this.droppedBufferSize += this.pos;
            this.pos = 0;
            this.lastGapPos = -2;
            this.gapStack.length = 0;
        }
    }
    write(chunk, isLastChunk) {
        if (this.html.length > 0) this.html += chunk;
        else this.html = chunk;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }
    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
        this.endOfChunkHit = false;
    }
    startsWith(pattern, caseSensitive) {
        // Check if our buffer has enough characters
        if (this.pos + pattern.length > this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return false;
        }
        if (caseSensitive) return this.html.startsWith(pattern, this.pos);
        for(let i = 0; i < pattern.length; i++){
            const cp = this.html.charCodeAt(this.pos + i) | 0x20;
            if (cp !== pattern.charCodeAt(i)) return false;
        }
        return true;
    }
    peek(offset) {
        const pos = this.pos + offset;
        if (pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF;
        }
        const code = this.html.charCodeAt(pos);
        return code === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN ? (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED : code;
    }
    advance() {
        this.pos++;
        //NOTE: LF should be in the last column of the line
        if (this.isEol) {
            this.isEol = false;
            this.line++;
            this.lineStartPos = this.pos;
        }
        if (this.pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) {
            this.isEol = true;
            this.skipNextNewLine = true;
            return (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED;
        }
        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED) {
            this.isEol = true;
            if (this.skipNextNewLine) {
                // `line` will be bumped again in the recursive call.
                this.line--;
                this.skipNextNewLine = false;
                this._addGap();
                return this.advance();
            }
        }
        this.skipNextNewLine = false;
        if ((0, $13b6aff9b77366c5$export$7e678b42035e707f)(cp)) cp = this._processSurrogate(cp);
        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange = this.handler.onParseError === null || cp > 0x1f && cp < 0x7f || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN || cp > 0x9f && cp < 64976;
        if (!isCommonValidRange) this._checkForProblematicCharacters(cp);
        return cp;
    }
    _checkForProblematicCharacters(cp) {
        if ((0, $13b6aff9b77366c5$export$d6953a6077926e)(cp)) this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).controlCharacterInInputStream);
        else if ((0, $13b6aff9b77366c5$export$b3484aaf321bda02)(cp)) this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).noncharacterInInputStream);
    }
    retreat(count) {
        this.pos -= count;
        while(this.pos < this.lastGapPos){
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }
        this.isEol = false;
    }
}



var $05436e75d13cd0ed$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
})($05436e75d13cd0ed$export$f435f793048e7a0f || ($05436e75d13cd0ed$export$f435f793048e7a0f = {}));
function $05436e75d13cd0ed$export$df33bba014b5841e(token, attrName) {
    for(let i = token.attrs.length - 1; i >= 0; i--){
        if (token.attrs[i].name === attrName) return token.attrs[i].value;
    }
    return null;
}


var $551967bbe53cae21$exports = {};
// Make exports work in Node < 12
// eslint-disable-next-line no-undef, unicorn/prefer-module

$551967bbe53cae21$exports = (parcelRequire("3yvCV"));



var $5deb0c47e1a27c89$exports = {};

$parcel$export($5deb0c47e1a27c89$exports, "NS", () => $5deb0c47e1a27c89$export$fb4028874a74450);
$parcel$export($5deb0c47e1a27c89$exports, "ATTRS", () => $5deb0c47e1a27c89$export$380b7bc9e6cb1918);
$parcel$export($5deb0c47e1a27c89$exports, "DOCUMENT_MODE", () => $5deb0c47e1a27c89$export$a74d46c85337d29a);
$parcel$export($5deb0c47e1a27c89$exports, "TAG_NAMES", () => $5deb0c47e1a27c89$export$7e674a85a2656dce);
$parcel$export($5deb0c47e1a27c89$exports, "TAG_ID", () => $5deb0c47e1a27c89$export$cb0999a53e0acaed);
$parcel$export($5deb0c47e1a27c89$exports, "getTagID", () => $5deb0c47e1a27c89$export$39db8a1315f68282);
$parcel$export($5deb0c47e1a27c89$exports, "SPECIAL_ELEMENTS", () => $5deb0c47e1a27c89$export$7e5172336f7d2bbb);
$parcel$export($5deb0c47e1a27c89$exports, "NUMBERED_HEADERS", () => $5deb0c47e1a27c89$export$1ecc20fa0754c045);
$parcel$export($5deb0c47e1a27c89$exports, "hasUnescapedText", () => $5deb0c47e1a27c89$export$4ce4f8c09f921aed);
/** All valid namespaces in HTML. */ var $5deb0c47e1a27c89$export$fb4028874a74450;
(function(NS) {
    NS["HTML"] = "http://www.w3.org/1999/xhtml";
    NS["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS["SVG"] = "http://www.w3.org/2000/svg";
    NS["XLINK"] = "http://www.w3.org/1999/xlink";
    NS["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})($5deb0c47e1a27c89$export$fb4028874a74450 || ($5deb0c47e1a27c89$export$fb4028874a74450 = {}));
var $5deb0c47e1a27c89$export$380b7bc9e6cb1918;
(function(ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
})($5deb0c47e1a27c89$export$380b7bc9e6cb1918 || ($5deb0c47e1a27c89$export$380b7bc9e6cb1918 = {}));
var $5deb0c47e1a27c89$export$a74d46c85337d29a;
(function(DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
})($5deb0c47e1a27c89$export$a74d46c85337d29a || ($5deb0c47e1a27c89$export$a74d46c85337d29a = {}));
var $5deb0c47e1a27c89$export$7e674a85a2656dce;
(function(TAG_NAMES) {
    TAG_NAMES["A"] = "a";
    TAG_NAMES["ADDRESS"] = "address";
    TAG_NAMES["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES["APPLET"] = "applet";
    TAG_NAMES["AREA"] = "area";
    TAG_NAMES["ARTICLE"] = "article";
    TAG_NAMES["ASIDE"] = "aside";
    TAG_NAMES["B"] = "b";
    TAG_NAMES["BASE"] = "base";
    TAG_NAMES["BASEFONT"] = "basefont";
    TAG_NAMES["BGSOUND"] = "bgsound";
    TAG_NAMES["BIG"] = "big";
    TAG_NAMES["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES["BODY"] = "body";
    TAG_NAMES["BR"] = "br";
    TAG_NAMES["BUTTON"] = "button";
    TAG_NAMES["CAPTION"] = "caption";
    TAG_NAMES["CENTER"] = "center";
    TAG_NAMES["CODE"] = "code";
    TAG_NAMES["COL"] = "col";
    TAG_NAMES["COLGROUP"] = "colgroup";
    TAG_NAMES["DD"] = "dd";
    TAG_NAMES["DESC"] = "desc";
    TAG_NAMES["DETAILS"] = "details";
    TAG_NAMES["DIALOG"] = "dialog";
    TAG_NAMES["DIR"] = "dir";
    TAG_NAMES["DIV"] = "div";
    TAG_NAMES["DL"] = "dl";
    TAG_NAMES["DT"] = "dt";
    TAG_NAMES["EM"] = "em";
    TAG_NAMES["EMBED"] = "embed";
    TAG_NAMES["FIELDSET"] = "fieldset";
    TAG_NAMES["FIGCAPTION"] = "figcaption";
    TAG_NAMES["FIGURE"] = "figure";
    TAG_NAMES["FONT"] = "font";
    TAG_NAMES["FOOTER"] = "footer";
    TAG_NAMES["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES["FORM"] = "form";
    TAG_NAMES["FRAME"] = "frame";
    TAG_NAMES["FRAMESET"] = "frameset";
    TAG_NAMES["H1"] = "h1";
    TAG_NAMES["H2"] = "h2";
    TAG_NAMES["H3"] = "h3";
    TAG_NAMES["H4"] = "h4";
    TAG_NAMES["H5"] = "h5";
    TAG_NAMES["H6"] = "h6";
    TAG_NAMES["HEAD"] = "head";
    TAG_NAMES["HEADER"] = "header";
    TAG_NAMES["HGROUP"] = "hgroup";
    TAG_NAMES["HR"] = "hr";
    TAG_NAMES["HTML"] = "html";
    TAG_NAMES["I"] = "i";
    TAG_NAMES["IMG"] = "img";
    TAG_NAMES["IMAGE"] = "image";
    TAG_NAMES["INPUT"] = "input";
    TAG_NAMES["IFRAME"] = "iframe";
    TAG_NAMES["KEYGEN"] = "keygen";
    TAG_NAMES["LABEL"] = "label";
    TAG_NAMES["LI"] = "li";
    TAG_NAMES["LINK"] = "link";
    TAG_NAMES["LISTING"] = "listing";
    TAG_NAMES["MAIN"] = "main";
    TAG_NAMES["MALIGNMARK"] = "malignmark";
    TAG_NAMES["MARQUEE"] = "marquee";
    TAG_NAMES["MATH"] = "math";
    TAG_NAMES["MENU"] = "menu";
    TAG_NAMES["META"] = "meta";
    TAG_NAMES["MGLYPH"] = "mglyph";
    TAG_NAMES["MI"] = "mi";
    TAG_NAMES["MO"] = "mo";
    TAG_NAMES["MN"] = "mn";
    TAG_NAMES["MS"] = "ms";
    TAG_NAMES["MTEXT"] = "mtext";
    TAG_NAMES["NAV"] = "nav";
    TAG_NAMES["NOBR"] = "nobr";
    TAG_NAMES["NOFRAMES"] = "noframes";
    TAG_NAMES["NOEMBED"] = "noembed";
    TAG_NAMES["NOSCRIPT"] = "noscript";
    TAG_NAMES["OBJECT"] = "object";
    TAG_NAMES["OL"] = "ol";
    TAG_NAMES["OPTGROUP"] = "optgroup";
    TAG_NAMES["OPTION"] = "option";
    TAG_NAMES["P"] = "p";
    TAG_NAMES["PARAM"] = "param";
    TAG_NAMES["PLAINTEXT"] = "plaintext";
    TAG_NAMES["PRE"] = "pre";
    TAG_NAMES["RB"] = "rb";
    TAG_NAMES["RP"] = "rp";
    TAG_NAMES["RT"] = "rt";
    TAG_NAMES["RTC"] = "rtc";
    TAG_NAMES["RUBY"] = "ruby";
    TAG_NAMES["S"] = "s";
    TAG_NAMES["SCRIPT"] = "script";
    TAG_NAMES["SEARCH"] = "search";
    TAG_NAMES["SECTION"] = "section";
    TAG_NAMES["SELECT"] = "select";
    TAG_NAMES["SOURCE"] = "source";
    TAG_NAMES["SMALL"] = "small";
    TAG_NAMES["SPAN"] = "span";
    TAG_NAMES["STRIKE"] = "strike";
    TAG_NAMES["STRONG"] = "strong";
    TAG_NAMES["STYLE"] = "style";
    TAG_NAMES["SUB"] = "sub";
    TAG_NAMES["SUMMARY"] = "summary";
    TAG_NAMES["SUP"] = "sup";
    TAG_NAMES["TABLE"] = "table";
    TAG_NAMES["TBODY"] = "tbody";
    TAG_NAMES["TEMPLATE"] = "template";
    TAG_NAMES["TEXTAREA"] = "textarea";
    TAG_NAMES["TFOOT"] = "tfoot";
    TAG_NAMES["TD"] = "td";
    TAG_NAMES["TH"] = "th";
    TAG_NAMES["THEAD"] = "thead";
    TAG_NAMES["TITLE"] = "title";
    TAG_NAMES["TR"] = "tr";
    TAG_NAMES["TRACK"] = "track";
    TAG_NAMES["TT"] = "tt";
    TAG_NAMES["U"] = "u";
    TAG_NAMES["UL"] = "ul";
    TAG_NAMES["SVG"] = "svg";
    TAG_NAMES["VAR"] = "var";
    TAG_NAMES["WBR"] = "wbr";
    TAG_NAMES["XMP"] = "xmp";
})($5deb0c47e1a27c89$export$7e674a85a2656dce || ($5deb0c47e1a27c89$export$7e674a85a2656dce = {}));
var $5deb0c47e1a27c89$export$cb0999a53e0acaed;
(function(TAG_ID) {
    TAG_ID[TAG_ID["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID[TAG_ID["A"] = 1] = "A";
    TAG_ID[TAG_ID["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID[TAG_ID["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID[TAG_ID["APPLET"] = 4] = "APPLET";
    TAG_ID[TAG_ID["AREA"] = 5] = "AREA";
    TAG_ID[TAG_ID["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID[TAG_ID["ASIDE"] = 7] = "ASIDE";
    TAG_ID[TAG_ID["B"] = 8] = "B";
    TAG_ID[TAG_ID["BASE"] = 9] = "BASE";
    TAG_ID[TAG_ID["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID[TAG_ID["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID[TAG_ID["BIG"] = 12] = "BIG";
    TAG_ID[TAG_ID["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID[TAG_ID["BODY"] = 14] = "BODY";
    TAG_ID[TAG_ID["BR"] = 15] = "BR";
    TAG_ID[TAG_ID["BUTTON"] = 16] = "BUTTON";
    TAG_ID[TAG_ID["CAPTION"] = 17] = "CAPTION";
    TAG_ID[TAG_ID["CENTER"] = 18] = "CENTER";
    TAG_ID[TAG_ID["CODE"] = 19] = "CODE";
    TAG_ID[TAG_ID["COL"] = 20] = "COL";
    TAG_ID[TAG_ID["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID[TAG_ID["DD"] = 22] = "DD";
    TAG_ID[TAG_ID["DESC"] = 23] = "DESC";
    TAG_ID[TAG_ID["DETAILS"] = 24] = "DETAILS";
    TAG_ID[TAG_ID["DIALOG"] = 25] = "DIALOG";
    TAG_ID[TAG_ID["DIR"] = 26] = "DIR";
    TAG_ID[TAG_ID["DIV"] = 27] = "DIV";
    TAG_ID[TAG_ID["DL"] = 28] = "DL";
    TAG_ID[TAG_ID["DT"] = 29] = "DT";
    TAG_ID[TAG_ID["EM"] = 30] = "EM";
    TAG_ID[TAG_ID["EMBED"] = 31] = "EMBED";
    TAG_ID[TAG_ID["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID[TAG_ID["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID[TAG_ID["FIGURE"] = 34] = "FIGURE";
    TAG_ID[TAG_ID["FONT"] = 35] = "FONT";
    TAG_ID[TAG_ID["FOOTER"] = 36] = "FOOTER";
    TAG_ID[TAG_ID["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID[TAG_ID["FORM"] = 38] = "FORM";
    TAG_ID[TAG_ID["FRAME"] = 39] = "FRAME";
    TAG_ID[TAG_ID["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID[TAG_ID["H1"] = 41] = "H1";
    TAG_ID[TAG_ID["H2"] = 42] = "H2";
    TAG_ID[TAG_ID["H3"] = 43] = "H3";
    TAG_ID[TAG_ID["H4"] = 44] = "H4";
    TAG_ID[TAG_ID["H5"] = 45] = "H5";
    TAG_ID[TAG_ID["H6"] = 46] = "H6";
    TAG_ID[TAG_ID["HEAD"] = 47] = "HEAD";
    TAG_ID[TAG_ID["HEADER"] = 48] = "HEADER";
    TAG_ID[TAG_ID["HGROUP"] = 49] = "HGROUP";
    TAG_ID[TAG_ID["HR"] = 50] = "HR";
    TAG_ID[TAG_ID["HTML"] = 51] = "HTML";
    TAG_ID[TAG_ID["I"] = 52] = "I";
    TAG_ID[TAG_ID["IMG"] = 53] = "IMG";
    TAG_ID[TAG_ID["IMAGE"] = 54] = "IMAGE";
    TAG_ID[TAG_ID["INPUT"] = 55] = "INPUT";
    TAG_ID[TAG_ID["IFRAME"] = 56] = "IFRAME";
    TAG_ID[TAG_ID["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID[TAG_ID["LABEL"] = 58] = "LABEL";
    TAG_ID[TAG_ID["LI"] = 59] = "LI";
    TAG_ID[TAG_ID["LINK"] = 60] = "LINK";
    TAG_ID[TAG_ID["LISTING"] = 61] = "LISTING";
    TAG_ID[TAG_ID["MAIN"] = 62] = "MAIN";
    TAG_ID[TAG_ID["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID[TAG_ID["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID[TAG_ID["MATH"] = 65] = "MATH";
    TAG_ID[TAG_ID["MENU"] = 66] = "MENU";
    TAG_ID[TAG_ID["META"] = 67] = "META";
    TAG_ID[TAG_ID["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID[TAG_ID["MI"] = 69] = "MI";
    TAG_ID[TAG_ID["MO"] = 70] = "MO";
    TAG_ID[TAG_ID["MN"] = 71] = "MN";
    TAG_ID[TAG_ID["MS"] = 72] = "MS";
    TAG_ID[TAG_ID["MTEXT"] = 73] = "MTEXT";
    TAG_ID[TAG_ID["NAV"] = 74] = "NAV";
    TAG_ID[TAG_ID["NOBR"] = 75] = "NOBR";
    TAG_ID[TAG_ID["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID[TAG_ID["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID[TAG_ID["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID[TAG_ID["OBJECT"] = 79] = "OBJECT";
    TAG_ID[TAG_ID["OL"] = 80] = "OL";
    TAG_ID[TAG_ID["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID[TAG_ID["OPTION"] = 82] = "OPTION";
    TAG_ID[TAG_ID["P"] = 83] = "P";
    TAG_ID[TAG_ID["PARAM"] = 84] = "PARAM";
    TAG_ID[TAG_ID["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID[TAG_ID["PRE"] = 86] = "PRE";
    TAG_ID[TAG_ID["RB"] = 87] = "RB";
    TAG_ID[TAG_ID["RP"] = 88] = "RP";
    TAG_ID[TAG_ID["RT"] = 89] = "RT";
    TAG_ID[TAG_ID["RTC"] = 90] = "RTC";
    TAG_ID[TAG_ID["RUBY"] = 91] = "RUBY";
    TAG_ID[TAG_ID["S"] = 92] = "S";
    TAG_ID[TAG_ID["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID[TAG_ID["SEARCH"] = 94] = "SEARCH";
    TAG_ID[TAG_ID["SECTION"] = 95] = "SECTION";
    TAG_ID[TAG_ID["SELECT"] = 96] = "SELECT";
    TAG_ID[TAG_ID["SOURCE"] = 97] = "SOURCE";
    TAG_ID[TAG_ID["SMALL"] = 98] = "SMALL";
    TAG_ID[TAG_ID["SPAN"] = 99] = "SPAN";
    TAG_ID[TAG_ID["STRIKE"] = 100] = "STRIKE";
    TAG_ID[TAG_ID["STRONG"] = 101] = "STRONG";
    TAG_ID[TAG_ID["STYLE"] = 102] = "STYLE";
    TAG_ID[TAG_ID["SUB"] = 103] = "SUB";
    TAG_ID[TAG_ID["SUMMARY"] = 104] = "SUMMARY";
    TAG_ID[TAG_ID["SUP"] = 105] = "SUP";
    TAG_ID[TAG_ID["TABLE"] = 106] = "TABLE";
    TAG_ID[TAG_ID["TBODY"] = 107] = "TBODY";
    TAG_ID[TAG_ID["TEMPLATE"] = 108] = "TEMPLATE";
    TAG_ID[TAG_ID["TEXTAREA"] = 109] = "TEXTAREA";
    TAG_ID[TAG_ID["TFOOT"] = 110] = "TFOOT";
    TAG_ID[TAG_ID["TD"] = 111] = "TD";
    TAG_ID[TAG_ID["TH"] = 112] = "TH";
    TAG_ID[TAG_ID["THEAD"] = 113] = "THEAD";
    TAG_ID[TAG_ID["TITLE"] = 114] = "TITLE";
    TAG_ID[TAG_ID["TR"] = 115] = "TR";
    TAG_ID[TAG_ID["TRACK"] = 116] = "TRACK";
    TAG_ID[TAG_ID["TT"] = 117] = "TT";
    TAG_ID[TAG_ID["U"] = 118] = "U";
    TAG_ID[TAG_ID["UL"] = 119] = "UL";
    TAG_ID[TAG_ID["SVG"] = 120] = "SVG";
    TAG_ID[TAG_ID["VAR"] = 121] = "VAR";
    TAG_ID[TAG_ID["WBR"] = 122] = "WBR";
    TAG_ID[TAG_ID["XMP"] = 123] = "XMP";
})($5deb0c47e1a27c89$export$cb0999a53e0acaed || ($5deb0c47e1a27c89$export$cb0999a53e0acaed = {}));
const $5deb0c47e1a27c89$var$TAG_NAME_TO_ID = new Map([
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.A,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.A
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.ADDRESS,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.ADDRESS
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.ANNOTATION_XML,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.ANNOTATION_XML
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.APPLET,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.APPLET
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.AREA,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.AREA
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.ARTICLE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.ARTICLE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.ASIDE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.ASIDE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.B,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.B
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BASE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BASE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BASEFONT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BASEFONT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BGSOUND,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BGSOUND
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BIG,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BIG
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BLOCKQUOTE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BLOCKQUOTE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BODY,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BODY
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.BUTTON,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.BUTTON
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.CAPTION,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.CAPTION
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.CENTER,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.CENTER
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.CODE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.CODE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.COL,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.COL
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.COLGROUP,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.COLGROUP
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DD,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DD
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DESC,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DESC
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DETAILS,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DETAILS
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DIALOG,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DIALOG
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DIR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DIR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DIV,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DIV
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DL,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DL
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.DT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.DT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.EM,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.EM
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.EMBED,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.EMBED
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FIELDSET,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FIELDSET
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FIGCAPTION,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FIGCAPTION
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FIGURE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FIGURE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FONT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FONT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FOOTER,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FOOTER
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FOREIGN_OBJECT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FOREIGN_OBJECT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FORM,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FORM
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FRAME,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FRAME
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.FRAMESET,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.FRAMESET
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.H1,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.H1
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.H2,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.H2
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.H3,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.H3
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.H4,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.H4
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.H5,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.H5
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.H6,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.H6
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.HEAD,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.HEAD
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.HEADER,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.HEADER
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.HGROUP,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.HGROUP
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.HR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.HR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.HTML,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.HTML
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.I,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.I
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.IMG,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.IMG
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.IMAGE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.IMAGE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.INPUT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.INPUT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.IFRAME,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.IFRAME
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.KEYGEN,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.KEYGEN
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.LABEL,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.LABEL
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.LI,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.LI
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.LINK,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.LINK
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.LISTING,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.LISTING
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MAIN,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MAIN
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MALIGNMARK,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MALIGNMARK
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MARQUEE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MARQUEE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MATH,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MATH
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MENU,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MENU
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.META,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.META
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MGLYPH,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MGLYPH
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MI,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MI
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MO,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MO
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MN,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MN
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MS,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MS
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.MTEXT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.MTEXT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.NAV,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.NAV
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.NOBR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.NOBR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.NOFRAMES,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.NOFRAMES
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.NOEMBED,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.NOEMBED
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.NOSCRIPT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.NOSCRIPT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.OBJECT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.OBJECT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.OL,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.OL
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.OPTGROUP,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.OPTGROUP
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.OPTION,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.OPTION
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.P,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.P
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.PARAM,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.PARAM
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.PLAINTEXT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.PLAINTEXT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.PRE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.PRE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.RB,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.RB
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.RP,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.RP
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.RT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.RT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.RTC,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.RTC
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.RUBY,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.RUBY
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.S,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.S
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SCRIPT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SCRIPT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SEARCH,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SEARCH
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SECTION,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SECTION
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SELECT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SELECT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SOURCE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SOURCE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SMALL,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SMALL
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SPAN,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SPAN
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.STRIKE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.STRIKE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.STRONG,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.STRONG
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.STYLE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.STYLE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SUB,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SUB
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SUMMARY,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SUMMARY
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SUP,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SUP
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TABLE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TABLE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TBODY,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TBODY
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TEMPLATE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TEMPLATE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TEXTAREA,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TEXTAREA
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TFOOT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TFOOT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TD,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TD
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TH,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TH
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.THEAD,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.THEAD
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TITLE,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TITLE
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TRACK,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TRACK
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.TT,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.TT
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.U,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.U
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.UL,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.UL
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.SVG,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.SVG
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.VAR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.VAR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.WBR,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.WBR
    ],
    [
        $5deb0c47e1a27c89$export$7e674a85a2656dce.XMP,
        $5deb0c47e1a27c89$export$cb0999a53e0acaed.XMP
    ]
]);
function $5deb0c47e1a27c89$export$39db8a1315f68282(tagName) {
    var _a;
    return (_a = $5deb0c47e1a27c89$var$TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : $5deb0c47e1a27c89$export$cb0999a53e0acaed.UNKNOWN;
}
const $5deb0c47e1a27c89$var$$ = $5deb0c47e1a27c89$export$cb0999a53e0acaed;
const $5deb0c47e1a27c89$export$7e5172336f7d2bbb = {
    [$5deb0c47e1a27c89$export$fb4028874a74450.HTML]: new Set([
        $5deb0c47e1a27c89$var$$.ADDRESS,
        $5deb0c47e1a27c89$var$$.APPLET,
        $5deb0c47e1a27c89$var$$.AREA,
        $5deb0c47e1a27c89$var$$.ARTICLE,
        $5deb0c47e1a27c89$var$$.ASIDE,
        $5deb0c47e1a27c89$var$$.BASE,
        $5deb0c47e1a27c89$var$$.BASEFONT,
        $5deb0c47e1a27c89$var$$.BGSOUND,
        $5deb0c47e1a27c89$var$$.BLOCKQUOTE,
        $5deb0c47e1a27c89$var$$.BODY,
        $5deb0c47e1a27c89$var$$.BR,
        $5deb0c47e1a27c89$var$$.BUTTON,
        $5deb0c47e1a27c89$var$$.CAPTION,
        $5deb0c47e1a27c89$var$$.CENTER,
        $5deb0c47e1a27c89$var$$.COL,
        $5deb0c47e1a27c89$var$$.COLGROUP,
        $5deb0c47e1a27c89$var$$.DD,
        $5deb0c47e1a27c89$var$$.DETAILS,
        $5deb0c47e1a27c89$var$$.DIR,
        $5deb0c47e1a27c89$var$$.DIV,
        $5deb0c47e1a27c89$var$$.DL,
        $5deb0c47e1a27c89$var$$.DT,
        $5deb0c47e1a27c89$var$$.EMBED,
        $5deb0c47e1a27c89$var$$.FIELDSET,
        $5deb0c47e1a27c89$var$$.FIGCAPTION,
        $5deb0c47e1a27c89$var$$.FIGURE,
        $5deb0c47e1a27c89$var$$.FOOTER,
        $5deb0c47e1a27c89$var$$.FORM,
        $5deb0c47e1a27c89$var$$.FRAME,
        $5deb0c47e1a27c89$var$$.FRAMESET,
        $5deb0c47e1a27c89$var$$.H1,
        $5deb0c47e1a27c89$var$$.H2,
        $5deb0c47e1a27c89$var$$.H3,
        $5deb0c47e1a27c89$var$$.H4,
        $5deb0c47e1a27c89$var$$.H5,
        $5deb0c47e1a27c89$var$$.H6,
        $5deb0c47e1a27c89$var$$.HEAD,
        $5deb0c47e1a27c89$var$$.HEADER,
        $5deb0c47e1a27c89$var$$.HGROUP,
        $5deb0c47e1a27c89$var$$.HR,
        $5deb0c47e1a27c89$var$$.HTML,
        $5deb0c47e1a27c89$var$$.IFRAME,
        $5deb0c47e1a27c89$var$$.IMG,
        $5deb0c47e1a27c89$var$$.INPUT,
        $5deb0c47e1a27c89$var$$.LI,
        $5deb0c47e1a27c89$var$$.LINK,
        $5deb0c47e1a27c89$var$$.LISTING,
        $5deb0c47e1a27c89$var$$.MAIN,
        $5deb0c47e1a27c89$var$$.MARQUEE,
        $5deb0c47e1a27c89$var$$.MENU,
        $5deb0c47e1a27c89$var$$.META,
        $5deb0c47e1a27c89$var$$.NAV,
        $5deb0c47e1a27c89$var$$.NOEMBED,
        $5deb0c47e1a27c89$var$$.NOFRAMES,
        $5deb0c47e1a27c89$var$$.NOSCRIPT,
        $5deb0c47e1a27c89$var$$.OBJECT,
        $5deb0c47e1a27c89$var$$.OL,
        $5deb0c47e1a27c89$var$$.P,
        $5deb0c47e1a27c89$var$$.PARAM,
        $5deb0c47e1a27c89$var$$.PLAINTEXT,
        $5deb0c47e1a27c89$var$$.PRE,
        $5deb0c47e1a27c89$var$$.SCRIPT,
        $5deb0c47e1a27c89$var$$.SECTION,
        $5deb0c47e1a27c89$var$$.SELECT,
        $5deb0c47e1a27c89$var$$.SOURCE,
        $5deb0c47e1a27c89$var$$.STYLE,
        $5deb0c47e1a27c89$var$$.SUMMARY,
        $5deb0c47e1a27c89$var$$.TABLE,
        $5deb0c47e1a27c89$var$$.TBODY,
        $5deb0c47e1a27c89$var$$.TD,
        $5deb0c47e1a27c89$var$$.TEMPLATE,
        $5deb0c47e1a27c89$var$$.TEXTAREA,
        $5deb0c47e1a27c89$var$$.TFOOT,
        $5deb0c47e1a27c89$var$$.TH,
        $5deb0c47e1a27c89$var$$.THEAD,
        $5deb0c47e1a27c89$var$$.TITLE,
        $5deb0c47e1a27c89$var$$.TR,
        $5deb0c47e1a27c89$var$$.TRACK,
        $5deb0c47e1a27c89$var$$.UL,
        $5deb0c47e1a27c89$var$$.WBR,
        $5deb0c47e1a27c89$var$$.XMP
    ]),
    [$5deb0c47e1a27c89$export$fb4028874a74450.MATHML]: new Set([
        $5deb0c47e1a27c89$var$$.MI,
        $5deb0c47e1a27c89$var$$.MO,
        $5deb0c47e1a27c89$var$$.MN,
        $5deb0c47e1a27c89$var$$.MS,
        $5deb0c47e1a27c89$var$$.MTEXT,
        $5deb0c47e1a27c89$var$$.ANNOTATION_XML
    ]),
    [$5deb0c47e1a27c89$export$fb4028874a74450.SVG]: new Set([
        $5deb0c47e1a27c89$var$$.TITLE,
        $5deb0c47e1a27c89$var$$.FOREIGN_OBJECT,
        $5deb0c47e1a27c89$var$$.DESC
    ]),
    [$5deb0c47e1a27c89$export$fb4028874a74450.XLINK]: new Set(),
    [$5deb0c47e1a27c89$export$fb4028874a74450.XML]: new Set(),
    [$5deb0c47e1a27c89$export$fb4028874a74450.XMLNS]: new Set()
};
const $5deb0c47e1a27c89$export$1ecc20fa0754c045 = new Set([
    $5deb0c47e1a27c89$var$$.H1,
    $5deb0c47e1a27c89$var$$.H2,
    $5deb0c47e1a27c89$var$$.H3,
    $5deb0c47e1a27c89$var$$.H4,
    $5deb0c47e1a27c89$var$$.H5,
    $5deb0c47e1a27c89$var$$.H6
]);
const $5deb0c47e1a27c89$var$UNESCAPED_TEXT = new Set([
    $5deb0c47e1a27c89$export$7e674a85a2656dce.STYLE,
    $5deb0c47e1a27c89$export$7e674a85a2656dce.SCRIPT,
    $5deb0c47e1a27c89$export$7e674a85a2656dce.XMP,
    $5deb0c47e1a27c89$export$7e674a85a2656dce.IFRAME,
    $5deb0c47e1a27c89$export$7e674a85a2656dce.NOEMBED,
    $5deb0c47e1a27c89$export$7e674a85a2656dce.NOFRAMES,
    $5deb0c47e1a27c89$export$7e674a85a2656dce.PLAINTEXT
]);
function $5deb0c47e1a27c89$export$4ce4f8c09f921aed(tn, scriptingEnabled) {
    return $5deb0c47e1a27c89$var$UNESCAPED_TEXT.has(tn) || scriptingEnabled && tn === $5deb0c47e1a27c89$export$7e674a85a2656dce.NOSCRIPT;
}


//States
var $2c4fc6157fdd925a$var$State;
(function(State) {
    State[State["DATA"] = 0] = "DATA";
    State[State["RCDATA"] = 1] = "RCDATA";
    State[State["RAWTEXT"] = 2] = "RAWTEXT";
    State[State["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
    State[State["PLAINTEXT"] = 4] = "PLAINTEXT";
    State[State["TAG_OPEN"] = 5] = "TAG_OPEN";
    State[State["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
    State[State["TAG_NAME"] = 7] = "TAG_NAME";
    State[State["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
    State[State["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
    State[State["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
    State[State["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
    State[State["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
    State[State["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
    State[State["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
    State[State["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
    State[State["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
    State[State["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
    State[State["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
    State[State["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
    State[State["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
    State[State["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
    State[State["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
    State[State["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
    State[State["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
    State[State["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
    State[State["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
    State[State["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
    State[State["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
    State[State["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
    State[State["COMMENT_START"] = 42] = "COMMENT_START";
    State[State["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
    State[State["COMMENT"] = 44] = "COMMENT";
    State[State["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
    State[State["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
    State[State["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
    State[State["COMMENT_END"] = 50] = "COMMENT_END";
    State[State["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
    State[State["DOCTYPE"] = 52] = "DOCTYPE";
    State[State["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
    State[State["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
    State[State["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
    State[State["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
    State[State["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
    State[State["CDATA_SECTION"] = 68] = "CDATA_SECTION";
    State[State["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
    State[State["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
    State[State["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
    State[State["AMBIGUOUS_AMPERSAND"] = 72] = "AMBIGUOUS_AMPERSAND";
})($2c4fc6157fdd925a$var$State || ($2c4fc6157fdd925a$var$State = {}));
const $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159 = {
    DATA: $2c4fc6157fdd925a$var$State.DATA,
    RCDATA: $2c4fc6157fdd925a$var$State.RCDATA,
    RAWTEXT: $2c4fc6157fdd925a$var$State.RAWTEXT,
    SCRIPT_DATA: $2c4fc6157fdd925a$var$State.SCRIPT_DATA,
    PLAINTEXT: $2c4fc6157fdd925a$var$State.PLAINTEXT,
    CDATA_SECTION: $2c4fc6157fdd925a$var$State.CDATA_SECTION
};
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function $2c4fc6157fdd925a$var$isAsciiDigit(cp) {
    return cp >= (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).DIGIT_0 && cp <= (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).DIGIT_9;
}
function $2c4fc6157fdd925a$var$isAsciiUpper(cp) {
    return cp >= (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_A && cp <= (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_Z;
}
function $2c4fc6157fdd925a$var$isAsciiLower(cp) {
    return cp >= (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LATIN_SMALL_A && cp <= (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LATIN_SMALL_Z;
}
function $2c4fc6157fdd925a$var$isAsciiLetter(cp) {
    return $2c4fc6157fdd925a$var$isAsciiLower(cp) || $2c4fc6157fdd925a$var$isAsciiUpper(cp);
}
function $2c4fc6157fdd925a$var$isAsciiAlphaNumeric(cp) {
    return $2c4fc6157fdd925a$var$isAsciiLetter(cp) || $2c4fc6157fdd925a$var$isAsciiDigit(cp);
}
function $2c4fc6157fdd925a$var$toAsciiLower(cp) {
    return cp + 32;
}
function $2c4fc6157fdd925a$var$isWhitespace(cp) {
    return cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED;
}
function $2c4fc6157fdd925a$var$isScriptDataDoubleEscapeSequenceEnd(cp) {
    return $2c4fc6157fdd925a$var$isWhitespace(cp) || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS || cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN;
}
function $2c4fc6157fdd925a$var$getErrorForNumericCharacterReference(code) {
    if (code === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL) return (0, $0d242c12c37a5644$export$9e0efcb140234d2).nullCharacterReference;
    else if (code > 1114111) return (0, $0d242c12c37a5644$export$9e0efcb140234d2).characterReferenceOutsideUnicodeRange;
    else if ((0, $13b6aff9b77366c5$export$7e678b42035e707f)(code)) return (0, $0d242c12c37a5644$export$9e0efcb140234d2).surrogateCharacterReference;
    else if ((0, $13b6aff9b77366c5$export$b3484aaf321bda02)(code)) return (0, $0d242c12c37a5644$export$9e0efcb140234d2).noncharacterCharacterReference;
    else if ((0, $13b6aff9b77366c5$export$d6953a6077926e)(code) || code === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) return (0, $0d242c12c37a5644$export$9e0efcb140234d2).controlCharacterReference;
    return null;
}
class $2c4fc6157fdd925a$export$55e8b082af4aa63e {
    constructor(options, handler){
        this.options = options;
        this.handler = handler;
        this.paused = false;
        /** Ensures that the parsing loop isn't run multiple times at once. */ this.inLoop = false;
        /**
         * Indicates that the current adjusted node exists, is not an element in the HTML namespace,
         * and that it is not an integration point for either MathML or HTML.
         *
         * @see {@link https://html.spec.whatwg.org/multipage/parsing.html#tree-construction}
         */ this.inForeignNode = false;
        this.lastStartTagName = '';
        this.active = false;
        this.state = $2c4fc6157fdd925a$var$State.DATA;
        this.returnState = $2c4fc6157fdd925a$var$State.DATA;
        this.entityStartPos = 0;
        this.consumedAfterSnapshot = -1;
        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = {
            name: '',
            value: ''
        };
        this.preprocessor = new (0, $18505f1274889f1f$export$35db5c8036a15ad1)(handler);
        this.currentLocation = this.getCurrentLocation(-1);
        this.entityDecoder = new (0, $551967bbe53cae21$exports.EntityDecoder)((0, $551967bbe53cae21$exports.htmlDecodeTree), (cp, consumed)=>{
            // Note: Set `pos` _before_ flushing, as flushing might drop
            // the current chunk and invalidate `entityStartPos`.
            this.preprocessor.pos = this.entityStartPos + consumed - 1;
            this._flushCodePointConsumedAsCharacterReference(cp);
        }, handler.onParseError ? {
            missingSemicolonAfterCharacterReference: ()=>{
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingSemicolonAfterCharacterReference, 1);
            },
            absenceOfDigitsInNumericCharacterReference: (consumed)=>{
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + consumed);
            },
            validateNumericCharacterReference: (code)=>{
                const error = $2c4fc6157fdd925a$var$getErrorForNumericCharacterReference(code);
                if (error) this._err(error, 1);
            }
        } : undefined);
    }
    //Errors
    _err(code, cpOffset = 0) {
        var _a, _b;
        (_b = (_a = this.handler).onParseError) === null || _b === void 0 || _b.call(_a, this.preprocessor.getError(code, cpOffset));
    }
    // NOTE: `offset` may never run across line boundaries.
    getCurrentLocation(offset) {
        if (!this.options.sourceCodeLocationInfo) return null;
        return {
            startLine: this.preprocessor.line,
            startCol: this.preprocessor.col - offset,
            startOffset: this.preprocessor.offset - offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }
    _runParsingLoop() {
        if (this.inLoop) return;
        this.inLoop = true;
        while(this.active && !this.paused){
            this.consumedAfterSnapshot = 0;
            const cp = this._consume();
            if (!this._ensureHibernation()) this._callState(cp);
        }
        this.inLoop = false;
    }
    //API
    pause() {
        this.paused = true;
    }
    resume(writeCallback) {
        if (!this.paused) throw new Error('Parser was already resumed');
        this.paused = false;
        // Necessary for synchronous resume.
        if (this.inLoop) return;
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    write(chunk, isLastChunk, writeCallback) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
        this._runParsingLoop();
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            this.preprocessor.retreat(this.consumedAfterSnapshot);
            this.consumedAfterSnapshot = 0;
            this.active = false;
            return true;
        }
        return false;
    }
    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }
    _advanceBy(count) {
        this.consumedAfterSnapshot += count;
        for(let i = 0; i < count; i++)this.preprocessor.advance();
    }
    _consumeSequenceIfMatch(pattern, caseSensitive) {
        if (this.preprocessor.startsWith(pattern, caseSensitive)) {
            // We will already have consumed one character before calling this method.
            this._advanceBy(pattern.length - 1);
            return true;
        }
        return false;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: (0, $05436e75d13cd0ed$export$f435f793048e7a0f).START_TAG,
            tagName: '',
            tagID: (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(1)
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: (0, $05436e75d13cd0ed$export$f435f793048e7a0f).END_TAG,
            tagName: '',
            tagID: (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(2)
        };
    }
    _createCommentToken(offset) {
        this.currentToken = {
            type: (0, $05436e75d13cd0ed$export$f435f793048e7a0f).COMMENT,
            data: '',
            location: this.getCurrentLocation(offset)
        };
    }
    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: (0, $05436e75d13cd0ed$export$f435f793048e7a0f).DOCTYPE,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null,
            location: this.currentLocation
        };
    }
    _createCharacterToken(type, chars) {
        this.currentCharacterToken = {
            type: type,
            chars: chars,
            location: this.currentLocation
        };
    }
    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ''
        };
        this.currentLocation = this.getCurrentLocation(0);
    }
    _leaveAttrName() {
        var _a;
        var _b;
        const token = this.currentToken;
        if ((0, $05436e75d13cd0ed$export$df33bba014b5841e)(token, this.currentAttr.name) === null) {
            token.attrs.push(this.currentAttr);
            if (token.location && this.currentLocation) {
                const attrLocations = (_a = (_b = token.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = Object.create(null);
                attrLocations[this.currentAttr.name] = this.currentLocation;
                // Set end location
                this._leaveAttrValue();
            }
        } else this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).duplicateAttribute);
    }
    _leaveAttrValue() {
        if (this.currentLocation) {
            this.currentLocation.endLine = this.preprocessor.line;
            this.currentLocation.endCol = this.preprocessor.col;
            this.currentLocation.endOffset = this.preprocessor.offset;
        }
    }
    //Token emission
    prepareToken(ct) {
        this._emitCurrentCharacterToken(ct.location);
        this.currentToken = null;
        if (ct.location) {
            ct.location.endLine = this.preprocessor.line;
            ct.location.endCol = this.preprocessor.col + 1;
            ct.location.endOffset = this.preprocessor.offset + 1;
        }
        this.currentLocation = this.getCurrentLocation(-1);
    }
    emitCurrentTagToken() {
        const ct = this.currentToken;
        this.prepareToken(ct);
        ct.tagID = (0, $5deb0c47e1a27c89$export$39db8a1315f68282)(ct.tagName);
        if (ct.type === (0, $05436e75d13cd0ed$export$f435f793048e7a0f).START_TAG) {
            this.lastStartTagName = ct.tagName;
            this.handler.onStartTag(ct);
        } else {
            if (ct.attrs.length > 0) this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithAttributes);
            if (ct.selfClosing) this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithTrailingSolidus);
            this.handler.onEndTag(ct);
        }
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentComment(ct) {
        this.prepareToken(ct);
        this.handler.onComment(ct);
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentDoctype(ct) {
        this.prepareToken(ct);
        this.handler.onDoctype(ct);
        this.preprocessor.dropParsedChunk();
    }
    _emitCurrentCharacterToken(nextLocation) {
        if (this.currentCharacterToken) {
            //NOTE: if we have a pending character token, make it's end location equal to the
            //current token's start location.
            if (nextLocation && this.currentCharacterToken.location) {
                this.currentCharacterToken.location.endLine = nextLocation.startLine;
                this.currentCharacterToken.location.endCol = nextLocation.startCol;
                this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
            }
            switch(this.currentCharacterToken.type){
                case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).CHARACTER:
                    this.handler.onCharacter(this.currentCharacterToken);
                    break;
                case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).NULL_CHARACTER:
                    this.handler.onNullCharacter(this.currentCharacterToken);
                    break;
                case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                    this.handler.onWhitespaceCharacter(this.currentCharacterToken);
                    break;
            }
            this.currentCharacterToken = null;
        }
    }
    _emitEOFToken() {
        const location = this.getCurrentLocation(0);
        if (location) {
            location.endLine = location.startLine;
            location.endCol = location.startCol;
            location.endOffset = location.startOffset;
        }
        this._emitCurrentCharacterToken(location);
        this.handler.onEof({
            type: (0, $05436e75d13cd0ed$export$f435f793048e7a0f).EOF,
            location: location
        });
        this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: The specification uses only one type of character token (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken) {
            if (this.currentCharacterToken.type === type) {
                this.currentCharacterToken.chars += ch;
                return;
            } else {
                this.currentLocation = this.getCurrentLocation(0);
                this._emitCurrentCharacterToken(this.currentLocation);
                this.preprocessor.dropParsedChunk();
            }
        }
        this._createCharacterToken(type, ch);
    }
    _emitCodePoint(cp) {
        const type = $2c4fc6157fdd925a$var$isWhitespace(cp) ? (0, $05436e75d13cd0ed$export$f435f793048e7a0f).WHITESPACE_CHARACTER : cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL ? (0, $05436e75d13cd0ed$export$f435f793048e7a0f).NULL_CHARACTER : (0, $05436e75d13cd0ed$export$f435f793048e7a0f).CHARACTER;
        this._appendCharToCurrentCharacterToken(type, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken((0, $05436e75d13cd0ed$export$f435f793048e7a0f).CHARACTER, ch);
    }
    // Character reference helpers
    _startCharacterReference() {
        this.returnState = this.state;
        this.state = $2c4fc6157fdd925a$var$State.CHARACTER_REFERENCE;
        this.entityStartPos = this.preprocessor.pos;
        this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? (0, $551967bbe53cae21$exports.DecodingMode).Attribute : (0, $551967bbe53cae21$exports.DecodingMode).Legacy);
    }
    _isCharacterReferenceInAttribute() {
        return this.returnState === $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_UNQUOTED;
    }
    _flushCodePointConsumedAsCharacterReference(cp) {
        if (this._isCharacterReferenceInAttribute()) this.currentAttr.value += String.fromCodePoint(cp);
        else this._emitCodePoint(cp);
    }
    // Calling states this way turns out to be much faster than any other approach.
    _callState(cp) {
        switch(this.state){
            case $2c4fc6157fdd925a$var$State.DATA:
                this._stateData(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RCDATA:
                this._stateRcdata(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RAWTEXT:
                this._stateRawtext(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA:
                this._stateScriptData(cp);
                break;
            case $2c4fc6157fdd925a$var$State.PLAINTEXT:
                this._statePlaintext(cp);
                break;
            case $2c4fc6157fdd925a$var$State.TAG_OPEN:
                this._stateTagOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.END_TAG_OPEN:
                this._stateEndTagOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.TAG_NAME:
                this._stateTagName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RCDATA_LESS_THAN_SIGN:
                this._stateRcdataLessThanSign(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RCDATA_END_TAG_OPEN:
                this._stateRcdataEndTagOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RCDATA_END_TAG_NAME:
                this._stateRcdataEndTagName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RAWTEXT_LESS_THAN_SIGN:
                this._stateRawtextLessThanSign(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RAWTEXT_END_TAG_OPEN:
                this._stateRawtextEndTagOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.RAWTEXT_END_TAG_NAME:
                this._stateRawtextEndTagName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_LESS_THAN_SIGN:
                this._stateScriptDataLessThanSign(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_END_TAG_OPEN:
                this._stateScriptDataEndTagOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_END_TAG_NAME:
                this._stateScriptDataEndTagName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPE_START:
                this._stateScriptDataEscapeStart(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPE_START_DASH:
                this._stateScriptDataEscapeStartDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED:
                this._stateScriptDataEscaped(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_DASH:
                this._stateScriptDataEscapedDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH:
                this._stateScriptDataEscapedDashDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataEscapedLessThanSign(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
                this._stateScriptDataEscapedEndTagOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
                this._stateScriptDataEscapedEndTagName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START:
                this._stateScriptDataDoubleEscapeStart(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED:
                this._stateScriptDataDoubleEscaped(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
                this._stateScriptDataDoubleEscapedDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
                this._stateScriptDataDoubleEscapedDashDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataDoubleEscapedLessThanSign(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END:
                this._stateScriptDataDoubleEscapeEnd(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME:
                this._stateBeforeAttributeName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.ATTRIBUTE_NAME:
                this._stateAttributeName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_ATTRIBUTE_NAME:
                this._stateAfterAttributeName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_VALUE:
                this._stateBeforeAttributeValue(cp);
                break;
            case $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
                this._stateAttributeValueDoubleQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED:
                this._stateAttributeValueSingleQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_UNQUOTED:
                this._stateAttributeValueUnquoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED:
                this._stateAfterAttributeValueQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.SELF_CLOSING_START_TAG:
                this._stateSelfClosingStartTag(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BOGUS_COMMENT:
                this._stateBogusComment(cp);
                break;
            case $2c4fc6157fdd925a$var$State.MARKUP_DECLARATION_OPEN:
                this._stateMarkupDeclarationOpen(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_START:
                this._stateCommentStart(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_START_DASH:
                this._stateCommentStartDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT:
                this._stateComment(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN:
                this._stateCommentLessThanSign(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN_BANG:
                this._stateCommentLessThanSignBang(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH:
                this._stateCommentLessThanSignBangDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
                this._stateCommentLessThanSignBangDashDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_END_DASH:
                this._stateCommentEndDash(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_END:
                this._stateCommentEnd(cp);
                break;
            case $2c4fc6157fdd925a$var$State.COMMENT_END_BANG:
                this._stateCommentEndBang(cp);
                break;
            case $2c4fc6157fdd925a$var$State.DOCTYPE:
                this._stateDoctype(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_NAME:
                this._stateBeforeDoctypeName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.DOCTYPE_NAME:
                this._stateDoctypeName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_NAME:
                this._stateAfterDoctypeName(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD:
                this._stateAfterDoctypePublicKeyword(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateBeforeDoctypePublicIdentifier(cp);
                break;
            case $2c4fc6157fdd925a$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypePublicIdentifierDoubleQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypePublicIdentifierSingleQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateAfterDoctypePublicIdentifier(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
                this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD:
                this._stateAfterDoctypeSystemKeyword(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateBeforeDoctypeSystemIdentifier(cp);
                break;
            case $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypeSystemIdentifierSingleQuoted(cp);
                break;
            case $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateAfterDoctypeSystemIdentifier(cp);
                break;
            case $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE:
                this._stateBogusDoctype(cp);
                break;
            case $2c4fc6157fdd925a$var$State.CDATA_SECTION:
                this._stateCdataSection(cp);
                break;
            case $2c4fc6157fdd925a$var$State.CDATA_SECTION_BRACKET:
                this._stateCdataSectionBracket(cp);
                break;
            case $2c4fc6157fdd925a$var$State.CDATA_SECTION_END:
                this._stateCdataSectionEnd(cp);
                break;
            case $2c4fc6157fdd925a$var$State.CHARACTER_REFERENCE:
                this._stateCharacterReference();
                break;
            case $2c4fc6157fdd925a$var$State.AMBIGUOUS_AMPERSAND:
                this._stateAmbiguousAmpersand(cp);
                break;
            default:
                throw new Error('Unknown state');
        }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    _stateData(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.TAG_OPEN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitCodePoint(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    //  RCDATA state
    //------------------------------------------------------------------
    _stateRcdata(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.RCDATA_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    _stateRawtext(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.RAWTEXT_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data state
    //------------------------------------------------------------------
    _stateScriptData(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    _statePlaintext(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Tag open state
    //------------------------------------------------------------------
    _stateTagOpen(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this._createStartTagToken();
            this.state = $2c4fc6157fdd925a$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.MARKUP_DECLARATION_OPEN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $2c4fc6157fdd925a$var$State.END_TAG_OPEN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUESTION_MARK:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedQuestionMarkInsteadOfTagName);
                this._createCommentToken(1);
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('<');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._emitChars('<');
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this._stateData(cp);
        }
    }
    // End tag open state
    //------------------------------------------------------------------
    _stateEndTagOpen(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this.state = $2c4fc6157fdd925a$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingEndTagName);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('</');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._createCommentToken(2);
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
        }
    }
    // Tag name state
    //------------------------------------------------------------------
    _stateTagName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $2c4fc6157fdd925a$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.tagName += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                token.tagName += String.fromCodePoint($2c4fc6157fdd925a$var$isAsciiUpper(cp) ? $2c4fc6157fdd925a$var$toAsciiLower(cp) : cp);
        }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    _stateRcdataLessThanSign(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $2c4fc6157fdd925a$var$State.RCDATA_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $2c4fc6157fdd925a$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    _stateRcdataEndTagOpen(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this.state = $2c4fc6157fdd925a$var$State.RCDATA_END_TAG_NAME;
            this._stateRcdataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    handleSpecialEndTag(_cp) {
        if (!this.preprocessor.startsWith(this.lastStartTagName, false)) return !this._ensureHibernation();
        this._createEndTagToken();
        const token = this.currentToken;
        token.tagName = this.lastStartTagName;
        const cp = this.preprocessor.peek(this.lastStartTagName.length);
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME;
                return false;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $2c4fc6157fdd925a$var$State.SELF_CLOSING_START_TAG;
                return false;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._advanceBy(this.lastStartTagName.length);
                this.emitCurrentTagToken();
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                return false;
            default:
                return !this._ensureHibernation();
        }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    _stateRcdataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    _stateRawtextLessThanSign(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $2c4fc6157fdd925a$var$State.RAWTEXT_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $2c4fc6157fdd925a$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    _stateRawtextEndTagOpen(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this.state = $2c4fc6157fdd925a$var$State.RAWTEXT_END_TAG_NAME;
            this._stateRawtextEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    _stateRawtextEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataLessThanSign(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_END_TAG_OPEN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPE_START;
                this._emitChars('<!');
                break;
            default:
                this._emitChars('<');
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
                this._stateScriptData(cp);
        }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEndTagOpen(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_END_TAG_NAME;
            this._stateScriptDataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStart(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPE_START_DASH;
            this._emitChars('-');
        } else {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStartDash(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
            this._emitChars('-');
        } else {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escaped state
    //------------------------------------------------------------------
    _stateScriptDataEscaped(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDash(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDashDash(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataEscapedLessThanSign(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
        else if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this._emitChars('<');
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START;
            this._stateScriptDataDoubleEscapeStart(cp);
        } else {
            this._emitChars('<');
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagOpen(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiLetter(cp)) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
            this._stateScriptDataEscapedEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeStart(cp) {
        if (this.preprocessor.startsWith((0, $13b6aff9b77366c5$export$5abac700f947e2).SCRIPT, false) && $2c4fc6157fdd925a$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $13b6aff9b77366c5$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $13b6aff9b77366c5$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscaped(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDash(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDashDash(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedLessThanSign(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END;
            this._emitChars('/');
        } else {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeEnd(cp) {
        if (this.preprocessor.startsWith((0, $13b6aff9b77366c5$export$5abac700f947e2).SCRIPT, false) && $2c4fc6157fdd925a$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $13b6aff9b77366c5$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $13b6aff9b77366c5$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $2c4fc6157fdd925a$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Before attribute name state
    //------------------------------------------------------------------
    _stateBeforeAttributeName(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedEqualsSignBeforeAttributeName);
                this._createAttr('=');
                this.state = $2c4fc6157fdd925a$var$State.ATTRIBUTE_NAME;
                break;
            default:
                this._createAttr('');
                this.state = $2c4fc6157fdd925a$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Attribute name state
    //------------------------------------------------------------------
    _stateAttributeName(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._leaveAttrName();
                this.state = $2c4fc6157fdd925a$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._leaveAttrName();
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedCharacterInAttributeName);
                this.currentAttr.name += String.fromCodePoint(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.name += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            default:
                this.currentAttr.name += String.fromCodePoint($2c4fc6157fdd925a$var$isAsciiUpper(cp) ? $2c4fc6157fdd925a$var$toAsciiLower(cp) : cp);
        }
    }
    // After attribute name state
    //------------------------------------------------------------------
    _stateAfterAttributeName(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $2c4fc6157fdd925a$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._createAttr('');
                this.state = $2c4fc6157fdd925a$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Before attribute value state
    //------------------------------------------------------------------
    _stateBeforeAttributeValue(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingAttributeValue);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            default:
                this.state = $2c4fc6157fdd925a$var$State.ATTRIBUTE_VALUE_UNQUOTED;
                this._stateAttributeValueUnquoted(cp);
        }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueDoubleQuoted(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueSingleQuoted(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    _stateAttributeValueUnquoted(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GRAVE_ACCENT:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedCharacterInUnquotedAttributeValue);
                this.currentAttr.value += String.fromCodePoint(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    _stateAfterAttributeValueQuoted(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._leaveAttrValue();
                this.state = $2c4fc6157fdd925a$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceBetweenAttributes);
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    _stateSelfClosingStartTag(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    const token = this.currentToken;
                    token.selfClosing = true;
                    this.state = $2c4fc6157fdd925a$var$State.DATA;
                    this.emitCurrentTagToken();
                    break;
                }
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedSolidusInTag);
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Bogus comment state
    //------------------------------------------------------------------
    _stateBogusComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    _stateMarkupDeclarationOpen(cp) {
        if (this._consumeSequenceIfMatch((0, $13b6aff9b77366c5$export$5abac700f947e2).DASH_DASH, true)) {
            this._createCommentToken((0, $13b6aff9b77366c5$export$5abac700f947e2).DASH_DASH.length + 1);
            this.state = $2c4fc6157fdd925a$var$State.COMMENT_START;
        } else if (this._consumeSequenceIfMatch((0, $13b6aff9b77366c5$export$5abac700f947e2).DOCTYPE, false)) {
            // NOTE: Doctypes tokens are created without fixed offsets. We keep track of the moment a doctype *might* start here.
            this.currentLocation = this.getCurrentLocation((0, $13b6aff9b77366c5$export$5abac700f947e2).DOCTYPE.length + 1);
            this.state = $2c4fc6157fdd925a$var$State.DOCTYPE;
        } else if (this._consumeSequenceIfMatch((0, $13b6aff9b77366c5$export$5abac700f947e2).CDATA_START, true)) {
            if (this.inForeignNode) this.state = $2c4fc6157fdd925a$var$State.CDATA_SECTION;
            else {
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).cdataInHtmlContent);
                this._createCommentToken((0, $13b6aff9b77366c5$export$5abac700f947e2).CDATA_START.length + 1);
                this.currentToken.data = '[CDATA[';
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_COMMENT;
            }
        } else if (!this._ensureHibernation()) {
            this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).incorrectlyOpenedComment);
            this._createCommentToken(2);
            this.state = $2c4fc6157fdd925a$var$State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
        }
    }
    // Comment start state
    //------------------------------------------------------------------
    _stateCommentStart(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_START_DASH;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                    this.state = $2c4fc6157fdd925a$var$State.DATA;
                    const token = this.currentToken;
                    this.emitCurrentComment(token);
                    break;
                }
            default:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment start dash state
    //------------------------------------------------------------------
    _stateCommentStartDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_END;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment state
    //------------------------------------------------------------------
    _stateComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_END_DASH;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    _stateCommentLessThanSign(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                token.data += '!';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN_BANG;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                break;
            default:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBang(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH;
        else {
            this.state = $2c4fc6157fdd925a$var$State.COMMENT;
            this._stateComment(cp);
        }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDash(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $2c4fc6157fdd925a$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
        else {
            this.state = $2c4fc6157fdd925a$var$State.COMMENT_END_DASH;
            this._stateCommentEndDash(cp);
        }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDashDash(cp) {
        if (cp !== (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN && cp !== (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF) this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).nestedComment);
        this.state = $2c4fc6157fdd925a$var$State.COMMENT_END;
        this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    _stateCommentEndDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_END;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end state
    //------------------------------------------------------------------
    _stateCommentEnd(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_END_BANG;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '-';
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end bang state
    //------------------------------------------------------------------
    _stateCommentEndBang(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '--!';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT_END_DASH;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).incorrectlyClosedComment);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--!';
                this.state = $2c4fc6157fdd925a$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    _stateDoctype(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_NAME;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceBeforeDoctypeName);
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
        }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    _stateBeforeDoctypeName(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiUpper(cp)) {
            this._createDoctypeToken(String.fromCharCode($2c4fc6157fdd925a$var$toAsciiLower(cp)));
            this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_NAME;
        } else switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._createDoctypeToken((0, $13b6aff9b77366c5$export$e8d20e7a50e6c279));
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_NAME;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingDoctypeName);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this.state = $2c4fc6157fdd925a$var$State.DATA;
                    break;
                }
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._createDoctypeToken(String.fromCodePoint(cp));
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_NAME;
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    _stateDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_NAME;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.name += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.name += String.fromCodePoint($2c4fc6157fdd925a$var$isAsciiUpper(cp) ? $2c4fc6157fdd925a$var$toAsciiLower(cp) : cp);
        }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    _stateAfterDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                if (this._consumeSequenceIfMatch((0, $13b6aff9b77366c5$export$5abac700f947e2).PUBLIC, false)) this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD;
                else if (this._consumeSequenceIfMatch((0, $13b6aff9b77366c5$export$5abac700f947e2).SYSTEM, false)) this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD;
                else if (!this._ensureHibernation()) {
                    this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).invalidCharacterSequenceAfterDoctypeName);
                    token.forceQuirks = true;
                    this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                    this._stateBogusDoctype(cp);
                }
        }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.publicId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.publicId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $2c4fc6157fdd925a$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $2c4fc6157fdd925a$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $2c4fc6157fdd925a$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $2c4fc6157fdd925a$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $13b6aff9b77366c5$export$e8d20e7a50e6c279);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedCharacterAfterDoctypeSystemIdentifier);
                this.state = $2c4fc6157fdd925a$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    _stateBogusDoctype(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unexpectedNullCharacter);
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
        }
    }
    // CDATA section state
    //------------------------------------------------------------------
    _stateCdataSection(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this.state = $2c4fc6157fdd925a$var$State.CDATA_SECTION_BRACKET;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInCdata);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    _stateCdataSectionBracket(cp) {
        if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET) this.state = $2c4fc6157fdd925a$var$State.CDATA_SECTION_END;
        else {
            this._emitChars(']');
            this.state = $2c4fc6157fdd925a$var$State.CDATA_SECTION;
            this._stateCdataSection(cp);
        }
    }
    // CDATA section end state
    //------------------------------------------------------------------
    _stateCdataSectionEnd(cp) {
        switch(cp){
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $2c4fc6157fdd925a$var$State.DATA;
                break;
            case (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this._emitChars(']');
                break;
            default:
                this._emitChars(']]');
                this.state = $2c4fc6157fdd925a$var$State.CDATA_SECTION;
                this._stateCdataSection(cp);
        }
    }
    // Character reference state
    //------------------------------------------------------------------
    _stateCharacterReference() {
        let length = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
        if (length < 0) {
            if (this.preprocessor.lastChunkWritten) length = this.entityDecoder.end();
            else {
                // Wait for the rest of the entity.
                this.active = false;
                // Mark the entire buffer as read.
                this.preprocessor.pos = this.preprocessor.html.length - 1;
                this.consumedAfterSnapshot = 0;
                this.preprocessor.endOfChunkHit = true;
                return;
            }
        }
        if (length === 0) {
            // This was not a valid entity. Go back to the beginning, and
            // figure out what to do.
            this.preprocessor.pos = this.entityStartPos;
            this._flushCodePointConsumedAsCharacterReference((0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this.state = !this._isCharacterReferenceInAttribute() && $2c4fc6157fdd925a$var$isAsciiAlphaNumeric(this.preprocessor.peek(1)) ? $2c4fc6157fdd925a$var$State.AMBIGUOUS_AMPERSAND : this.returnState;
        } else // We successfully parsed an entity. Switch to the return state.
        this.state = this.returnState;
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    _stateAmbiguousAmpersand(cp) {
        if ($2c4fc6157fdd925a$var$isAsciiAlphaNumeric(cp)) this._flushCodePointConsumedAsCharacterReference(cp);
        else {
            if (cp === (0, $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0).SEMICOLON) this._err((0, $0d242c12c37a5644$export$9e0efcb140234d2).unknownNamedCharacterReference);
            this.state = this.returnState;
            this._callState(cp);
        }
    }
}



//Element utils
const $03dd88514dcbaecb$var$IMPLICIT_END_TAG_REQUIRED = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RB,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RP,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RTC
]);
const $03dd88514dcbaecb$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = new Set([
    ...$03dd88514dcbaecb$var$IMPLICIT_END_TAG_REQUIRED,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR
]);
const $03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).APPLET,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MARQUEE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OBJECT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH
]);
const $03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML_LIST = new Set([
    ...$03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OL,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UL
]);
const $03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML_BUTTON = new Set([
    ...$03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BUTTON
]);
const $03dd88514dcbaecb$var$SCOPING_ELEMENTS_MATHML = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ANNOTATION_XML,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MI,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MN,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MO,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MS,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MTEXT
]);
const $03dd88514dcbaecb$var$SCOPING_ELEMENTS_SVG = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DESC,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FOREIGN_OBJECT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE
]);
const $03dd88514dcbaecb$var$TABLE_ROW_CONTEXT = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML
]);
const $03dd88514dcbaecb$var$TABLE_BODY_CONTEXT = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML
]);
const $03dd88514dcbaecb$var$TABLE_CONTEXT = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML
]);
const $03dd88514dcbaecb$var$TABLE_CELLS = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH
]);
class $03dd88514dcbaecb$export$56decf886ed987d6 {
    get currentTmplContentOrNode() {
        return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
    constructor(document, treeAdapter, handler){
        this.treeAdapter = treeAdapter;
        this.handler = handler;
        this.items = [];
        this.tagIDs = [];
        this.stackTop = -1;
        this.tmplCount = 0;
        this.currentTagId = (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UNKNOWN;
        this.current = document;
    }
    //Index of element
    _indexOf(element) {
        return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
    push(element, tagID) {
        this.stackTop++;
        this.items[this.stackTop] = element;
        this.current = element;
        this.tagIDs[this.stackTop] = tagID;
        this.currentTagId = tagID;
        if (this._isInTemplate()) this.tmplCount++;
        this.handler.onItemPush(element, tagID, true);
    }
    pop() {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount--;
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, true);
    }
    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) this.current = newElement;
    }
    insertAfter(referenceElement, newElement, newElementID) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        this.tagIDs.splice(insertionIdx, 0, newElementID);
        this.stackTop++;
        if (insertionIdx === this.stackTop) this._updateCurrentElement();
        if (this.current && this.currentTagId !== undefined) this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
    popUntilTagNamePopped(tagName) {
        let targetIdx = this.stackTop + 1;
        do targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
        while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
        this.shortenToLength(Math.max(targetIdx, 0));
    }
    shortenToLength(idx) {
        while(this.stackTop >= idx){
            const popped = this.current;
            if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount -= 1;
            this.stackTop--;
            this._updateCurrentElement();
            this.handler.onItemPop(popped, this.stackTop < idx);
        }
    }
    popUntilElementPopped(element) {
        const idx = this._indexOf(element);
        this.shortenToLength(Math.max(idx, 0));
    }
    popUntilPopped(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(Math.max(idx, 0));
    }
    popUntilNumberedHeaderPopped() {
        this.popUntilPopped((0, $5deb0c47e1a27c89$export$1ecc20fa0754c045), (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    }
    popUntilTableCellPopped() {
        this.popUntilPopped($03dd88514dcbaecb$var$TABLE_CELLS, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    }
    popAllUpToHtmlElement() {
        //NOTE: here we assume that the root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.tmplCount = 0;
        this.shortenToLength(1);
    }
    _indexOfTagNames(tagNames, namespace) {
        for(let i = this.stackTop; i >= 0; i--){
            if (tagNames.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace) return i;
        }
        return -1;
    }
    clearBackTo(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx + 1);
    }
    clearBackToTableContext() {
        this.clearBackTo($03dd88514dcbaecb$var$TABLE_CONTEXT, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    }
    clearBackToTableBodyContext() {
        this.clearBackTo($03dd88514dcbaecb$var$TABLE_BODY_CONTEXT, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    }
    clearBackToTableRowContext() {
        this.clearBackTo($03dd88514dcbaecb$var$TABLE_ROW_CONTEXT, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    }
    remove(element) {
        const idx = this._indexOf(element);
        if (idx >= 0) {
            if (idx === this.stackTop) this.pop();
            else {
                this.items.splice(idx, 1);
                this.tagIDs.splice(idx, 1);
                this.stackTop--;
                this._updateCurrentElement();
                this.handler.onItemPop(element, false);
            }
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        return this.stackTop >= 1 && this.tagIDs[1] === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY ? this.items[1] : null;
    }
    contains(element) {
        return this._indexOf(element) > -1;
    }
    getCommonAncestor(element) {
        const elementIdx = this._indexOf(element) - 1;
        return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.tagIDs[0] === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML;
    }
    //Element in scope
    hasInDynamicScope(tagName, htmlScope) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            switch(this.treeAdapter.getNamespaceURI(this.items[i])){
                case (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML:
                    if (tn === tagName) return true;
                    if (htmlScope.has(tn)) return false;
                    break;
                case (0, $5deb0c47e1a27c89$export$fb4028874a74450).SVG:
                    if ($03dd88514dcbaecb$var$SCOPING_ELEMENTS_SVG.has(tn)) return false;
                    break;
                case (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML:
                    if ($03dd88514dcbaecb$var$SCOPING_ELEMENTS_MATHML.has(tn)) return false;
                    break;
            }
        }
        return true;
    }
    hasInScope(tagName) {
        return this.hasInDynamicScope(tagName, $03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML);
    }
    hasInListItemScope(tagName) {
        return this.hasInDynamicScope(tagName, $03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML_LIST);
    }
    hasInButtonScope(tagName) {
        return this.hasInDynamicScope(tagName, $03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML_BUTTON);
    }
    hasNumberedHeaderInScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            switch(this.treeAdapter.getNamespaceURI(this.items[i])){
                case (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML:
                    if ((0, $5deb0c47e1a27c89$export$1ecc20fa0754c045).has(tn)) return true;
                    if ($03dd88514dcbaecb$var$SCOPING_ELEMENTS_HTML.has(tn)) return false;
                    break;
                case (0, $5deb0c47e1a27c89$export$fb4028874a74450).SVG:
                    if ($03dd88514dcbaecb$var$SCOPING_ELEMENTS_SVG.has(tn)) return false;
                    break;
                case (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML:
                    if ($03dd88514dcbaecb$var$SCOPING_ELEMENTS_MATHML.has(tn)) return false;
                    break;
            }
        }
        return true;
    }
    hasInTableScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case tagName:
                    return true;
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
                    return false;
            }
        }
        return true;
    }
    hasTableBodyContextInTableScope() {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
                    return true;
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
                    return false;
            }
        }
        return true;
    }
    hasInSelectScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case tagName:
                    return true;
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION:
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP:
                    break;
                default:
                    return false;
            }
        }
        return true;
    }
    //Implied end tags
    generateImpliedEndTags() {
        while(this.currentTagId !== undefined && $03dd88514dcbaecb$var$IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsThoroughly() {
        while(this.currentTagId !== undefined && $03dd88514dcbaecb$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsWithExclusion(exclusionId) {
        while(this.currentTagId !== undefined && this.currentTagId !== exclusionId && $03dd88514dcbaecb$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
}


//Const
const $3a77e1f54f03a4f4$var$NOAH_ARK_CAPACITY = 3;
var $3a77e1f54f03a4f4$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Marker"] = 0] = "Marker";
    EntryType[EntryType["Element"] = 1] = "Element";
})($3a77e1f54f03a4f4$export$e41c32906b33062a || ($3a77e1f54f03a4f4$export$e41c32906b33062a = {}));
const $3a77e1f54f03a4f4$var$MARKER = {
    type: $3a77e1f54f03a4f4$export$e41c32906b33062a.Marker
};
class $3a77e1f54f03a4f4$export$20023318d9d5bbce {
    constructor(treeAdapter){
        this.treeAdapter = treeAdapter;
        this.entries = [];
        this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for(let i = 0; i < this.entries.length; i++){
            const entry = this.entries[i];
            if (entry.type === $3a77e1f54f03a4f4$export$e41c32906b33062a.Marker) break;
            const { element: element } = entry;
            if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
                const elementAttrs = this.treeAdapter.getAttrList(element);
                if (elementAttrs.length === neAttrsLength) candidates.push({
                    idx: i,
                    attrs: elementAttrs
                });
            }
        }
        return candidates;
    }
    _ensureNoahArkCondition(newElement) {
        if (this.entries.length < $3a77e1f54f03a4f4$var$NOAH_ARK_CAPACITY) return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < $3a77e1f54f03a4f4$var$NOAH_ARK_CAPACITY) return;
        //NOTE: build attrs map for the new element, so we can perform fast lookups
        const neAttrsMap = new Map(neAttrs.map((neAttr)=>[
                neAttr.name,
                neAttr.value
            ]));
        let validCandidates = 0;
        //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met
        for(let i = 0; i < candidates.length; i++){
            const candidate = candidates[i];
            // We know that `candidate.attrs.length === neAttrs.length`
            if (candidate.attrs.every((cAttr)=>neAttrsMap.get(cAttr.name) === cAttr.value)) {
                validCandidates += 1;
                if (validCandidates >= $3a77e1f54f03a4f4$var$NOAH_ARK_CAPACITY) this.entries.splice(candidate.idx, 1);
            }
        }
    }
    //Mutations
    insertMarker() {
        this.entries.unshift($3a77e1f54f03a4f4$var$MARKER);
    }
    pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
            type: $3a77e1f54f03a4f4$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    insertElementAfterBookmark(element, token) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
            type: $3a77e1f54f03a4f4$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex !== -1) this.entries.splice(entryIndex, 1);
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */ clearToLastMarker() {
        const markerIdx = this.entries.indexOf($3a77e1f54f03a4f4$var$MARKER);
        if (markerIdx === -1) this.entries.length = 0;
        else this.entries.splice(0, markerIdx + 1);
    }
    //Search
    getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry)=>entry.type === $3a77e1f54f03a4f4$export$e41c32906b33062a.Marker || this.treeAdapter.getTagName(entry.element) === tagName);
        return entry && entry.type === $3a77e1f54f03a4f4$export$e41c32906b33062a.Element ? entry : null;
    }
    getElementEntry(element) {
        return this.entries.find((entry)=>entry.type === $3a77e1f54f03a4f4$export$e41c32906b33062a.Element && entry.element === element);
    }
}



const $96d1b2ecef66ec3e$export$7ddbba828dfa4796 = {
    //Node construction
    createDocument () {
        return {
            nodeName: '#document',
            mode: (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).NO_QUIRKS,
            childNodes: []
        };
    },
    createDocumentFragment () {
        return {
            nodeName: '#document-fragment',
            childNodes: []
        };
    },
    createElement (tagName, namespaceURI, attrs) {
        return {
            nodeName: tagName,
            tagName: tagName,
            attrs: attrs,
            namespaceURI: namespaceURI,
            childNodes: [],
            parentNode: null
        };
    },
    createCommentNode (data) {
        return {
            nodeName: '#comment',
            data: data,
            parentNode: null
        };
    },
    createTextNode (value) {
        return {
            nodeName: '#text',
            value: value,
            parentNode: null
        };
    },
    //Tree mutation
    appendChild (parentNode, newNode) {
        parentNode.childNodes.push(newNode);
        newNode.parentNode = parentNode;
    },
    insertBefore (parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
        parentNode.childNodes.splice(insertionIdx, 0, newNode);
        newNode.parentNode = parentNode;
    },
    setTemplateContent (templateElement, contentElement) {
        templateElement.content = contentElement;
    },
    getTemplateContent (templateElement) {
        return templateElement.content;
    },
    setDocumentType (document, name, publicId, systemId) {
        const doctypeNode = document.childNodes.find((node)=>node.nodeName === '#documentType');
        if (doctypeNode) {
            doctypeNode.name = name;
            doctypeNode.publicId = publicId;
            doctypeNode.systemId = systemId;
        } else {
            const node = {
                nodeName: '#documentType',
                name: name,
                publicId: publicId,
                systemId: systemId,
                parentNode: null
            };
            $96d1b2ecef66ec3e$export$7ddbba828dfa4796.appendChild(document, node);
        }
    },
    setDocumentMode (document, mode) {
        document.mode = mode;
    },
    getDocumentMode (document) {
        return document.mode;
    },
    detachNode (node) {
        if (node.parentNode) {
            const idx = node.parentNode.childNodes.indexOf(node);
            node.parentNode.childNodes.splice(idx, 1);
            node.parentNode = null;
        }
    },
    insertText (parentNode, text) {
        if (parentNode.childNodes.length > 0) {
            const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
            if ($96d1b2ecef66ec3e$export$7ddbba828dfa4796.isTextNode(prevNode)) {
                prevNode.value += text;
                return;
            }
        }
        $96d1b2ecef66ec3e$export$7ddbba828dfa4796.appendChild(parentNode, $96d1b2ecef66ec3e$export$7ddbba828dfa4796.createTextNode(text));
    },
    insertTextBefore (parentNode, text, referenceNode) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
        if (prevNode && $96d1b2ecef66ec3e$export$7ddbba828dfa4796.isTextNode(prevNode)) prevNode.value += text;
        else $96d1b2ecef66ec3e$export$7ddbba828dfa4796.insertBefore(parentNode, $96d1b2ecef66ec3e$export$7ddbba828dfa4796.createTextNode(text), referenceNode);
    },
    adoptAttributes (recipient, attrs) {
        const recipientAttrsMap = new Set(recipient.attrs.map((attr)=>attr.name));
        for(let j = 0; j < attrs.length; j++)if (!recipientAttrsMap.has(attrs[j].name)) recipient.attrs.push(attrs[j]);
    },
    //Tree traversing
    getFirstChild (node) {
        return node.childNodes[0];
    },
    getChildNodes (node) {
        return node.childNodes;
    },
    getParentNode (node) {
        return node.parentNode;
    },
    getAttrList (element) {
        return element.attrs;
    },
    //Node data
    getTagName (element) {
        return element.tagName;
    },
    getNamespaceURI (element) {
        return element.namespaceURI;
    },
    getTextNodeContent (textNode) {
        return textNode.value;
    },
    getCommentNodeContent (commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName (doctypeNode) {
        return doctypeNode.name;
    },
    getDocumentTypeNodePublicId (doctypeNode) {
        return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId (doctypeNode) {
        return doctypeNode.systemId;
    },
    //Node types
    isTextNode (node) {
        return node.nodeName === '#text';
    },
    isCommentNode (node) {
        return node.nodeName === '#comment';
    },
    isDocumentTypeNode (node) {
        return node.nodeName === '#documentType';
    },
    isElementNode (node) {
        return Object.prototype.hasOwnProperty.call(node, 'tagName');
    },
    // Source code location
    setNodeSourceCodeLocation (node, location) {
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation (node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation (node, endLocation) {
        node.sourceCodeLocation = {
            ...node.sourceCodeLocation,
            ...endLocation
        };
    }
};



//Const
const $a06b9e6616f0f275$var$VALID_DOCTYPE_NAME = 'html';
const $a06b9e6616f0f275$var$VALID_SYSTEM_ID = 'about:legacy-compat';
const $a06b9e6616f0f275$var$QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
const $a06b9e6616f0f275$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//'
];
const $a06b9e6616f0f275$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$a06b9e6616f0f275$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
const $a06b9e6616f0f275$var$QUIRKS_MODE_PUBLIC_IDS = new Set([
    '-//w3o//dtd w3 html strict 3.0//en//',
    '-/w3c/dtd html 4.0 transitional/en',
    'html'
]);
const $a06b9e6616f0f275$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
    '-//w3c//dtd xhtml 1.0 frameset//',
    '-//w3c//dtd xhtml 1.0 transitional//'
];
const $a06b9e6616f0f275$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$a06b9e6616f0f275$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
//Utils
function $a06b9e6616f0f275$var$hasPrefix(publicId, prefixes) {
    return prefixes.some((prefix)=>publicId.startsWith(prefix));
}
function $a06b9e6616f0f275$export$ee48152ecc0e3f40(token) {
    return token.name === $a06b9e6616f0f275$var$VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === $a06b9e6616f0f275$var$VALID_SYSTEM_ID);
}
function $a06b9e6616f0f275$export$64782beacef87b30(token) {
    if (token.name !== $a06b9e6616f0f275$var$VALID_DOCTYPE_NAME) return (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS;
    const { systemId: systemId } = token;
    if (systemId && systemId.toLowerCase() === $a06b9e6616f0f275$var$QUIRKS_MODE_SYSTEM_ID) return (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS;
    let { publicId: publicId } = token;
    if (publicId !== null) {
        publicId = publicId.toLowerCase();
        if ($a06b9e6616f0f275$var$QUIRKS_MODE_PUBLIC_IDS.has(publicId)) return (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS;
        let prefixes = systemId === null ? $a06b9e6616f0f275$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : $a06b9e6616f0f275$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES;
        if ($a06b9e6616f0f275$var$hasPrefix(publicId, prefixes)) return (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS;
        prefixes = systemId === null ? $a06b9e6616f0f275$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : $a06b9e6616f0f275$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
        if ($a06b9e6616f0f275$var$hasPrefix(publicId, prefixes)) return (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).LIMITED_QUIRKS;
    }
    return (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).NO_QUIRKS;
}



//MIME types
const $a7b4b99c1048c081$var$MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};
//Attributes
const $a7b4b99c1048c081$var$DEFINITION_URL_ATTR = 'definitionurl';
const $a7b4b99c1048c081$var$ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const $a7b4b99c1048c081$var$SVG_ATTRS_ADJUSTMENT_MAP = new Map([
    'attributeName',
    'attributeType',
    'baseFrequency',
    'baseProfile',
    'calcMode',
    'clipPathUnits',
    'diffuseConstant',
    'edgeMode',
    'filterUnits',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'kernelMatrix',
    'kernelUnitLength',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'limitingConeAngle',
    'markerHeight',
    'markerUnits',
    'markerWidth',
    'maskContentUnits',
    'maskUnits',
    'numOctaves',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'refX',
    'refY',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'specularConstant',
    'specularExponent',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stitchTiles',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textLength',
    'viewBox',
    'viewTarget',
    'xChannelSelector',
    'yChannelSelector',
    'zoomAndPan'
].map((attr)=>[
        attr.toLowerCase(),
        attr
    ]));
const $a7b4b99c1048c081$var$XML_ATTRS_ADJUSTMENT_MAP = new Map([
    [
        'xlink:actuate',
        {
            prefix: 'xlink',
            name: 'actuate',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:arcrole',
        {
            prefix: 'xlink',
            name: 'arcrole',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:href',
        {
            prefix: 'xlink',
            name: 'href',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:role',
        {
            prefix: 'xlink',
            name: 'role',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:show',
        {
            prefix: 'xlink',
            name: 'show',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:title',
        {
            prefix: 'xlink',
            name: 'title',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:type',
        {
            prefix: 'xlink',
            name: 'type',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xml:lang',
        {
            prefix: 'xml',
            name: 'lang',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XML
        }
    ],
    [
        'xml:space',
        {
            prefix: 'xml',
            name: 'space',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XML
        }
    ],
    [
        'xmlns',
        {
            prefix: '',
            name: 'xmlns',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XMLNS
        }
    ],
    [
        'xmlns:xlink',
        {
            prefix: 'xmlns',
            name: 'xlink',
            namespace: (0, $5deb0c47e1a27c89$export$fb4028874a74450).XMLNS
        }
    ]
]);
const $a7b4b99c1048c081$export$86512877756eb1b1 = new Map([
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'textPath'
].map((tn)=>[
        tn.toLowerCase(),
        tn
    ]));
//Tags that causes exit from foreign content
const $a7b4b99c1048c081$var$EXITS_FOREIGN_CONTENT = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).B,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BIG,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BLOCKQUOTE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CENTER,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CODE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIV,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DL,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).EM,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).EMBED,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H1,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H2,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H3,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H4,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H5,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H6,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HR,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).I,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).IMG,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LISTING,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MENU,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).META,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOBR,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OL,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).PRE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RUBY,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).S,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SMALL,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SPAN,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STRONG,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STRIKE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SUB,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SUP,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).U,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UL,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).VAR
]);
function $a7b4b99c1048c081$export$3435eb4ab4d2ed2d(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FONT && startTagToken.attrs.some(({ name: name })=>name === (0, $5deb0c47e1a27c89$export$380b7bc9e6cb1918).COLOR || name === (0, $5deb0c47e1a27c89$export$380b7bc9e6cb1918).SIZE || name === (0, $5deb0c47e1a27c89$export$380b7bc9e6cb1918).FACE);
    return isFontWithAttrs || $a7b4b99c1048c081$var$EXITS_FOREIGN_CONTENT.has(tn);
}
function $a7b4b99c1048c081$export$c583cc5a9d633feb(token) {
    for(let i = 0; i < token.attrs.length; i++)if (token.attrs[i].name === $a7b4b99c1048c081$var$DEFINITION_URL_ATTR) {
        token.attrs[i].name = $a7b4b99c1048c081$var$ADJUSTED_DEFINITION_URL_ATTR;
        break;
    }
}
function $a7b4b99c1048c081$export$74ce06f755fb8f68(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrName = $a7b4b99c1048c081$var$SVG_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrName != null) token.attrs[i].name = adjustedAttrName;
    }
}
function $a7b4b99c1048c081$export$a5192af02995cbdc(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrEntry = $a7b4b99c1048c081$var$XML_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
}
function $a7b4b99c1048c081$export$95df78fe2e7f33e3(token) {
    const adjustedTagName = $a7b4b99c1048c081$export$86512877756eb1b1.get(token.tagName);
    if (adjustedTagName != null) {
        token.tagName = adjustedTagName;
        token.tagID = (0, $5deb0c47e1a27c89$export$39db8a1315f68282)(token.tagName);
    }
}
//Integration points
function $a7b4b99c1048c081$var$isMathMLTextIntegrationPoint(tn, ns) {
    return ns === (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML && (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MI || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MO || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MN || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MS || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MTEXT);
}
function $a7b4b99c1048c081$var$isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML && tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ANNOTATION_XML) {
        for(let i = 0; i < attrs.length; i++)if (attrs[i].name === (0, $5deb0c47e1a27c89$export$380b7bc9e6cb1918).ENCODING) {
            const value = attrs[i].value.toLowerCase();
            return value === $a7b4b99c1048c081$var$MIME_TYPES.TEXT_HTML || value === $a7b4b99c1048c081$var$MIME_TYPES.APPLICATION_XML;
        }
    }
    return ns === (0, $5deb0c47e1a27c89$export$fb4028874a74450).SVG && (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FOREIGN_OBJECT || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DESC || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE);
}
function $a7b4b99c1048c081$export$6baf3ebfdd620e1(tn, ns, attrs, foreignNS) {
    return (!foreignNS || foreignNS === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) && $a7b4b99c1048c081$var$isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML) && $a7b4b99c1048c081$var$isMathMLTextIntegrationPoint(tn, ns);
}






//Misc constants
const $546dc23fbaaf59e4$var$HIDDEN_INPUT_TYPE = 'hidden';
//Adoption agency loops iteration count
const $546dc23fbaaf59e4$var$AA_OUTER_LOOP_ITER = 8;
const $546dc23fbaaf59e4$var$AA_INNER_LOOP_ITER = 3;
//Insertion modes
var $546dc23fbaaf59e4$var$InsertionMode;
(function(InsertionMode) {
    InsertionMode[InsertionMode["INITIAL"] = 0] = "INITIAL";
    InsertionMode[InsertionMode["BEFORE_HTML"] = 1] = "BEFORE_HTML";
    InsertionMode[InsertionMode["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
    InsertionMode[InsertionMode["IN_HEAD"] = 3] = "IN_HEAD";
    InsertionMode[InsertionMode["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
    InsertionMode[InsertionMode["AFTER_HEAD"] = 5] = "AFTER_HEAD";
    InsertionMode[InsertionMode["IN_BODY"] = 6] = "IN_BODY";
    InsertionMode[InsertionMode["TEXT"] = 7] = "TEXT";
    InsertionMode[InsertionMode["IN_TABLE"] = 8] = "IN_TABLE";
    InsertionMode[InsertionMode["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
    InsertionMode[InsertionMode["IN_CAPTION"] = 10] = "IN_CAPTION";
    InsertionMode[InsertionMode["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
    InsertionMode[InsertionMode["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
    InsertionMode[InsertionMode["IN_ROW"] = 13] = "IN_ROW";
    InsertionMode[InsertionMode["IN_CELL"] = 14] = "IN_CELL";
    InsertionMode[InsertionMode["IN_SELECT"] = 15] = "IN_SELECT";
    InsertionMode[InsertionMode["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
    InsertionMode[InsertionMode["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
    InsertionMode[InsertionMode["AFTER_BODY"] = 18] = "AFTER_BODY";
    InsertionMode[InsertionMode["IN_FRAMESET"] = 19] = "IN_FRAMESET";
    InsertionMode[InsertionMode["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
    InsertionMode[InsertionMode["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
    InsertionMode[InsertionMode["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})($546dc23fbaaf59e4$var$InsertionMode || ($546dc23fbaaf59e4$var$InsertionMode = {}));
const $546dc23fbaaf59e4$var$BASE_LOC = {
    startLine: -1,
    startCol: -1,
    startOffset: -1,
    endLine: -1,
    endCol: -1,
    endOffset: -1
};
const $546dc23fbaaf59e4$var$TABLE_STRUCTURE_TAGS = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR
]);
const $546dc23fbaaf59e4$var$defaultParserOptions = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    treeAdapter: (0, $96d1b2ecef66ec3e$export$7ddbba828dfa4796),
    onParseError: null
};
class $546dc23fbaaf59e4$export$7acfa6ed01010e37 {
    constructor(options, document, /** @internal */ fragmentContext = null, /** @internal */ scriptHandler = null){
        this.fragmentContext = fragmentContext;
        this.scriptHandler = scriptHandler;
        this.currentToken = null;
        this.stopped = false;
        /** @internal */ this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.INITIAL;
        /** @internal */ this.originalInsertionMode = $546dc23fbaaf59e4$var$InsertionMode.INITIAL;
        /** @internal */ this.headElement = null;
        /** @internal */ this.formElement = null;
        /** Indicates that the current node is not an element in the HTML namespace */ this.currentNotInHTML = false;
        /**
         * The template insertion mode stack is maintained from the left.
         * Ie. the topmost element will always have index 0.
         *
         * @internal
         */ this.tmplInsertionModeStack = [];
        /** @internal */ this.pendingCharacterTokens = [];
        /** @internal */ this.hasNonWhitespacePendingCharacterToken = false;
        /** @internal */ this.framesetOk = true;
        /** @internal */ this.skipNextNewLine = false;
        /** @internal */ this.fosterParentingEnabled = false;
        this.options = {
            ...$546dc23fbaaf59e4$var$defaultParserOptions,
            ...options
        };
        this.treeAdapter = this.options.treeAdapter;
        this.onParseError = this.options.onParseError;
        // Always enable location info if we report parse errors.
        if (this.onParseError) this.options.sourceCodeLocationInfo = true;
        this.document = document !== null && document !== void 0 ? document : this.treeAdapter.createDocument();
        this.tokenizer = new (0, $2c4fc6157fdd925a$export$55e8b082af4aa63e)(this.options, this);
        this.activeFormattingElements = new (0, $3a77e1f54f03a4f4$export$20023318d9d5bbce)(this.treeAdapter);
        this.fragmentContextID = fragmentContext ? (0, $5deb0c47e1a27c89$export$39db8a1315f68282)(this.treeAdapter.getTagName(fragmentContext)) : (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UNKNOWN;
        this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
        this.openElements = new (0, $03dd88514dcbaecb$export$56decf886ed987d6)(this.document, this.treeAdapter, this);
    }
    // API
    static parse(html, options) {
        const parser = new this(options);
        parser.tokenizer.write(html, true);
        return parser.document;
    }
    static getFragmentParser(fragmentContext, options) {
        const opts = {
            ...$546dc23fbaaf59e4$var$defaultParserOptions,
            ...options
        };
        //NOTE: use a <template> element as the fragment context if no context element was provided,
        //so we will parse in a "forgiving" manner
        fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).TEMPLATE, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML, []);
        //NOTE: create a fake element which will be used as the `document` for fragment parsing.
        //This is important for jsdom, where a new `document` cannot be created. This led to
        //fragment parsing messing with the main `document`.
        const documentMock = opts.treeAdapter.createElement('documentmock', (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML, []);
        const parser = new this(opts, documentMock, fragmentContext);
        if (parser.fragmentContextID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE) parser.tmplInsertionModeStack.unshift($546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE);
        parser._initTokenizerForFragmentParsing();
        parser._insertFakeRootElement();
        parser._resetInsertionMode();
        parser._findFormInFragmentContext();
        return parser;
    }
    getFragment() {
        const rootElement = this.treeAdapter.getFirstChild(this.document);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
    }
    //Errors
    /** @internal */ _err(token, code, beforeToken) {
        var _a;
        if (!this.onParseError) return;
        const loc = (_a = token.location) !== null && _a !== void 0 ? _a : $546dc23fbaaf59e4$var$BASE_LOC;
        const err = {
            code: code,
            startLine: loc.startLine,
            startCol: loc.startCol,
            startOffset: loc.startOffset,
            endLine: beforeToken ? loc.startLine : loc.endLine,
            endCol: beforeToken ? loc.startCol : loc.endCol,
            endOffset: beforeToken ? loc.startOffset : loc.endOffset
        };
        this.onParseError(err);
    }
    //Stack events
    /** @internal */ onItemPush(node, tid, isTop) {
        var _a, _b;
        (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 || _b.call(_a, node);
        if (isTop && this.openElements.stackTop > 0) this._setContextModes(node, tid);
    }
    /** @internal */ onItemPop(node, isTop) {
        var _a, _b;
        if (this.options.sourceCodeLocationInfo) this._setEndLocation(node, this.currentToken);
        (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 || _b.call(_a, node, this.openElements.current);
        if (isTop) {
            let current;
            let currentTagId;
            if (this.openElements.stackTop === 0 && this.fragmentContext) {
                current = this.fragmentContext;
                currentTagId = this.fragmentContextID;
            } else ({ current: current, currentTagId: currentTagId } = this.openElements);
            this._setContextModes(current, currentTagId);
        }
    }
    _setContextModes(current, tid) {
        const isHTML = current === this.document || current && this.treeAdapter.getNamespaceURI(current) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML;
        this.currentNotInHTML = !isHTML;
        this.tokenizer.inForeignNode = !isHTML && current !== undefined && tid !== undefined && !this._isIntegrationPoint(tid, current);
    }
    /** @protected */ _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.TEXT;
    }
    switchToPlaintextParsing() {
        this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.TEXT;
        this.originalInsertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
        this.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).PLAINTEXT;
    }
    //Fragment parsing
    /** @protected */ _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    /** @protected */ _findFormInFragmentContext() {
        let node = this.fragmentContext;
        while(node){
            if (this.treeAdapter.getTagName(node) === (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).FORM) {
                this.formElement = node;
                break;
            }
            node = this.treeAdapter.getParentNode(node);
        }
    }
    _initTokenizerForFragmentParsing() {
        if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) return;
        switch(this.fragmentContextID){
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEXTAREA:
                this.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RCDATA;
                break;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).XMP:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).IFRAME:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOEMBED:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOSCRIPT:
                this.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RAWTEXT;
                break;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
                this.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).SCRIPT_DATA;
                break;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).PLAINTEXT:
                this.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).PLAINTEXT;
                break;
            default:
        }
    }
    //Tree mutation
    /** @protected */ _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
        if (token.location) {
            const documentChildren = this.treeAdapter.getChildNodes(this.document);
            const docTypeNode = documentChildren.find((node)=>this.treeAdapter.isDocumentTypeNode(node));
            if (docTypeNode) this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token.location);
        }
    }
    /** @protected */ _attachElementToTree(element, location) {
        if (this.options.sourceCodeLocationInfo) {
            const loc = location && {
                ...location,
                startTag: location
            };
            this.treeAdapter.setNodeSourceCodeLocation(element, loc);
        }
        if (this._shouldFosterParentOnInsertion()) this._fosterParentElement(element);
        else {
            const parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.appendChild(parent !== null && parent !== void 0 ? parent : this.document, element);
        }
    }
    /**
     * For self-closing tags. Add an element to the tree, but skip adding it
     * to the stack.
     */ /** @protected */ _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
    }
    /** @protected */ _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
        this.openElements.push(element, token.tagID);
    }
    /** @protected */ _insertFakeElement(tagName, tagID) {
        const element = this.treeAdapter.createElement(tagName, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML, []);
        this._attachElementToTree(element, null);
        this.openElements.push(element, tagID);
    }
    /** @protected */ _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl, token.location);
        this.openElements.push(tmpl, token.tagID);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
    /** @protected */ _insertFakeRootElement() {
        const element = this.treeAdapter.createElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).HTML, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML, []);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(element, null);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML);
    }
    /** @protected */ _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
    }
    /** @protected */ _insertCharacters(token) {
        let parent;
        let beforeElement;
        if (this._shouldFosterParentOnInsertion()) {
            ({ parent: parent, beforeElement: beforeElement } = this._findFosterParentingLocation());
            if (beforeElement) this.treeAdapter.insertTextBefore(parent, token.chars, beforeElement);
            else this.treeAdapter.insertText(parent, token.chars);
        } else {
            parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.insertText(parent, token.chars);
        }
        if (!token.location) return;
        const siblings = this.treeAdapter.getChildNodes(parent);
        const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
        const textNode = siblings[textNodeIdx - 1];
        //NOTE: if we have a location assigned by another token, then just update the end position
        const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
        if (tnLoc) {
            const { endLine: endLine, endCol: endCol, endOffset: endOffset } = token.location;
            this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
                endLine: endLine,
                endCol: endCol,
                endOffset: endOffset
            });
        } else if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
    }
    /** @protected */ _adoptNodes(donor, recipient) {
        for(let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)){
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }
    /** @protected */ _setEndLocation(element, closingToken) {
        if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
            const ctLoc = closingToken.location;
            const tn = this.treeAdapter.getTagName(element);
            const endLoc = // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            closingToken.type === (0, $05436e75d13cd0ed$export$f435f793048e7a0f).END_TAG && tn === closingToken.tagName ? {
                endTag: {
                    ...ctLoc
                },
                endLine: ctLoc.endLine,
                endCol: ctLoc.endCol,
                endOffset: ctLoc.endOffset
            } : {
                endLine: ctLoc.startLine,
                endCol: ctLoc.startCol,
                endOffset: ctLoc.startOffset
            };
            this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
        }
    }
    //Token processing
    shouldProcessStartTagTokenInForeignContent(token) {
        // Check that neither current === document, or ns === NS.HTML
        if (!this.currentNotInHTML) return false;
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
            current = this.fragmentContext;
            currentTagId = this.fragmentContextID;
        } else ({ current: current, currentTagId: currentTagId } = this.openElements);
        if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SVG && this.treeAdapter.getTagName(current) === (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML) return false;
        return(// Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MGLYPH || token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MALIGNMARK) && currentTagId !== undefined && !this._isIntegrationPoint(currentTagId, current, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML));
    }
    /** @protected */ _processToken(token) {
        switch(token.type){
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).CHARACTER:
                this.onCharacter(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).NULL_CHARACTER:
                this.onNullCharacter(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).COMMENT:
                this.onComment(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).DOCTYPE:
                this.onDoctype(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).START_TAG:
                this._processStartTag(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).END_TAG:
                this.onEndTag(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).EOF:
                this.onEof(token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                this.onWhitespaceCharacter(token);
                break;
        }
    }
    //Integration points
    /** @protected */ _isIntegrationPoint(tid, element, foreignNS) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return $a7b4b99c1048c081$export$6baf3ebfdd620e1(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    /** @protected */ _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.entries.length;
        if (listLength) {
            const endIndex = this.activeFormattingElements.entries.findIndex((entry)=>entry.type === (0, $3a77e1f54f03a4f4$export$e41c32906b33062a).Marker || this.openElements.contains(entry.element));
            const unopenIdx = endIndex === -1 ? listLength - 1 : endIndex - 1;
            for(let i = unopenIdx; i >= 0; i--){
                const entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }
    //Close elements
    /** @protected */ _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
    }
    /** @protected */ _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P);
        this.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P);
    }
    //Insertion modes
    /** @protected */ _resetInsertionMode() {
        for(let i = this.openElements.stackTop; i >= 0; i--)//Insertion mode reset map
        switch(i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]){
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAMESET:
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT:
                this._resetInsertionModeForSelect(i);
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
                this.insertionMode = this.tmplInsertionModeStack[0];
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
                this.insertionMode = this.headElement ? $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD : $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD;
                return;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
                if (i > 0) {
                    this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_CELL;
                    return;
                }
                break;
            case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
                if (i > 0) {
                    this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD;
                    return;
                }
                break;
        }
        this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
    }
    /** @protected */ _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) for(let i = selectIdx - 1; i > 0; i--){
            const tn = this.openElements.tagIDs[i];
            if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE) break;
            else if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE) {
                this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE;
                return;
            }
        }
        this.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT;
    }
    //Foster parenting
    /** @protected */ _isElementCausesFosterParenting(tn) {
        return $546dc23fbaaf59e4$var$TABLE_STRUCTURE_TAGS.has(tn);
    }
    /** @protected */ _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this.openElements.currentTagId !== undefined && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
    /** @protected */ _findFosterParentingLocation() {
        for(let i = this.openElements.stackTop; i >= 0; i--){
            const openElement = this.openElements.items[i];
            switch(this.openElements.tagIDs[i]){
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
                    if (this.treeAdapter.getNamespaceURI(openElement) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) return {
                        parent: this.treeAdapter.getTemplateContent(openElement),
                        beforeElement: null
                    };
                    break;
                case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
                    {
                        const parent = this.treeAdapter.getParentNode(openElement);
                        if (parent) return {
                            parent: parent,
                            beforeElement: openElement
                        };
                        return {
                            parent: this.openElements.items[i - 1],
                            beforeElement: null
                        };
                    }
                default:
            }
        }
        return {
            parent: this.openElements.items[0],
            beforeElement: null
        };
    }
    /** @protected */ _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        else this.treeAdapter.appendChild(location.parent, element);
    }
    //Special elements
    /** @protected */ _isSpecialElement(element, id) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        return (0, $5deb0c47e1a27c89$export$7e5172336f7d2bbb)[ns].has(id);
    }
    /** @internal */ onCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $546dc23fbaaf59e4$var$characterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
                $546dc23fbaaf59e4$var$tokenInInitialMode(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML:
                $546dc23fbaaf59e4$var$tokenBeforeHtml(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
                $546dc23fbaaf59e4$var$tokenBeforeHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
                $546dc23fbaaf59e4$var$tokenInHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $546dc23fbaaf59e4$var$tokenInHeadNoScript(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
                $546dc23fbaaf59e4$var$tokenAfterHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CELL:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE:
                $546dc23fbaaf59e4$var$characterInBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.TEXT:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE:
                this._insertCharacters(token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
                $546dc23fbaaf59e4$var$characterInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$characterInTableText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
                $546dc23fbaaf59e4$var$tokenInColumnGroup(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
                $546dc23fbaaf59e4$var$tokenAfterBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
                $546dc23fbaaf59e4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onNullCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $546dc23fbaaf59e4$var$nullCharacterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
                $546dc23fbaaf59e4$var$tokenInInitialMode(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML:
                $546dc23fbaaf59e4$var$tokenBeforeHtml(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
                $546dc23fbaaf59e4$var$tokenBeforeHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
                $546dc23fbaaf59e4$var$tokenInHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $546dc23fbaaf59e4$var$tokenInHeadNoScript(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
                $546dc23fbaaf59e4$var$tokenAfterHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.TEXT:
                this._insertCharacters(token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
                $546dc23fbaaf59e4$var$characterInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
                $546dc23fbaaf59e4$var$tokenInColumnGroup(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
                $546dc23fbaaf59e4$var$tokenAfterBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
                $546dc23fbaaf59e4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onComment(token) {
        this.skipNextNewLine = false;
        if (this.currentNotInHTML) {
            $546dc23fbaaf59e4$var$appendComment(this, token);
            return;
        }
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML:
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CELL:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$appendComment(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$tokenInTableText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
                $546dc23fbaaf59e4$var$appendCommentToRootHtmlElement(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$appendCommentToDocument(this, token);
                break;
            default:
        }
    }
    /** @internal */ onDoctype(token) {
        this.skipNextNewLine = false;
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
                $546dc23fbaaf59e4$var$doctypeInInitialMode(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
                this._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).misplacedDoctype);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$tokenInTableText(this, token);
                break;
            default:
        }
    }
    /** @internal */ onStartTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        this._processStartTag(token);
        if (token.selfClosing && !token.ackSelfClosing) this._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     * @protected
     */ _processStartTag(token) {
        if (this.shouldProcessStartTagTokenInForeignContent(token)) $546dc23fbaaf59e4$var$startTagInForeignContent(this, token);
        else this._startTagOutsideForeignContent(token);
    }
    /** @protected */ _startTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
                $546dc23fbaaf59e4$var$tokenInInitialMode(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML:
                $546dc23fbaaf59e4$var$startTagBeforeHtml(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
                $546dc23fbaaf59e4$var$startTagBeforeHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
                $546dc23fbaaf59e4$var$startTagInHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $546dc23fbaaf59e4$var$startTagInHeadNoScript(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
                $546dc23fbaaf59e4$var$startTagAfterHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_BODY:
                $546dc23fbaaf59e4$var$startTagInBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
                $546dc23fbaaf59e4$var$startTagInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$tokenInTableText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION:
                $546dc23fbaaf59e4$var$startTagInCaption(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
                $546dc23fbaaf59e4$var$startTagInColumnGroup(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
                $546dc23fbaaf59e4$var$startTagInTableBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
                $546dc23fbaaf59e4$var$startTagInRow(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CELL:
                $546dc23fbaaf59e4$var$startTagInCell(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT:
                $546dc23fbaaf59e4$var$startTagInSelect(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $546dc23fbaaf59e4$var$startTagInSelectInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE:
                $546dc23fbaaf59e4$var$startTagInTemplate(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
                $546dc23fbaaf59e4$var$startTagAfterBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET:
                $546dc23fbaaf59e4$var$startTagInFrameset(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$startTagAfterFrameset(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
                $546dc23fbaaf59e4$var$startTagAfterAfterBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$startTagAfterAfterFrameset(this, token);
                break;
            default:
        }
    }
    /** @internal */ onEndTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        if (this.currentNotInHTML) $546dc23fbaaf59e4$var$endTagInForeignContent(this, token);
        else this._endTagOutsideForeignContent(token);
    }
    /** @protected */ _endTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
                $546dc23fbaaf59e4$var$tokenInInitialMode(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML:
                $546dc23fbaaf59e4$var$endTagBeforeHtml(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
                $546dc23fbaaf59e4$var$endTagBeforeHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
                $546dc23fbaaf59e4$var$endTagInHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $546dc23fbaaf59e4$var$endTagInHeadNoScript(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
                $546dc23fbaaf59e4$var$endTagAfterHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_BODY:
                $546dc23fbaaf59e4$var$endTagInBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.TEXT:
                $546dc23fbaaf59e4$var$endTagInText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
                $546dc23fbaaf59e4$var$endTagInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$tokenInTableText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION:
                $546dc23fbaaf59e4$var$endTagInCaption(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
                $546dc23fbaaf59e4$var$endTagInColumnGroup(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
                $546dc23fbaaf59e4$var$endTagInTableBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
                $546dc23fbaaf59e4$var$endTagInRow(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CELL:
                $546dc23fbaaf59e4$var$endTagInCell(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT:
                $546dc23fbaaf59e4$var$endTagInSelect(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $546dc23fbaaf59e4$var$endTagInSelectInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE:
                $546dc23fbaaf59e4$var$endTagInTemplate(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
                $546dc23fbaaf59e4$var$endTagAfterBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET:
                $546dc23fbaaf59e4$var$endTagInFrameset(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$endTagAfterFrameset(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
                $546dc23fbaaf59e4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onEof(token) {
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.INITIAL:
                $546dc23fbaaf59e4$var$tokenInInitialMode(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML:
                $546dc23fbaaf59e4$var$tokenBeforeHtml(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD:
                $546dc23fbaaf59e4$var$tokenBeforeHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
                $546dc23fbaaf59e4$var$tokenInHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $546dc23fbaaf59e4$var$tokenInHeadNoScript(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
                $546dc23fbaaf59e4$var$tokenAfterHead(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CELL:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $546dc23fbaaf59e4$var$eofInBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.TEXT:
                $546dc23fbaaf59e4$var$eofInText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$tokenInTableText(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE:
                $546dc23fbaaf59e4$var$eofInTemplate(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_FRAMESET:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$stopParsing(this, token);
                break;
            default:
        }
    }
    /** @internal */ onWhitespaceCharacter(token) {
        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;
            if (token.chars.charCodeAt(0) === $13b6aff9b77366c5$export$e3f6c2feb5c0ecc0.LINE_FEED) {
                if (token.chars.length === 1) return;
                token.chars = token.chars.substr(1);
            }
        }
        if (this.tokenizer.inForeignNode) {
            this._insertCharacters(token);
            return;
        }
        switch(this.insertionMode){
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD:
            case $546dc23fbaaf59e4$var$InsertionMode.TEXT:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_FRAMESET:
                this._insertCharacters(token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_CELL:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $546dc23fbaaf59e4$var$whitespaceCharacterInBody(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY:
            case $546dc23fbaaf59e4$var$InsertionMode.IN_ROW:
                $546dc23fbaaf59e4$var$characterInTable(this, token);
                break;
            case $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT:
                $546dc23fbaaf59e4$var$whitespaceCharacterInTableText(this, token);
                break;
            default:
        }
    }
}
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function $546dc23fbaaf59e4$var$aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagID)) formattingElementEntry = null;
    } else $546dc23fbaaf59e4$var$genericEndTagInBody(p, token);
    return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function $546dc23fbaaf59e4$var$aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    let idx = p.openElements.stackTop;
    for(; idx >= 0; idx--){
        const element = p.openElements.items[idx];
        if (element === formattingElementEntry.element) break;
        if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) furthestBlock = element;
    }
    if (!furthestBlock) {
        p.openElements.shortenToLength(Math.max(idx, 0));
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
}
//Step 13 of the algorithm
function $546dc23fbaaf59e4$var$aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for(let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement){
        //NOTE: store the next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);
        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= $546dc23fbaaf59e4$var$AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) p.activeFormattingElements.removeEntry(elementEntry);
            p.openElements.remove(element);
        } else {
            element = $546dc23fbaaf59e4$var$aaRecreateElementFromEntry(p, elementEntry);
            if (lastElement === furthestBlock) p.activeFormattingElements.bookmark = elementEntry;
            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }
    return lastElement;
}
//Step 13.7 of the algorithm
function $546dc23fbaaf59e4$var$aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
}
//Step 14 of the algorithm
function $546dc23fbaaf59e4$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    const tn = p.treeAdapter.getTagName(commonAncestor);
    const tid = (0, $5deb0c47e1a27c89$export$39db8a1315f68282)(tn);
    if (p._isElementCausesFosterParenting(tid)) p._fosterParentElement(lastElement);
    else {
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
        if (tid === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE && ns === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}
//Steps 15-19 of the algorithm
function $546dc23fbaaf59e4$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const { token: token } = formattingElementEntry;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement, token.tagID);
}
//Algorithm entry point
function $546dc23fbaaf59e4$var$callAdoptionAgency(p, token) {
    for(let i = 0; i < $546dc23fbaaf59e4$var$AA_OUTER_LOOP_ITER; i++){
        const formattingElementEntry = $546dc23fbaaf59e4$var$aaObtainFormattingElementEntry(p, token);
        if (!formattingElementEntry) break;
        const furthestBlock = $546dc23fbaaf59e4$var$aaObtainFurthestBlock(p, formattingElementEntry);
        if (!furthestBlock) break;
        p.activeFormattingElements.bookmark = formattingElementEntry;
        const lastElement = $546dc23fbaaf59e4$var$aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
        p.treeAdapter.detachNode(lastElement);
        if (commonAncestor) $546dc23fbaaf59e4$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        $546dc23fbaaf59e4$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}
//Generic token handlers
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContentOrNode);
}
function $546dc23fbaaf59e4$var$appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}
function $546dc23fbaaf59e4$var$appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}
function $546dc23fbaaf59e4$var$stopParsing(p, token) {
    p.stopped = true;
    // NOTE: Set end locations for elements that remain on the open element stack.
    if (token.location) {
        // NOTE: If we are not in a fragment, `html` and `body` will stay on the stack.
        // This is a problem, as we might overwrite their end position here.
        const target = p.fragmentContext ? 0 : 2;
        for(let i = p.openElements.stackTop; i >= target; i--)p._setEndLocation(p.openElements.items[i], token);
        // Handle `html` and `body`
        if (!p.fragmentContext && p.openElements.stackTop >= 0) {
            const htmlElement = p.openElements.items[0];
            const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
            if (htmlLocation && !htmlLocation.endTag) {
                p._setEndLocation(htmlElement, token);
                if (p.openElements.stackTop >= 1) {
                    const bodyElement = p.openElements.items[1];
                    const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
                    if (bodyLocation && !bodyLocation.endTag) p._setEndLocation(bodyElement, token);
                }
            }
        }
    }
}
// The "initial" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS : $a06b9e6616f0f275$export$64782beacef87b30(token);
    if (!$a06b9e6616f0f275$export$ee48152ecc0e3f40(token)) p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).nonConformingDoctype);
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML;
}
function $546dc23fbaaf59e4$var$tokenInInitialMode(p, token) {
    p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).missingDoctype, true);
    p.treeAdapter.setDocumentMode(p.document, (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HTML;
    p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagBeforeHtml(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML) {
        p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
        p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD;
    } else $546dc23fbaaf59e4$var$tokenBeforeHtml(p, token);
}
function $546dc23fbaaf59e4$var$endTagBeforeHtml(p, token) {
    const tn = token.tagID;
    if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR) $546dc23fbaaf59e4$var$tokenBeforeHtml(p, token);
}
function $546dc23fbaaf59e4$var$tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.BEFORE_HEAD;
    p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagBeforeHead(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            p.headElement = p.openElements.current;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD;
            break;
        default:
            $546dc23fbaaf59e4$var$tokenBeforeHead(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagBeforeHead(p, token) {
    const tn = token.tagID;
    if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR) $546dc23fbaaf59e4$var$tokenBeforeHead(p, token);
    else p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $546dc23fbaaf59e4$var$tokenBeforeHead(p, token) {
    p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).HEAD, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInHead(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASEFONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BGSOUND:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LINK:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).META:
            p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE:
            p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RCDATA);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RAWTEXT);
            else {
                p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD_NO_SCRIPT;
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
            p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RAWTEXT);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
            p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).SCRIPT_DATA);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            p._insertTemplate(token);
            p.activeFormattingElements.insertMarker();
            p.framesetOk = false;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE;
            p.tmplInsertionModeStack.unshift($546dc23fbaaf59e4$var$InsertionMode.IN_TEMPLATE);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $546dc23fbaaf59e4$var$tokenInHead(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInHead(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
            p.openElements.pop();
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$tokenInHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $546dc23fbaaf59e4$var$templateEndTagInHead(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTagsThoroughly();
        if (p.openElements.currentTagId !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE) p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).closingOfElementWithOpenChildElements);
        p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
    } else p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $546dc23fbaaf59e4$var$tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_HEAD;
    p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASEFONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BGSOUND:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LINK:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).META:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOSCRIPT:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).nestedNoscriptInHead);
            break;
        default:
            $546dc23fbaaf59e4$var$tokenInHeadNoScript(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOSCRIPT:
            p.openElements.pop();
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR:
            $546dc23fbaaf59e4$var$tokenInHeadNoScript(p, token);
            break;
        default:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $546dc23fbaaf59e4$var$tokenInHeadNoScript(p, token) {
    const errCode = token.type === (0, $05436e75d13cd0ed$export$f435f793048e7a0f).EOF ? (0, $0d242c12c37a5644$export$9e0efcb140234d2).openElementsLeftAfterEof : (0, $0d242c12c37a5644$export$9e0efcb140234d2).disallowedContentInNoscriptInHead;
    p._err(token, errCode);
    p.openElements.pop();
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            p.framesetOk = false;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASEFONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BGSOUND:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LINK:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).META:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).abandonedHeadElementChild);
            p.openElements.push(p.headElement, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD);
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            p.openElements.remove(p.headElement);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $546dc23fbaaf59e4$var$tokenAfterHead(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR:
            $546dc23fbaaf59e4$var$tokenAfterHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $546dc23fbaaf59e4$var$tokenAfterHead(p, token) {
    p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).BODY, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
    $546dc23fbaaf59e4$var$modeInBody(p, token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$modeInBody(p, token) {
    switch(token.type){
        case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).CHARACTER:
            $546dc23fbaaf59e4$var$characterInBody(p, token);
            break;
        case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
            $546dc23fbaaf59e4$var$whitespaceCharacterInBody(p, token);
            break;
        case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).COMMENT:
            $546dc23fbaaf59e4$var$appendComment(p, token);
            break;
        case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).START_TAG:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).END_TAG:
            $546dc23fbaaf59e4$var$endTagInBody(p, token);
            break;
        case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).EOF:
            $546dc23fbaaf59e4$var$eofInBody(p, token);
            break;
        default:
    }
}
function $546dc23fbaaf59e4$var$whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}
function $546dc23fbaaf59e4$var$characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $546dc23fbaaf59e4$var$htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}
function $546dc23fbaaf59e4$var$bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}
function $546dc23fbaaf59e4$var$framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
        p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_FRAMESET;
    }
}
function $546dc23fbaaf59e4$var$addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    if (p.openElements.currentTagId !== undefined && (0, $5deb0c47e1a27c89$export$1ecc20fa0754c045).has(p.openElements.currentTagId)) p.openElements.pop();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}
function $546dc23fbaaf59e4$var$formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
        p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
        if (!inTemplate) p.formElement = p.openElements.current;
    }
}
function $546dc23fbaaf59e4$var$listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagID;
    for(let i = p.openElements.stackTop; i >= 0; i--){
        const elementId = p.openElements.tagIDs[i];
        if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI && elementId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI || (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DT) && (elementId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DD || elementId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DT)) {
            p.openElements.generateImpliedEndTagsWithExclusion(elementId);
            p.openElements.popUntilTagNamePopped(elementId);
            break;
        }
        if (elementId !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ADDRESS && elementId !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIV && elementId !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P && p._isSpecialElement(p.openElements.items[i], elementId)) break;
    }
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).PLAINTEXT;
}
function $546dc23fbaaf59e4$var$buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.framesetOk = false;
}
function $546dc23fbaaf59e4$var$aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).A);
    if (activeElementEntry) {
        $546dc23fbaaf59e4$var$callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $546dc23fbaaf59e4$var$bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $546dc23fbaaf59e4$var$nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOBR)) {
        $546dc23fbaaf59e4$var$callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $546dc23fbaaf59e4$var$appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}
function $546dc23fbaaf59e4$var$tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== (0, $5deb0c47e1a27c89$export$a74d46c85337d29a).QUIRKS && p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
}
function $546dc23fbaaf59e4$var$areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$isHiddenInput(token) {
    const inputType = (0, $05436e75d13cd0ed$export$df33bba014b5841e)(token, (0, $5deb0c47e1a27c89$export$380b7bc9e6cb1918).TYPE);
    return inputType != null && inputType.toLowerCase() === $546dc23fbaaf59e4$var$HIDDEN_INPUT_TYPE;
}
function $546dc23fbaaf59e4$var$inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    if (!$546dc23fbaaf59e4$var$isHiddenInput(token)) p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$paramStartTagInBody(p, token) {
    p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$imageStartTagInBody(p, token) {
    token.tagName = (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).IMG;
    token.tagID = (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).IMG;
    $546dc23fbaaf59e4$var$areaStartTagInBody(p, token);
}
function $546dc23fbaaf59e4$var$textareaStartTagInBody(p, token) {
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.TEXT;
}
function $546dc23fbaaf59e4$var$xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._closePElement();
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $546dc23fbaaf59e4$var$iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RAWTEXT);
}
//NOTE: here we assume that we always act as a user agent with enabled plugins/frames, so we parse
//<noembed>/<noframes> as rawtext.
function $546dc23fbaaf59e4$var$rawTextStartTagInBody(p, token) {
    p._switchToTextParsing(token, (0, $2c4fc6157fdd925a$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $546dc23fbaaf59e4$var$selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = p.insertionMode === $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE || p.insertionMode === $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION || p.insertionMode === $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY || p.insertionMode === $546dc23fbaaf59e4$var$InsertionMode.IN_ROW || p.insertionMode === $546dc23fbaaf59e4$var$InsertionMode.IN_CELL ? $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT_IN_TABLE : $546dc23fbaaf59e4$var$InsertionMode.IN_SELECT;
}
function $546dc23fbaaf59e4$var$optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTags();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTagsWithExclusion((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RTC);
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $a7b4b99c1048c081$export$c583cc5a9d633feb(token);
    $a7b4b99c1048c081$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML);
    else p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML);
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $a7b4b99c1048c081$export$74ce06f755fb8f68(token);
    $a7b4b99c1048c081$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).SVG);
    else p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).SVG);
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
}
function $546dc23fbaaf59e4$var$startTagInBody(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).I:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).S:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).B:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).U:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).EM:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BIG:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CODE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SMALL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STRIKE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STRONG:
            $546dc23fbaaf59e4$var$bStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).A:
            $546dc23fbaaf59e4$var$aStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H1:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H2:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H3:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H4:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H5:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H6:
            $546dc23fbaaf59e4$var$numberedHeaderStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIV:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NAV:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MAIN:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MENU:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ASIDE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CENTER:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FIGURE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FOOTER:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEADER:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIALOG:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DETAILS:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ADDRESS:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ARTICLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SEARCH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SECTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SUMMARY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FIELDSET:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FIGCAPTION:
            $546dc23fbaaf59e4$var$addressStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DT:
            $546dc23fbaaf59e4$var$listItemStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).IMG:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).WBR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).AREA:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).EMBED:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).KEYGEN:
            $546dc23fbaaf59e4$var$areaStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HR:
            $546dc23fbaaf59e4$var$hrStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RB:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RTC:
            $546dc23fbaaf59e4$var$rbStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).RP:
            $546dc23fbaaf59e4$var$rtStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).PRE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LISTING:
            $546dc23fbaaf59e4$var$preStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).XMP:
            $546dc23fbaaf59e4$var$xmpStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SVG:
            $546dc23fbaaf59e4$var$svgStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$htmlStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LINK:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).META:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BGSOUND:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASEFONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
            $546dc23fbaaf59e4$var$bodyStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FORM:
            $546dc23fbaaf59e4$var$formStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOBR:
            $546dc23fbaaf59e4$var$nobrStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MATH:
            $546dc23fbaaf59e4$var$mathStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
            $546dc23fbaaf59e4$var$tableStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).INPUT:
            $546dc23fbaaf59e4$var$inputStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).PARAM:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TRACK:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SOURCE:
            $546dc23fbaaf59e4$var$paramStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).IMAGE:
            $546dc23fbaaf59e4$var$imageStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BUTTON:
            $546dc23fbaaf59e4$var$buttonStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).APPLET:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OBJECT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MARQUEE:
            $546dc23fbaaf59e4$var$appletStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).IFRAME:
            $546dc23fbaaf59e4$var$iframeStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT:
            $546dc23fbaaf59e4$var$selectStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP:
            $546dc23fbaaf59e4$var$optgroupStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOEMBED:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
            $546dc23fbaaf59e4$var$rawTextStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAMESET:
            $546dc23fbaaf59e4$var$framesetStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEXTAREA:
            $546dc23fbaaf59e4$var$textareaStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) $546dc23fbaaf59e4$var$rawTextStartTagInBody(p, token);
            else $546dc23fbaaf59e4$var$genericStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).PLAINTEXT:
            $546dc23fbaaf59e4$var$plaintextStartTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAME:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
            break;
        default:
            $546dc23fbaaf59e4$var$genericStartTagInBody(p, token);
    }
}
function $546dc23fbaaf59e4$var$bodyEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY;
        //NOTE: <body> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo) {
            const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
            if (bodyElement) p._setEndLocation(bodyElement, token);
        }
    }
}
function $546dc23fbaaf59e4$var$htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_BODY;
        $546dc23fbaaf59e4$var$endTagAfterBody(p, token);
    }
}
function $546dc23fbaaf59e4$var$addressEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $546dc23fbaaf59e4$var$formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const { formElement: formElement } = p;
    if (!inTemplate) p.formElement = null;
    if ((formElement || inTemplate) && p.openElements.hasInScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FORM)) {
        p.openElements.generateImpliedEndTags();
        if (inTemplate) p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FORM);
        else if (formElement) p.openElements.remove(formElement);
    }
}
function $546dc23fbaaf59e4$var$pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P)) p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).P, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P);
    p._closePElement();
}
function $546dc23fbaaf59e4$var$liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI);
        p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI);
    }
}
function $546dc23fbaaf59e4$var$ddEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $546dc23fbaaf59e4$var$numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}
function $546dc23fbaaf59e4$var$appletEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}
function $546dc23fbaaf59e4$var$brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).BR, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR);
    p.openElements.pop();
    p.framesetOk = false;
}
function $546dc23fbaaf59e4$var$genericEndTagInBody(p, token) {
    const tn = token.tagName;
    const tid = token.tagID;
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        const elementId = p.openElements.tagIDs[i];
        // Compare the tag name here, as the tag might not be a known tag with an ID.
        if (tid === elementId && (tid !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
            p.openElements.generateImpliedEndTagsWithExclusion(tid);
            if (p.openElements.stackTop >= i) p.openElements.shortenToLength(i);
            break;
        }
        if (p._isSpecialElement(element, elementId)) break;
    }
}
function $546dc23fbaaf59e4$var$endTagInBody(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).A:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).B:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).I:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).S:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).U:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).EM:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BIG:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CODE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOBR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SMALL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STRIKE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STRONG:
            $546dc23fbaaf59e4$var$callAdoptionAgency(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P:
            $546dc23fbaaf59e4$var$pEndTagInBody(p);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).UL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIR:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIV:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NAV:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).PRE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MAIN:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MENU:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ASIDE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BUTTON:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CENTER:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FIGURE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FOOTER:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HEADER:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DIALOG:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ADDRESS:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).ARTICLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DETAILS:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SEARCH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SECTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SUMMARY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LISTING:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FIELDSET:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FIGCAPTION:
            $546dc23fbaaf59e4$var$addressEndTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LI:
            $546dc23fbaaf59e4$var$liEndTagInBody(p);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).DT:
            $546dc23fbaaf59e4$var$ddEndTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H1:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H2:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H3:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H4:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H5:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).H6:
            $546dc23fbaaf59e4$var$numberedHeaderEndTagInBody(p);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR:
            $546dc23fbaaf59e4$var$brEndTagInBody(p);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
            $546dc23fbaaf59e4$var$bodyEndTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$htmlEndTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FORM:
            $546dc23fbaaf59e4$var$formEndTagInBody(p);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).APPLET:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OBJECT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).MARQUEE:
            $546dc23fbaaf59e4$var$appletEndTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
            break;
        default:
            $546dc23fbaaf59e4$var$genericEndTagInBody(p, token);
    }
}
function $546dc23fbaaf59e4$var$eofInBody(p, token) {
    if (p.tmplInsertionModeStack.length > 0) $546dc23fbaaf59e4$var$eofInTemplate(p, token);
    else $546dc23fbaaf59e4$var$stopParsing(p, token);
}
// The "text" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$endTagInText(p, token) {
    var _a;
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT) (_a = p.scriptHandler) === null || _a === void 0 || _a.call(p, p.openElements.current);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}
function $546dc23fbaaf59e4$var$eofInText(p, token) {
    p._err(token, (0, $0d242c12c37a5644$export$9e0efcb140234d2).eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p.onEof(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$characterInTable(p, token) {
    if (p.openElements.currentTagId !== undefined && $546dc23fbaaf59e4$var$TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
        p.pendingCharacterTokens.length = 0;
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_TEXT;
        switch(token.type){
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).CHARACTER:
                $546dc23fbaaf59e4$var$characterInTableText(p, token);
                break;
            case (0, $05436e75d13cd0ed$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                $546dc23fbaaf59e4$var$whitespaceCharacterInTableText(p, token);
                break;
        }
    } else $546dc23fbaaf59e4$var$tokenInTable(p, token);
}
function $546dc23fbaaf59e4$var$captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_CAPTION;
}
function $546dc23fbaaf59e4$var$colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP;
}
function $546dc23fbaaf59e4$var$colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).COLGROUP, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP;
    $546dc23fbaaf59e4$var$startTagInColumnGroup(p, token);
}
function $546dc23fbaaf59e4$var$tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
}
function $546dc23fbaaf59e4$var$tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).TBODY, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY);
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
    $546dc23fbaaf59e4$var$startTagInTableBody(p, token);
}
function $546dc23fbaaf59e4$var$tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE)) {
        p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE);
        p._resetInsertionMode();
        p._processStartTag(token);
    }
}
function $546dc23fbaaf59e4$var$inputStartTagInTable(p, token) {
    if ($546dc23fbaaf59e4$var$isHiddenInput(token)) p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
    else $546dc23fbaaf59e4$var$tokenInTable(p, token);
    token.ackSelfClosing = true;
}
function $546dc23fbaaf59e4$var$formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}
function $546dc23fbaaf59e4$var$startTagInTable(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            $546dc23fbaaf59e4$var$tdStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
            $546dc23fbaaf59e4$var$colStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FORM:
            $546dc23fbaaf59e4$var$formStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
            $546dc23fbaaf59e4$var$tableStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
            $546dc23fbaaf59e4$var$tbodyStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).INPUT:
            $546dc23fbaaf59e4$var$inputStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
            $546dc23fbaaf59e4$var$captionStartTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
            $546dc23fbaaf59e4$var$colgroupStartTagInTable(p, token);
            break;
        default:
            $546dc23fbaaf59e4$var$tokenInTable(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInTable(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE)) {
                p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE);
                p._resetInsertionMode();
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            break;
        default:
            $546dc23fbaaf59e4$var$tokenInTable(p, token);
    }
}
function $546dc23fbaaf59e4$var$tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    // Process token in `In Body` mode
    $546dc23fbaaf59e4$var$modeInBody(p, token);
    p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}
function $546dc23fbaaf59e4$var$characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}
function $546dc23fbaaf59e4$var$tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) for(; i < p.pendingCharacterTokens.length; i++)$546dc23fbaaf59e4$var$tokenInTable(p, p.pendingCharacterTokens[i]);
    else for(; i < p.pendingCharacterTokens.length; i++)p._insertCharacters(p.pendingCharacterTokens[i]);
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
const $546dc23fbaaf59e4$var$TABLE_VOID_ELEMENTS = new Set([
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD,
    (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR
]);
function $546dc23fbaaf59e4$var$startTagInCaption(p, token) {
    const tn = token.tagID;
    if ($546dc23fbaaf59e4$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
            $546dc23fbaaf59e4$var$startTagInTable(p, token);
        }
    } else $546dc23fbaaf59e4$var$startTagInBody(p, token);
}
function $546dc23fbaaf59e4$var$endTagInCaption(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
                if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE) $546dc23fbaaf59e4$var$endTagInTable(p, token);
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            break;
        default:
            $546dc23fbaaf59e4$var$endTagInBody(p, token);
    }
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
            p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        default:
            $546dc23fbaaf59e4$var$tokenInColumnGroup(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP) {
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
            break;
        default:
            $546dc23fbaaf59e4$var$tokenInColumnGroup(p, token);
    }
}
function $546dc23fbaaf59e4$var$tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP) {
        p.openElements.pop();
        p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
        p._processToken(token);
    }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInTableBody(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            p.openElements.clearBackToTableBodyContext();
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableBodyContext();
            p._insertFakeElement((0, $5deb0c47e1a27c89$export$7e674a85a2656dce).TR, (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR);
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
            $546dc23fbaaf59e4$var$startTagInRow(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
                $546dc23fbaaf59e4$var$startTagInTable(p, token);
            }
            break;
        default:
            $546dc23fbaaf59e4$var$startTagInTable(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInTableBody(p, token) {
    const tn = token.tagID;
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
                $546dc23fbaaf59e4$var$endTagInTable(p, token);
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            break;
        default:
            $546dc23fbaaf59e4$var$endTagInTable(p, token);
    }
}
// The "in row" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInRow(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableRowContext();
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_CELL;
            p.activeFormattingElements.insertMarker();
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
                $546dc23fbaaf59e4$var$startTagInTableBody(p, token);
            }
            break;
        default:
            $546dc23fbaaf59e4$var$startTagInTable(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInRow(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
                $546dc23fbaaf59e4$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(token.tagID) || p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
                $546dc23fbaaf59e4$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
            break;
        default:
            $546dc23fbaaf59e4$var$endTagInTable(p, token);
    }
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInCell(p, token) {
    const tn = token.tagID;
    if ($546dc23fbaaf59e4$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD) || p.openElements.hasInTableScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH)) {
            p._closeTableCell();
            $546dc23fbaaf59e4$var$startTagInRow(p, token);
        }
    } else $546dc23fbaaf59e4$var$startTagInBody(p, token);
}
function $546dc23fbaaf59e4$var$endTagInCell(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped(tn);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope(tn)) {
                p._closeTableCell();
                $546dc23fbaaf59e4$var$endTagInRow(p, token);
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            break;
        default:
            $546dc23fbaaf59e4$var$endTagInBody(p, token);
    }
}
// The "in select" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HR:
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).INPUT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).KEYGEN:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEXTAREA:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
                if (token.tagID !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT) p._processStartTag(token);
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $546dc23fbaaf59e4$var$endTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.stackTop > 0 && p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
            }
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
            $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
            break;
        default:
    }
}
// The "in select in table" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH) {
        p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT);
        p._resetInsertionMode();
        p._processStartTag(token);
    } else $546dc23fbaaf59e4$var$startTagInSelect(p, token);
}
function $546dc23fbaaf59e4$var$endTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TABLE || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD || tn === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SELECT);
            p._resetInsertionMode();
            p.onEndTag(token);
        }
    } else $546dc23fbaaf59e4$var$endTagInSelect(p, token);
}
// The "in template" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInTemplate(p, token) {
    switch(token.tagID){
        // First, handle tags that can start without a mode change
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BASEFONT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BGSOUND:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).LINK:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).META:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).SCRIPT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).STYLE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TITLE:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        // Re-process the token in the appropriate mode
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).CAPTION:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COLGROUP:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TBODY:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TFOOT:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).THEAD:
            p.tmplInsertionModeStack[0] = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE;
            $546dc23fbaaf59e4$var$startTagInTable(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).COL:
            p.tmplInsertionModeStack[0] = $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_COLUMN_GROUP;
            $546dc23fbaaf59e4$var$startTagInColumnGroup(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TR:
            p.tmplInsertionModeStack[0] = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_TABLE_BODY;
            $546dc23fbaaf59e4$var$startTagInTableBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TD:
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TH:
            p.tmplInsertionModeStack[0] = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_ROW;
            $546dc23fbaaf59e4$var$startTagInRow(p, token);
            break;
        default:
            p.tmplInsertionModeStack[0] = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
            p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
    }
}
function $546dc23fbaaf59e4$var$endTagInTemplate(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE) $546dc23fbaaf59e4$var$templateEndTagInHead(p, token);
}
function $546dc23fbaaf59e4$var$eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped((0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
        p.onEof(token);
    } else $546dc23fbaaf59e4$var$stopParsing(p, token);
}
// The "after body" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagAfterBody(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML) $546dc23fbaaf59e4$var$startTagInBody(p, token);
    else $546dc23fbaaf59e4$var$tokenAfterBody(p, token);
}
function $546dc23fbaaf59e4$var$endTagAfterBody(p, token) {
    var _a;
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML) {
        if (!p.fragmentContext) p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_BODY;
        //NOTE: <html> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML) {
            p._setEndLocation(p.openElements.items[0], token);
            // Update the body element, if it doesn't have an end tag
            const bodyElement = p.openElements.items[1];
            if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) p._setEndLocation(bodyElement, token);
        }
    } else $546dc23fbaaf59e4$var$tokenAfterBody(p, token);
}
function $546dc23fbaaf59e4$var$tokenAfterBody(p, token) {
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
    $546dc23fbaaf59e4$var$modeInBody(p, token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagInFrameset(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAME:
            p._appendElement(token, (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $546dc23fbaaf59e4$var$endTagInFrameset(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();
        if (!p.fragmentContext && p.openElements.currentTagId !== (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).FRAMESET) p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_FRAMESET;
    }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $546dc23fbaaf59e4$var$endTagAfterFrameset(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML) p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.AFTER_AFTER_FRAMESET;
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagAfterAfterBody(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML) $546dc23fbaaf59e4$var$startTagInBody(p, token);
    else $546dc23fbaaf59e4$var$tokenAfterAfterBody(p, token);
}
function $546dc23fbaaf59e4$var$tokenAfterAfterBody(p, token) {
    p.insertionMode = $546dc23fbaaf59e4$var$InsertionMode.IN_BODY;
    $546dc23fbaaf59e4$var$modeInBody(p, token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$startTagAfterAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).HTML:
            $546dc23fbaaf59e4$var$startTagInBody(p, token);
            break;
        case (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).NOFRAMES:
            $546dc23fbaaf59e4$var$startTagInHead(p, token);
            break;
        default:
    }
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function $546dc23fbaaf59e4$var$nullCharacterInForeignContent(p, token) {
    token.chars = $13b6aff9b77366c5$export$e8d20e7a50e6c279;
    p._insertCharacters(token);
}
function $546dc23fbaaf59e4$var$characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $546dc23fbaaf59e4$var$popUntilHtmlOrIntegrationPoint(p) {
    while(p.treeAdapter.getNamespaceURI(p.openElements.current) !== (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML && p.openElements.currentTagId !== undefined && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current))p.openElements.pop();
}
function $546dc23fbaaf59e4$var$startTagInForeignContent(p, token) {
    if ($a7b4b99c1048c081$export$3435eb4ab4d2ed2d(token)) {
        $546dc23fbaaf59e4$var$popUntilHtmlOrIntegrationPoint(p);
        p._startTagOutsideForeignContent(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);
        if (currentNs === (0, $5deb0c47e1a27c89$export$fb4028874a74450).MATHML) $a7b4b99c1048c081$export$c583cc5a9d633feb(token);
        else if (currentNs === (0, $5deb0c47e1a27c89$export$fb4028874a74450).SVG) {
            $a7b4b99c1048c081$export$95df78fe2e7f33e3(token);
            $a7b4b99c1048c081$export$74ce06f755fb8f68(token);
        }
        $a7b4b99c1048c081$export$a5192af02995cbdc(token);
        if (token.selfClosing) p._appendElement(token, currentNs);
        else p._insertElement(token, currentNs);
        token.ackSelfClosing = true;
    }
}
function $546dc23fbaaf59e4$var$endTagInForeignContent(p, token) {
    if (token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).P || token.tagID === (0, $5deb0c47e1a27c89$export$cb0999a53e0acaed).BR) {
        $546dc23fbaaf59e4$var$popUntilHtmlOrIntegrationPoint(p);
        p._endTagOutsideForeignContent(token);
        return;
    }
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        if (p.treeAdapter.getNamespaceURI(element) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML) {
            p._endTagOutsideForeignContent(token);
            break;
        }
        const tagName = p.treeAdapter.getTagName(element);
        if (tagName.toLowerCase() === token.tagName) {
            //NOTE: update the token tag name for `_setEndLocation`.
            token.tagName = tagName;
            p.openElements.shortenToLength(i);
            break;
        }
    }
}




var $aaf64e2e0aa049b5$exports = {};
// Make exports work in Node < 12
// eslint-disable-next-line no-undef, unicorn/prefer-module

$aaf64e2e0aa049b5$exports = (parcelRequire("bpIMV"));



// Sets
const $6c820babda949dde$var$VOID_ELEMENTS = new Set([
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).AREA,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).BASE,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).BASEFONT,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).BGSOUND,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).BR,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).COL,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).EMBED,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).FRAME,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).HR,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).IMG,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).INPUT,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).KEYGEN,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).LINK,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).META,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).PARAM,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).SOURCE,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).TRACK,
    (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).WBR
]);
function $6c820babda949dde$var$isVoidElement(node, options) {
    return options.treeAdapter.isElementNode(node) && options.treeAdapter.getNamespaceURI(node) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML && $6c820babda949dde$var$VOID_ELEMENTS.has(options.treeAdapter.getTagName(node));
}
const $6c820babda949dde$var$defaultOpts = {
    treeAdapter: (0, $96d1b2ecef66ec3e$export$7ddbba828dfa4796),
    scriptingEnabled: true
};
function $6c820babda949dde$export$dfdc1655ccc5b9cb(node, options) {
    const opts = {
        ...$6c820babda949dde$var$defaultOpts,
        ...options
    };
    if ($6c820babda949dde$var$isVoidElement(node, opts)) return '';
    return $6c820babda949dde$var$serializeChildNodes(node, opts);
}
function $6c820babda949dde$export$71e9c1f1ceb5a856(node, options) {
    const opts = {
        ...$6c820babda949dde$var$defaultOpts,
        ...options
    };
    return $6c820babda949dde$var$serializeNode(node, opts);
}
function $6c820babda949dde$var$serializeChildNodes(parentNode, options) {
    let html = '';
    // Get container of the child nodes
    const container = options.treeAdapter.isElementNode(parentNode) && options.treeAdapter.getTagName(parentNode) === (0, $5deb0c47e1a27c89$export$7e674a85a2656dce).TEMPLATE && options.treeAdapter.getNamespaceURI(parentNode) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML ? options.treeAdapter.getTemplateContent(parentNode) : parentNode;
    const childNodes = options.treeAdapter.getChildNodes(container);
    if (childNodes) for (const currentNode of childNodes)html += $6c820babda949dde$var$serializeNode(currentNode, options);
    return html;
}
function $6c820babda949dde$var$serializeNode(node, options) {
    if (options.treeAdapter.isElementNode(node)) return $6c820babda949dde$var$serializeElement(node, options);
    if (options.treeAdapter.isTextNode(node)) return $6c820babda949dde$var$serializeTextNode(node, options);
    if (options.treeAdapter.isCommentNode(node)) return $6c820babda949dde$var$serializeCommentNode(node, options);
    if (options.treeAdapter.isDocumentTypeNode(node)) return $6c820babda949dde$var$serializeDocumentTypeNode(node, options);
    // Return an empty string for unknown nodes
    return '';
}
function $6c820babda949dde$var$serializeElement(node, options) {
    const tn = options.treeAdapter.getTagName(node);
    return `<${tn}${$6c820babda949dde$var$serializeAttributes(node, options)}>${$6c820babda949dde$var$isVoidElement(node, options) ? '' : `${$6c820babda949dde$var$serializeChildNodes(node, options)}</${tn}>`}`;
}
function $6c820babda949dde$var$serializeAttributes(node, { treeAdapter: treeAdapter }) {
    let html = '';
    for (const attr of treeAdapter.getAttrList(node)){
        html += ' ';
        if (attr.namespace) switch(attr.namespace){
            case (0, $5deb0c47e1a27c89$export$fb4028874a74450).XML:
                html += `xml:${attr.name}`;
                break;
            case (0, $5deb0c47e1a27c89$export$fb4028874a74450).XMLNS:
                if (attr.name !== 'xmlns') html += 'xmlns:';
                html += attr.name;
                break;
            case (0, $5deb0c47e1a27c89$export$fb4028874a74450).XLINK:
                html += `xlink:${attr.name}`;
                break;
            default:
                html += `${attr.prefix}:${attr.name}`;
        }
        else html += attr.name;
        html += `="${(0, $aaf64e2e0aa049b5$exports.escapeAttribute)(attr.value)}"`;
    }
    return html;
}
function $6c820babda949dde$var$serializeTextNode(node, options) {
    const { treeAdapter: treeAdapter } = options;
    const content = treeAdapter.getTextNodeContent(node);
    const parent = treeAdapter.getParentNode(node);
    const parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
    return parentTn && treeAdapter.getNamespaceURI(parent) === (0, $5deb0c47e1a27c89$export$fb4028874a74450).HTML && (0, $5deb0c47e1a27c89$export$4ce4f8c09f921aed)(parentTn, options.scriptingEnabled) ? content : (0, $aaf64e2e0aa049b5$exports.escapeText)(content);
}
function $6c820babda949dde$var$serializeCommentNode(node, { treeAdapter: treeAdapter }) {
    return `<!--${treeAdapter.getCommentNodeContent(node)}-->`;
}
function $6c820babda949dde$var$serializeDocumentTypeNode(node, { treeAdapter: treeAdapter }) {
    return `<!DOCTYPE ${treeAdapter.getDocumentTypeNodeName(node)}>`;
}







function $c7e9358d089ba8ff$export$98e6a39c04603d36(html, options) {
    return (0, $546dc23fbaaf59e4$export$7acfa6ed01010e37).parse(html, options);
}
function $c7e9358d089ba8ff$export$e1152f5efcc82ad(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }
    const parser = (0, $546dc23fbaaf59e4$export$7acfa6ed01010e37).getFragmentParser(fragmentContext, options);
    parser.tokenizer.write(html, true);
    return parser.getFragment();
}



parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $acbd03306e728ee4$var$enquoteDoctypeId(id) {
    const quote = id.includes('"') ? "'" : '"';
    return quote + id + quote;
}
function $acbd03306e728ee4$export$28adbdf76da34d76(name, publicId, systemId) {
    let str = '!DOCTYPE ';
    if (name) str += name;
    if (publicId) str += ` PUBLIC ${$acbd03306e728ee4$var$enquoteDoctypeId(publicId)}`;
    else if (systemId) str += ' SYSTEM';
    if (systemId) str += ` ${$acbd03306e728ee4$var$enquoteDoctypeId(systemId)}`;
    return str;
}
const $acbd03306e728ee4$export$e00c9c6684b0ace = {
    // Re-exports from domhandler
    isCommentNode: (0, $3zekA.isComment),
    isElementNode: (0, $3zekA.isTag),
    isTextNode: (0, $3zekA.isText),
    //Node construction
    createDocument () {
        const node = new (0, $3zekA.Document)([]);
        node['x-mode'] = (0, $5deb0c47e1a27c89$exports).DOCUMENT_MODE.NO_QUIRKS;
        return node;
    },
    createDocumentFragment () {
        return new (0, $3zekA.Document)([]);
    },
    createElement (tagName, namespaceURI, attrs) {
        const attribs = Object.create(null);
        const attribsNamespace = Object.create(null);
        const attribsPrefix = Object.create(null);
        for(let i = 0; i < attrs.length; i++){
            const attrName = attrs[i].name;
            attribs[attrName] = attrs[i].value;
            attribsNamespace[attrName] = attrs[i].namespace;
            attribsPrefix[attrName] = attrs[i].prefix;
        }
        const node = new (0, $3zekA.Element)(tagName, attribs, []);
        node.namespace = namespaceURI;
        node['x-attribsNamespace'] = attribsNamespace;
        node['x-attribsPrefix'] = attribsPrefix;
        return node;
    },
    createCommentNode (data) {
        return new (0, $3zekA.Comment)(data);
    },
    createTextNode (value) {
        return new (0, $3zekA.Text)(value);
    },
    //Tree mutation
    appendChild (parentNode, newNode) {
        const prev = parentNode.children[parentNode.children.length - 1];
        if (prev) {
            prev.next = newNode;
            newNode.prev = prev;
        }
        parentNode.children.push(newNode);
        newNode.parent = parentNode;
    },
    insertBefore (parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.children.indexOf(referenceNode);
        const { prev: prev } = referenceNode;
        if (prev) {
            prev.next = newNode;
            newNode.prev = prev;
        }
        referenceNode.prev = newNode;
        newNode.next = referenceNode;
        parentNode.children.splice(insertionIdx, 0, newNode);
        newNode.parent = parentNode;
    },
    setTemplateContent (templateElement, contentElement) {
        $acbd03306e728ee4$export$e00c9c6684b0ace.appendChild(templateElement, contentElement);
    },
    getTemplateContent (templateElement) {
        return templateElement.children[0];
    },
    setDocumentType (document, name, publicId, systemId) {
        const data = $acbd03306e728ee4$export$28adbdf76da34d76(name, publicId, systemId);
        let doctypeNode = document.children.find((node)=>(0, $3zekA.isDirective)(node) && node.name === '!doctype');
        if (doctypeNode) doctypeNode.data = data !== null && data !== void 0 ? data : null;
        else {
            doctypeNode = new (0, $3zekA.ProcessingInstruction)('!doctype', data);
            $acbd03306e728ee4$export$e00c9c6684b0ace.appendChild(document, doctypeNode);
        }
        doctypeNode['x-name'] = name;
        doctypeNode['x-publicId'] = publicId;
        doctypeNode['x-systemId'] = systemId;
    },
    setDocumentMode (document, mode) {
        document['x-mode'] = mode;
    },
    getDocumentMode (document) {
        return document['x-mode'];
    },
    detachNode (node) {
        if (node.parent) {
            const idx = node.parent.children.indexOf(node);
            const { prev: prev, next: next } = node;
            node.prev = null;
            node.next = null;
            if (prev) prev.next = next;
            if (next) next.prev = prev;
            node.parent.children.splice(idx, 1);
            node.parent = null;
        }
    },
    insertText (parentNode, text) {
        const lastChild = parentNode.children[parentNode.children.length - 1];
        if (lastChild && (0, $3zekA.isText)(lastChild)) lastChild.data += text;
        else $acbd03306e728ee4$export$e00c9c6684b0ace.appendChild(parentNode, $acbd03306e728ee4$export$e00c9c6684b0ace.createTextNode(text));
    },
    insertTextBefore (parentNode, text, referenceNode) {
        const prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];
        if (prevNode && (0, $3zekA.isText)(prevNode)) prevNode.data += text;
        else $acbd03306e728ee4$export$e00c9c6684b0ace.insertBefore(parentNode, $acbd03306e728ee4$export$e00c9c6684b0ace.createTextNode(text), referenceNode);
    },
    adoptAttributes (recipient, attrs) {
        for(let i = 0; i < attrs.length; i++){
            const attrName = attrs[i].name;
            if (recipient.attribs[attrName] === undefined) {
                recipient.attribs[attrName] = attrs[i].value;
                recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
                recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
            }
        }
    },
    //Tree traversing
    getFirstChild (node) {
        return node.children[0];
    },
    getChildNodes (node) {
        return node.children;
    },
    getParentNode (node) {
        return node.parent;
    },
    getAttrList (element) {
        return element.attributes;
    },
    //Node data
    getTagName (element) {
        return element.name;
    },
    getNamespaceURI (element) {
        return element.namespace;
    },
    getTextNodeContent (textNode) {
        return textNode.data;
    },
    getCommentNodeContent (commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName (doctypeNode) {
        var _a;
        return (_a = doctypeNode['x-name']) !== null && _a !== void 0 ? _a : '';
    },
    getDocumentTypeNodePublicId (doctypeNode) {
        var _a;
        return (_a = doctypeNode['x-publicId']) !== null && _a !== void 0 ? _a : '';
    },
    getDocumentTypeNodeSystemId (doctypeNode) {
        var _a;
        return (_a = doctypeNode['x-systemId']) !== null && _a !== void 0 ? _a : '';
    },
    //Node types
    isDocumentTypeNode (node) {
        return (0, $3zekA.isDirective)(node) && node.name === '!doctype';
    },
    // Source code location
    setNodeSourceCodeLocation (node, location) {
        if (location) {
            node.startIndex = location.startOffset;
            node.endIndex = location.endOffset;
        }
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation (node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation (node, endLocation) {
        if (endLocation.endOffset != null) node.endIndex = endLocation.endOffset;
        node.sourceCodeLocation = {
            ...node.sourceCodeLocation,
            ...endLocation
        };
    }
};


function $272467dba44a5965$export$2f1ddab8b648d7f6(content, options, isDocument, context) {
    var _a;
    (_a = options.treeAdapter) !== null && _a !== void 0 ? _a : options.treeAdapter = (0, $acbd03306e728ee4$export$e00c9c6684b0ace);
    if (options.scriptingEnabled !== false) options.scriptingEnabled = true;
    return isDocument ? (0, $c7e9358d089ba8ff$export$98e6a39c04603d36)(content, options) : (0, $c7e9358d089ba8ff$export$e1152f5efcc82ad)(context, content, options);
}
const $272467dba44a5965$var$renderOpts = {
    treeAdapter: (0, $acbd03306e728ee4$export$e00c9c6684b0ace)
};
function $272467dba44a5965$export$af75b43ff4abe814(dom) {
    /*
     * `dom-serializer` passes over the special "root" node and renders the
     * node's children in its place. To mimic this behavior with `parse5`, an
     * equivalent operation must be applied to the input array.
     */ const nodes = 'length' in dom ? dom : [
        dom
    ];
    for(let index = 0; index < nodes.length; index += 1){
        const node = nodes[index];
        if ((0, $3zekA.isDocument)(node)) Array.prototype.splice.call(nodes, index, 1, ...node.children);
    }
    let result = '';
    for(let index = 0; index < nodes.length; index += 1){
        const node = nodes[index];
        result += (0, $6c820babda949dde$export$71e9c1f1ceb5a856)(node, $272467dba44a5965$var$renderOpts);
    }
    return result;
}



var $k4wK2 = parcelRequire("k4wK2");

var $hq9P0 = parcelRequire("hq9P0");
const $767ebae4ce83dbe3$var$parse = (0, $hrVkI.getParse)((content, options, isDocument, context)=>options._useHtmlParser2 ? (0, $hq9P0.parseDocument)(content, options) : (0, $272467dba44a5965$export$2f1ddab8b648d7f6)(content, options, isDocument, context));
const $767ebae4ce83dbe3$export$11e63f7b0f3d9900 = (0, $7cd6fa5314d5f81f$export$8b469b2b7efa8d79)($767ebae4ce83dbe3$var$parse, (dom, options)=>options._useHtmlParser2 ? (0, $k4wK2.default)(dom, options) : (0, $272467dba44a5965$export$af75b43ff4abe814)(dom));




async function $7e7eb8ac7d73945c$export$f0fa481bcd2e1512(file, log) {
    log(`Starting to deflate "${file.name}"`, 'info');
    const fileData = new Uint8Array(await file.arrayBuffer());
    const fileList = await $7e7eb8ac7d73945c$export$ad306f4bd4f412df(fileData);
    log(`Archive contains ${Object.entries(fileList).length} entries`, 'info');
    console.log(fileList);
    let needsIndexRebuild = false;
    let needsMetaRebuild = false;
    let jsonMeta = null;
    let jsonPageList = null;
    const nonFatalWarnings = [];
    const logNonFatal = (str)=>{
        nonFatalWarnings.push(str);
        log(str, 'warning');
    };
    await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
    if (fileList['images/'] || Object.keys(fileList).some((filePath)=>filePath.startsWith('images/'))) log(`Worksheet has images/ folder`, 'success');
    else logNonFatal(`Worksheet does not have images/ folder`);
    await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
    if (fileList['pages/'] || Object.keys(fileList).some((filePath)=>filePath.startsWith('pages/'))) log(`Worksheet has pages/ folder`, 'success');
    else {
        log(`Worksheet does not have pages/ folder`, 'error');
        throw new Error(`Fatal: Worksheet file does not have a pages/ folder`);
    }
    await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
    if (fileList['worksheet.json']) log(`Worksheet has a metadata file`, 'success');
    else {
        needsMetaRebuild = true;
        logNonFatal(`Worksheet does not have a metadata file - needs rebuilding`);
    }
    await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
    if (fileList['pages.json']) log(`Worksheet has a page index file`, 'success');
    else {
        needsIndexRebuild = true;
        logNonFatal(`Worksheet does not have a page index file - needs rebuilding`);
    }
    await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
    const pageIndexRaw = await $7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, 'pages.json');
    const allPageIds = [];
    if (pageIndexRaw) {
        const pageIndexString = (0, $6ZWSX.Buffer).from(pageIndexRaw).toString();
        let pageDataJson = null;
        try {
            pageDataJson = JSON.parse(pageIndexString);
            if (!pageDataJson || !Array.isArray(pageDataJson)) {
                pageDataJson = null;
                throw new Error(`Page index is null or not an array`);
            }
        } catch (err) {
            logNonFatal(`Page index is invalid, needs rebuilding: ${err}`);
            needsMetaRebuild = true;
        }
        if (pageDataJson) {
            log(`Page index is valid JSON. Cross-checking...`, 'success');
            jsonPageList = pageDataJson;
            const pageFiles = Object.keys(fileList).filter((fn)=>fn.startsWith('pages/') && fn.endsWith('.json'));
            if (pageDataJson.length == 0 && pageFiles.length == 0) {
                log(`Worksheet does not contain any pages, there is nothing to fix.`, 'error');
                throw new Error(`Worksheet does not contain any pages, there is nothing to fix.`);
            }
            // check if all pages in index exist in file list
            for (const pageId of pageDataJson)if (!pageFiles.includes(`pages/${pageId}.json`)) {
                logNonFatal(`Missing page: ${pageId}`);
                needsIndexRebuild = true;
            }
            await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
            log(`Done checking index against file list`, 'info');
            // check if all pages are visible
            for (const pageFile of pageFiles){
                const pageId = (pageFile.split('/').pop() || '').replace('.json', '');
                allPageIds.push(pageId);
                if (!pageDataJson.includes(pageId)) {
                    logNonFatal(`Found hidden or deleted page: ${pageId}`);
                    needsIndexRebuild = true;
                }
            }
            await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
            log(`Done checking file list against index`, 'info');
        }
    } else {
        needsIndexRebuild = true;
        needsMetaRebuild = true;
    }
    await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(100);
    const metaDataRaw = await $7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, 'worksheet.json');
    if (metaDataRaw) {
        const metaDataString = (0, $6ZWSX.Buffer).from(metaDataRaw).toString();
        try {
            const metaDataJson = JSON.parse(metaDataString);
            if (!metaDataJson || Object.entries(metaDataJson).length == 0) throw new Error(`Metadata is null or missing entries`);
            log(`Metadata is valid JSON`, 'success');
            jsonMeta = metaDataJson;
        } catch (err) {
            logNonFatal(`Metadata is invalid, needs rebuilding: ${err}`);
            needsMetaRebuild = true;
        }
    } else needsMetaRebuild = true;
    if (jsonMeta && jsonMeta.currentPageId) {
        if (!allPageIds.includes(jsonMeta.currentPageId)) {
            logNonFatal(`Current page index (${jsonMeta.currentPageId}) points to a missing page`);
            needsMetaRebuild = true;
            needsIndexRebuild = true;
        } else log(`Current page index is valid`, 'success');
    }
    const rawZipData = await new Promise((resolve, reject)=>{
        const zipArchiveParts = [];
        const zipOut = new $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f((err, data, final)=>{
            if (err) {
                reject(err);
                return;
            }
            zipArchiveParts.push(data);
            if (final) resolve($7e7eb8ac7d73945c$export$1af0c9ce8253b845(zipArchiveParts));
        });
        (async ()=>{
            /*
             * Add pages
             */ log(`Copying pages over...`, 'info');
            const pageFilesData = await $7e7eb8ac7d73945c$export$2080f84059ea7a12(fileData, (fn)=>fn.startsWith('pages/') && fn.endsWith('.json'));
            let pageIndexRaw = [];
            for (const [pagePath, pageDataRaw] of Object.entries(pageFilesData)){
                const pageId = (pagePath.split('/').pop() || '').replace('.json', '');
                const pageDataString = (0, $6ZWSX.Buffer).from(pageDataRaw).toString('utf8');
                let pageJsonOut = null;
                try {
                    const pageJson = JSON.parse(pageDataString);
                    if (!pageJson || typeof pageJson !== 'object' || !('content' in pageJson)) {
                        needsIndexRebuild = true;
                        throw new Error(`Page JSON is invalid`);
                    }
                    if (!pageJson.id || pageJson.id != pageId) {
                        logNonFatal(`Page ${pagePath} id mismatch (${pageJson.id}), fixing`);
                        needsIndexRebuild = true;
                        pageJson.id = pageId;
                    }
                    let pageNeedsRebuild = false;
                    let rawPageContent = pageJson.content || '';
                    if (rawPageContent) {
                        const $ = $767ebae4ce83dbe3$export$11e63f7b0f3d9900(`<div id="__root"></div>`);
                        const $page = $('<div/>').html(rawPageContent);
                        const NON_ALLOWED_SELECTOR = '[data-js="mathEditor"]';
                        const foundNonAllowed = $page.find(NON_ALLOWED_SELECTOR);
                        let changedDom = false;
                        if (foundNonAllowed.length > 0) {
                            logNonFatal(`Page ${pageId} contains non-allowed or non-saveable elements`);
                            foundNonAllowed.each((i, el)=>{
                                const $el = $(el);
                                log(`Removing ${el.tagName}[class="${$el.attr('class')}"][data-js="${$el.attr('data-js')}"][id="${$el.attr('id')}"]`, 'warning');
                                $el.remove();
                            });
                            changedDom = true;
                        }
                        if (changedDom) {
                            pageNeedsRebuild = true;
                            rawPageContent = $page.html();
                        }
                    }
                    if (pageNeedsRebuild) {
                        log(`Rebuilding page content...`, 'info');
                        pageJson.content = rawPageContent;
                    }
                    pageJsonOut = JSON.stringify(pageJson);
                } catch (err) {
                    needsIndexRebuild = true;
                    logNonFatal(`Page ${pagePath} is corrupted: ${err}`);
                    pageJsonOut = JSON.stringify({
                        id: pageId,
                        title: 'Corrupted page file',
                        content: ` `,
                        length: 1
                    });
                }
                if (pageJsonOut) {
                    pageIndexRaw.push(pageId);
                    $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zipOut, pagePath, $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(pageJsonOut));
                }
                await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(10);
            }
            /*
             * Add images
             */ log(`Copying images over...`, 'info');
            //const pageFilesData = await readFilesFromZip(fileData, fn => fn.startsWith('pages/') && fn.endsWith('.json'));
            const imageFiles = await $7e7eb8ac7d73945c$export$2080f84059ea7a12(fileData, (fn)=>fn.startsWith('images/'));
            let n = 0;
            for (const [imagePath, imageRaw] of Object.entries(imageFiles)){
                $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zipOut, imagePath, imageRaw, 0);
                await $7e7eb8ac7d73945c$export$cf8ca10959047ff4(2);
                n++;
            }
            log(`Added ${n} images`, 'info');
            if (needsMetaRebuild) {
                log(`Rebuilding metadata...`, 'info');
                $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zipOut, 'worksheet.json', $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(JSON.stringify({
                    title: "Korjattu ty\xf6kirja",
                    description: '',
                    author: 'LMAFix',
                    latestVersion: 'r1.10.0',
                    created: new Date().toISOString(),
                    theme: 'light',
                    bookmarks: []
                })));
            } else {
                log(`Copying metadata...`, 'info');
                const rawMeta = await $7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, 'worksheet.json') ?? $461bf5d8bd29e0d8$export$366b39a6daa8ed7a('{}');
                $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zipOut, 'worksheet.json', rawMeta);
            }
            if (needsIndexRebuild) {
                log(`Rebuilding page index...`, 'info');
                $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zipOut, 'pages.json', $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(JSON.stringify([
                    ...allPageIds
                ])));
            } else {
                log(`Copying page index...`, 'info');
                const rawPageList = await $7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, 'pages.json') ?? $461bf5d8bd29e0d8$export$366b39a6daa8ed7a('[]');
                $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zipOut, 'pages.json', rawPageList);
            }
        })().then(()=>{
            zipOut.end();
        }).catch((err)=>reject(err));
    });
    console.log(rawZipData);
    let result = 'success';
    if (nonFatalWarnings.length > 0) result = 'warning';
    return {
        result: result,
        warnings: nonFatalWarnings,
        meta: {
            fileList: fileList,
            pageList: jsonPageList,
            meta: jsonMeta,
            readFile: (path)=>$7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, path),
            readFileUnicode: async (path)=>(0, $6ZWSX.Buffer).from(await $7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, path) || '').toString('utf8')
        },
        zipData: rawZipData
    };
}
function $7e7eb8ac7d73945c$export$468d8bf94fe883f3(zip, fileName, contents, compressionLevel = 9) {
    const entry = new $461bf5d8bd29e0d8$export$f7e481ca646388b6(fileName, {
        level: compressionLevel
    });
    zip.add(entry);
    entry.push(contents, true);
}
function $7e7eb8ac7d73945c$export$cf8ca10959047ff4(delay) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), delay));
}
function $7e7eb8ac7d73945c$export$1af0c9ce8253b845(fileData) {
    const finalFileSize = fileData.map((b)=>b.length).reduce((p, c)=>p + c, 0);
    const finalData = new Uint8Array(finalFileSize);
    let offset = 0;
    for (const buf of fileData){
        for(let i = 0; i < buf.length; i++)finalData[offset + i] = buf[i];
        offset += buf.length;
    }
    return finalData;
}
function $7e7eb8ac7d73945c$export$2080f84059ea7a12(fileData, fileFilter) {
    return new Promise((resolve, reject)=>{
        const unzipper = new $461bf5d8bd29e0d8$export$9b7485f84cbaaa56();
        unzipper.register($461bf5d8bd29e0d8$export$eb188945cc39e642);
        const filePromises = [];
        unzipper.onfile = (file)=>{
            if (fileFilter(file.name)) {
                const fileData = [];
                filePromises.push(new Promise((resolveInner, rejectInner)=>{
                    file.ondata = (err, data, final)=>{
                        if (err) {
                            rejectInner(err);
                            return;
                        }
                        fileData.push(data);
                        if (final) resolveInner([
                            file.name,
                            $7e7eb8ac7d73945c$export$1af0c9ce8253b845(fileData)
                        ]);
                    };
                    file.start();
                }));
            }
        };
        unzipper.push(fileData, true);
        Promise.allSettled(filePromises).then((fulfilled)=>{
            resolve(Object.fromEntries(fulfilled.filter((pr)=>pr.status == 'fulfilled').map((pr)=>pr.value)));
        });
    });
}
function $7e7eb8ac7d73945c$export$469cc0457ed65bb0(fileData, fileToRead) {
    return new Promise((resolve, reject)=>{
        const unzipper = new $461bf5d8bd29e0d8$export$9b7485f84cbaaa56();
        unzipper.register($461bf5d8bd29e0d8$export$eb188945cc39e642);
        unzipper.onfile = (file)=>{
            if (file.name == fileToRead) {
                const fileData = [];
                file.ondata = (err, data, final)=>{
                    if (err) {
                        reject(err);
                        return;
                    }
                    fileData.push(data);
                    if (final) resolve($7e7eb8ac7d73945c$export$1af0c9ce8253b845(fileData));
                };
                file.start();
            }
        };
        unzipper.push(fileData, true);
        resolve(null);
    });
}
function $7e7eb8ac7d73945c$export$ad306f4bd4f412df(fileData) {
    return new Promise((resolve, reject)=>{
        const files = {};
        const unzipper = new $461bf5d8bd29e0d8$export$9b7485f84cbaaa56();
        unzipper.register($461bf5d8bd29e0d8$export$eb188945cc39e642);
        unzipper.onfile = (file)=>{
            files[file.name] = {
                name: file.name.split('/').pop() || '?',
                fullPath: file.name,
                size: file.size ?? 0
            };
        };
        unzipper.push(fileData, true);
        resolve(files);
    });
}


var $8f7780c5ce6349c5$exports = {};
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $8f7780c5ce6349c5$exports = factory();
})($8f7780c5ce6349c5$exports, function() {
    return function download(data, strFileName, strMimeType) {
        var self = window, defaultMime = "application/octet-stream", mimeType = strMimeType || defaultMime, payload = data, url = !strFileName && !strMimeType && payload, anchor = document.createElement("a"), toString = function(a) {
            return String(a);
        }, myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString, fileName = strFileName || "download", blob, reader;
        myBlob = myBlob.call ? myBlob.bind(self) : Blob;
        if (String(this) === "true") {
            payload = [
                payload,
                mimeType
            ];
            mimeType = payload[0];
            payload = payload[1];
        }
        if (url && url.length < 2048) {
            fileName = url.split("/").pop().split("?")[0];
            anchor.href = url; // assign href prop to temp anchor
            if (anchor.href.indexOf(url) !== -1) {
                var ajax = new XMLHttpRequest();
                ajax.open("GET", url, true);
                ajax.responseType = 'blob';
                ajax.onload = function(e) {
                    download(e.target.response, fileName, defaultMime);
                };
                setTimeout(function() {
                    ajax.send();
                }, 0); // allows setting custom ajax headers using the return:
                return ajax;
            } // end if valid url?
        } // end if url?
        //go ahead and download dataURLs right away
        if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
            if (payload.length > 2096103.424 && myBlob !== toString) {
                payload = dataUrlToBlob(payload);
                mimeType = payload.type || defaultMime;
            } else return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
        } else if (/([\x80-\xff])/.test(payload)) {
            var i = 0, tempUiArr = new Uint8Array(payload.length), mx = tempUiArr.length;
            for(i; i < mx; ++i)tempUiArr[i] = payload.charCodeAt(i);
            payload = new myBlob([
                tempUiArr
            ], {
                type: mimeType
            });
        }
        blob = payload instanceof myBlob ? payload : new myBlob([
            payload
        ], {
            type: mimeType
        });
        function dataUrlToBlob(strUrl) {
            var parts = strUrl.split(/[:;,]/), type = parts[1], decoder = parts[2] == "base64" ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx = binData.length, i = 0, uiArr = new Uint8Array(mx);
            for(i; i < mx; ++i)uiArr[i] = binData.charCodeAt(i);
            return new myBlob([
                uiArr
            ], {
                type: type
            });
        }
        function saver(url, winMode) {
            if ('download' in anchor) {
                anchor.href = url;
                anchor.setAttribute("download", fileName);
                anchor.className = "download-js-link";
                anchor.innerHTML = "downloading...";
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                setTimeout(function() {
                    anchor.click();
                    document.body.removeChild(anchor);
                    if (winMode === true) setTimeout(function() {
                        self.URL.revokeObjectURL(anchor.href);
                    }, 250);
                }, 66);
                return true;
            }
            // handle non-a[download] safari as best we can:
            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                if (!window.open(url)) {
                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) location.href = url;
                }
                return true;
            }
            //do iframe dataURL download (old ch+FF):
            var f = document.createElement("iframe");
            document.body.appendChild(f);
            if (!winMode && /^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
            f.src = url;
            setTimeout(function() {
                document.body.removeChild(f);
            }, 333);
        } //end saver
        if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, fileName);
        if (self.URL) saver(self.URL.createObjectURL(blob), true);
        else {
            // handle non-Blob()+non-URL browsers:
            if (typeof blob === "string" || blob.constructor === toString) try {
                return saver("data:" + mimeType + ";base64," + self.btoa(blob));
            } catch (y) {
                return saver("data:" + mimeType + "," + encodeURIComponent(blob));
            }
            // Blob but not URL support:
            reader = new FileReader();
            reader.onload = function(e) {
                saver(this.result);
            };
            reader.readAsDataURL(blob);
        }
        return true;
    }; /* end download() */ 
});



function $382be457760a56e2$export$2e7a2f02633d86ce(props) {
    let iconName = props.icon;
    if (!iconName.startsWith('ri-')) iconName = 'ri-' + iconName;
    const cl = [
        iconName,
        ...props.className ? props.className.split(' ') : []
    ];
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("i", {
        className: cl.join(' ')
    });
}


let $124101900752fc21$var$fixerRunning = false;
const $124101900752fc21$var$LOG_LINE_ICON = {
    'info': 'ri-info-i',
    'success': 'ri-check-line',
    'warning': 'ri-alert-line',
    'error': 'ri-alarm-warning-line'
};
function $124101900752fc21$export$75f3fb9e23ee237d(props) {
    const [meta, setMeta] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const [logLines, setLogLines] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [fixerError, setFixerError] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const [fixerResult, setFixerResult] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (!props.file) return;
        if ($124101900752fc21$var$fixerRunning) return;
        $124101900752fc21$var$fixerRunning = true;
        (0, $7e7eb8ac7d73945c$export$f0fa481bcd2e1512)(props.file, (data, level)=>{
            setLogLines((l)=>[
                    [
                        level,
                        data
                    ],
                    ...l
                ]);
            console.log(`[${level}] ${data}`);
        }).then((res)=>{
            setFixerResult(res);
            console.log(`fixer done`);
        }).catch((err)=>{
            console.error(`fixer failed:`);
            console.error(err);
            setFixerError(`${err}`);
            setFixerResult(null);
        }).finally(()=>{
            $124101900752fc21$var$fixerRunning = false;
        });
    }, [
        props.file
    ]);
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fixer"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        style: {
            margin: '0 0 16px 0'
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-file-2-line"
    }), ' ', props.file.name, !fixerResult && !fixerError && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
        className: "spinner",
        style: {
            marginLeft: '24px'
        }
    })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        id: "log"
    }, logLines.map(([level, logLine], i)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "line",
            "data-level": level
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
            icon: $124101900752fc21$var$LOG_LINE_ICON[level]
        }), " ", logLine))), fixerError && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
        className: "color-error"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-alarm-warning-line"
    }), " Fatal errors occurred. Either the file is not an actual L'Math file, or it cannot be fixed.")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "error-alert"
    }, fixerError)), fixerResult && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "The tool has finished."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, fixerResult.result == 'success' && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
        className: "color-success"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-check-line"
    }), " File was re-built successfully."), fixerResult.result == 'warning' && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
        className: "color-warning"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-alert-line"
    }), " Some issues found. Fixed file is available."), fixerResult.result == 'error' && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
        className: "color-error"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-alarm-warning-line"
    }), " Fatal errors occurred. The file cannot be fixed.")), fixerResult.warnings && fixerResult.warnings.length > 0 && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("details", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("summary", null, "Click to view warnings"), fixerResult.warnings.map((w, i)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
            className: "color-error",
            key: i
        }, w)))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("hr", null), fixerResult.zipData && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Download your fixed file here: "), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("button", {
        className: "btn",
        onClick: (e)=>{
            e.preventDefault();
            if (fixerResult.zipData) (0, (/*@__PURE__*/$parcel$interopDefault($8f7780c5ce6349c5$exports)))(fixerResult.zipData, `${(props.file.name || 'worksheet').replace('.lma', '')}_fix_${Date.now()}.lma`, 'application/zip');
            else alert(`Nothing to download! :(`);
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-save-3-fill"
    }), " Save fixed file"), ' ', /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("button", {
        className: "btn secondary",
        onClick: (e)=>{
            e.preventDefault();
            props.reset();
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-arrow-go-back-fill"
    }), " Fix another"))));
}



function $b0704e477bfe3e7c$export$86fbec116b87613f() {
    const [file, setFile] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const [fixerKey, setFixerKey] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("main", {
        className: "main"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("header", {
        className: "info"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h1", null, "\uD83D\uDCC1 lmafix"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "This tool will attempt to fix a broken ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "https://lehtodigital.fi/lmath/"
    }, "L'Math .lma file"), " for you. Disclaimer: It does not always succeed. If you have an important file and the tool does not work, please ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "https://lehtodigital.fi/lmath/contact/"
    }, "contact me"), ".")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fixer-wrapper"
    }, file ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $124101900752fc21$export$75f3fb9e23ee237d), {
        key: fixerKey,
        file: file,
        reset: ()=>{
            setFile(null);
            setFixerKey((k)=>k + 1);
        }
    }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fix-file-drop",
        onDragOver: (e)=>e.preventDefault(),
        onDragLeave: (e)=>e.preventDefault(),
        onDrop: (e)=>{
            e.preventDefault();
            if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                console.log(e.dataTransfer.files);
                setFile(e.dataTransfer.files[0]);
            }
        },
        onClick: (e)=>{
            e.preventDefault();
            const inp = document.createElement('input');
            inp.type = 'file';
            inp.accept = '.lma';
            inp.addEventListener('change', (e)=>{
                if (inp.files && inp.files.length > 0) setFile(inp.files[0]);
            });
            inp.style.display = 'none';
            document.body.appendChild(inp);
            inp.click();
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $382be457760a56e2$export$2e7a2f02633d86ce), {
        icon: "ri-download-2-fill"
    })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Drop a file or Click to choose..."))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("footer", {
        className: "footer"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, "\xa9 Roni Lehto 2026 \xb7 ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "https://lehtodigital.fi/lmath/"
    }, "L'Math"), " \xb7 ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "https://github.com/lehtoroni/lmafix",
        target: "_blank"
    }, "Source on Github")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, "This tool works in your browser. No data will be sent to the server.")));
}


const $38d6cc12cd11cfd3$var$base = document.querySelector('#base');
if (!$38d6cc12cd11cfd3$var$base) throw new Error(`No base?!`);
(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $b0704e477bfe3e7c$export$86fbec116b87613f), null), $38d6cc12cd11cfd3$var$base);


//# sourceMappingURL=korjaa.lehtodigital.fi.21153528.js.map
